window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    'shopify:section:load',
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    'shopify:section:unload',
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    'shopify:section:select',
    this._onSelect.bind(this)
  );
  document.addEventListener(
    'shopify:section:deselect',
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    'shopify:block:select',
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    'shopify:block:deselect',
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var id = container.getAttribute('data-section-id');
    var type = container.getAttribute('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = this.instances.filter(function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === 'function') {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onSelect === 'function'
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onDeselect === 'function'
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onBlockSelect === 'function'
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onBlockDeselect === 'function'
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function(container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  resizeSelects: function(selects) {
    selects.forEach(function(select) {
      var arrowWidth = 55;

      var test = document.createElement('span');
      test.innerHTML = select.selectedOptions[0].label;

      document.querySelector('.site-footer').appendChild(test);

      var width = test.offsetWidth + arrowWidth;
      test.remove();

      select.style.width = width + 'px';
    });
  },

  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFTARROW: 37,
    RIGHTARROW: 39
  }
};

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {NodeList} options.tables - Elements of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.tables.forEach(function(table) {
      var wrapper = document.createElement('div');
      wrapper.classList.add(options.tableWrapperClass);

      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {NodeList} options.iframes - Elements of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.iframes.forEach(function(iframe) {
      var wrapper = document.createElement('div');
      wrapper.classList.add(options.iframeWrapperClass);

      iframe.parentNode.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);

      iframe.src = iframe.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  state: {
    firstFocusable: null,
    lastFocusable: null
  },
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects
   *
   * @param {HTMLElement} element - The element to be acted upon
   */
  pageLinkFocus: function(element) {
    if (!element) return;
    var focusClass = 'js-focus-hidden';

    element.setAttribute('tabIndex', '-1');
    element.focus();
    element.classList.add(focusClass);
    element.addEventListener('blur', callback, { once: true });

    function callback() {
      element.classList.remove(focusClass);
      element.removeAttribute('tabindex');
    }
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {HTMLElement} options.container - Container to trap focus within
   * @param {HTMLElement} options.elementToFocus - Element to be focused when focus leaves container
   */
  trapFocus: function(options) {
    var focusableElements = Array.from(
      options.container.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      )
    ).filter(function(element) {
      var width = element.offsetWidth;
      var height = element.offsetHeight;

      return (
        width !== 0 &&
        height !== 0 &&
        getComputedStyle(element).getPropertyValue('display') !== 'none'
      );
    });

    this.state.firstFocusable = focusableElements[0];
    this.state.lastFocusable = focusableElements[focusableElements.length - 1];

    if (!options.elementToFocus) {
      options.elementToFocus = options.container;
    }

    options.container.setAttribute('tabindex', '-1');
    options.elementToFocus.focus();

    this._setupHandlers();

    document.addEventListener('focusin', this._onFocusInHandler);
    document.addEventListener('focusout', this._onFocusOutHandler);
  },

  _setupHandlers: function() {
    if (!this._onFocusInHandler) {
      this._onFocusInHandler = this._onFocusIn.bind(this);
    }

    if (!this._onFocusOutHandler) {
      this._onFocusOutHandler = this._onFocusIn.bind(this);
    }

    if (!this._manageFocusHandler) {
      this._manageFocusHandler = this._manageFocus.bind(this);
    }
  },

  _onFocusOut: function() {
    document.removeEventListener('keydown', this._manageFocusHandler);
  },

  _onFocusIn: function(evt) {
    if (
      evt.target !== this.state.lastFocusable &&
      evt.target !== this.state.firstFocusable
    )
      return;

    document.addEventListener('keydown', this._manageFocusHandler);
  },

  _manageFocus: function(evt) {
    if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

    /**
     * On the last focusable element and tab forward,
     * focus the first element.
     */
    if (evt.target === this.state.lastFocusable && !evt.shiftKey) {
      evt.preventDefault();
      this.state.firstFocusable.focus();
    }
    /**
     * On the first focusable element and tab backward,
     * focus the last element.
     */
    if (evt.target === this.state.firstFocusable && evt.shiftKey) {
      evt.preventDefault();
      this.state.lastFocusable.focus();
    }
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {HTMLElement} options.container - Container to trap focus within
   */
  removeTrapFocus: function(options) {
    if (options.container) {
      options.container.removeAttribute('tabindex');
    }
    document.removeEventListener('focusin', this._onFocusInHandler);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {HTMLElement} options.links - Specific links to be targeted
   */
  accessibleLinks: function(options) {
    var body = document.querySelector('body');

    var idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message'
    };

    if (options.links === undefined || !options.links.length) {
      options.links = document.querySelectorAll(
        'a[href]:not([aria-describedby])'
      );
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {};
      }

      var messages = Object.assign(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.'
        },
        customMessages
      );

      var container = document.createElement('ul');
      var htmlMessages = '';

      for (var message in messages) {
        htmlMessages +=
          '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
      }

      container.setAttribute('hidden', true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite(link) {
      var hostname = window.location.hostname;

      return link.hostname !== hostname;
    }

    options.links.forEach(function(link) {
      var target = link.getAttribute('target');
      var rel = link.getAttribute('rel');
      var isExternal = _externalSite(link);
      var isTargetBlank = target === '_blank';

      if (isExternal) {
        link.setAttribute('aria-describedby', idSelectors.external);
      }

      if (isTargetBlank) {
        if (!rel || rel.indexOf('noopener') === -1) {
          var relValue = rel === undefined ? '' : rel + ' ';
          relValue = relValue + 'noopener';
          link.setAttribute('rel', relValue);
        }

        link.setAttribute('aria-describedby', idSelectors.newWindow);
      }

      if (isExternal && isTargetBlank) {
        link.setAttribute('aria-describedby', idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.container = options.container;
    this.product = options.product;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.singleOptions = this.container.querySelectorAll(
      options.singleOptionSelector
    );
    this.currentVariant = this._getVariantFromOptions();

    this.singleOptions.forEach(
      function(option) {
        option.addEventListener('change', this._onSelectChange.bind(this));
      }.bind(this)
    );
  }

  Variants.prototype = Object.assign({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var result = [];

      this.singleOptions.forEach(function(option) {
        var type = option.getAttribute('type');
        var isRadioOrCheckbox = type === 'radio' || type === 'checkbox';

        if (!isRadioOrCheckbox || option.checked) {
          result.push({
            value: option.value,
            index: option.getAttribute('data-index')
          });
        }
      });

      return result;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = variants.find(function(variant) {
        return selectedValues.every(function(values) {
          return variant[values.index] === values.value;
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.container.dispatchEvent(
        new CustomEvent('variantChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        })
      );

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantImageChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        })
      );
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price &&
        variant.unit_price === this.currentVariant.unit_price
      ) {
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantPriceChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        })
      );
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        })
      );
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      var masterSelect = this.container.querySelector(this.originalSelectorId);

      if (!masterSelect) return;
      masterSelect.value = variant.id;
    }
  });

  return Variants;
})();

this.Shopify = this.Shopify || {};
this.Shopify.theme = this.Shopify.theme || {};
this.Shopify.theme.PredictiveSearch = (function() {
  'use strict';

  function validateQuery(query) {
    var error;

    if (query === null || query === undefined) {
      error = new TypeError("'query' is missing");
      error.type = 'argument';
      throw error;
    }

    if (typeof query !== 'string') {
      error = new TypeError("'query' is not a string");
      error.type = 'argument';
      throw error;
    }
  }

  function GenericError() {
    var error = Error.call(this);

    error.name = 'Server error';
    error.message = 'Something went wrong on the server';
    error.status = 500;

    return error;
  }

  function NotFoundError(status) {
    var error = Error.call(this);

    error.name = 'Not found';
    error.message = 'Not found';
    error.status = status;

    return error;
  }

  function ServerError() {
    var error = Error.call(this);

    error.name = 'Server error';
    error.message = 'Something went wrong on the server';
    error.status = 500;

    return error;
  }

  function ContentTypeError(status) {
    var error = Error.call(this);

    error.name = 'Content-Type error';
    error.message = 'Content-Type was not provided or is of wrong type';
    error.status = status;

    return error;
  }

  function JsonParseError(status) {
    var error = Error.call(this);

    error.name = 'JSON parse error';
    error.message = 'JSON syntax error';
    error.status = status;

    return error;
  }

  function ThrottledError(status, name, message, retryAfter) {
    var error = Error.call(this);

    error.name = name;
    error.message = message;
    error.status = status;
    error.retryAfter = retryAfter;

    return error;
  }

  function InvalidParameterError(status, name, message) {
    var error = Error.call(this);

    error.name = name;
    error.message = message;
    error.status = status;

    return error;
  }

  function ExpectationFailedError(status, name, message) {
    var error = Error.call(this);

    error.name = name;
    error.message = message;
    error.status = status;

    return error;
  }

  function request(searchUrl, queryParams, query, onSuccess, onError) {
    var xhr = new XMLHttpRequest();
    var route = searchUrl + '/suggest.json';

    xhr.onreadystatechange = function() {
      if (xhr.readyState !== XMLHttpRequest.DONE) {
        return;
      }

      var contentType = xhr.getResponseHeader('Content-Type');

      if (xhr.status >= 500) {
        onError(new ServerError());

        return;
      }

      if (xhr.status === 404) {
        onError(new NotFoundError(xhr.status));

        return;
      }

      if (
        typeof contentType !== 'string' ||
        contentType.toLowerCase().match('application/json') === null
      ) {
        onError(new ContentTypeError(xhr.status));

        return;
      }

      if (xhr.status === 417) {
        try {
          var invalidParameterJson = JSON.parse(xhr.responseText);

          onError(
            new InvalidParameterError(
              xhr.status,
              invalidParameterJson.message,
              invalidParameterJson.description
            )
          );
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      if (xhr.status === 422) {
        try {
          var expectationFailedJson = JSON.parse(xhr.responseText);

          onError(
            new ExpectationFailedError(
              xhr.status,
              expectationFailedJson.message,
              expectationFailedJson.description
            )
          );
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      if (xhr.status === 429) {
        try {
          var throttledJson = JSON.parse(xhr.responseText);

          onError(
            new ThrottledError(
              xhr.status,
              throttledJson.message,
              throttledJson.description,
              xhr.getResponseHeader('Retry-After')
            )
          );
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      if (xhr.status === 200) {
        try {
          var res = JSON.parse(xhr.responseText);
          res.query = query;
          onSuccess(res);
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      try {
        var genericErrorJson = JSON.parse(xhr.responseText);
        onError(
          new GenericError(
            xhr.status,
            genericErrorJson.message,
            genericErrorJson.description
          )
        );
      } catch (error) {
        onError(new JsonParseError(xhr.status));
      }

      return;
    };

    xhr.open(
      'get',
      route + '?q=' + encodeURIComponent(query) + '&' + queryParams
    );

    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.send();
  }

  function Cache(config) {
    this._store = {};
    this._keys = [];
    if (config && config.bucketSize) {
      this.bucketSize = config.bucketSize;
    } else {
      this.bucketSize = 20;
    }
  }

  Cache.prototype.set = function(key, value) {
    if (this.count() >= this.bucketSize) {
      var deleteKey = this._keys.splice(0, 1);
      this.delete(deleteKey);
    }

    this._keys.push(key);
    this._store[key] = value;

    return this._store;
  };

  Cache.prototype.get = function(key) {
    return this._store[key];
  };

  Cache.prototype.has = function(key) {
    return Boolean(this._store[key]);
  };

  Cache.prototype.count = function() {
    return Object.keys(this._store).length;
  };

  Cache.prototype.delete = function(key) {
    var exists = Boolean(this._store[key]);
    delete this._store[key];
    return exists && !this._store[key];
  };

  function Dispatcher() {
    this.events = {};
  }

  Dispatcher.prototype.on = function(eventName, callback) {
    var event = this.events[eventName];
    if (!event) {
      event = new DispatcherEvent(eventName);
      this.events[eventName] = event;
    }
    event.registerCallback(callback);
  };

  Dispatcher.prototype.off = function(eventName, callback) {
    var event = this.events[eventName];
    if (event && event.callbacks.indexOf(callback) > -1) {
      event.unregisterCallback(callback);
      if (event.callbacks.length === 0) {
        delete this.events[eventName];
      }
    }
  };

  Dispatcher.prototype.dispatch = function(eventName, payload) {
    var event = this.events[eventName];
    if (event) {
      event.fire(payload);
    }
  };

  function DispatcherEvent(eventName) {
    this.eventName = eventName;
    this.callbacks = [];
  }

  DispatcherEvent.prototype.registerCallback = function(callback) {
    this.callbacks.push(callback);
  };

  DispatcherEvent.prototype.unregisterCallback = function(callback) {
    var index = this.callbacks.indexOf(callback);
    if (index > -1) {
      this.callbacks.splice(index, 1);
    }
  };

  DispatcherEvent.prototype.fire = function(payload) {
    var callbacks = this.callbacks.slice(0);
    callbacks.forEach(function(callback) {
      callback(payload);
    });
  };

  function debounce(func, wait) {
    var timeout = null;
    return function() {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        timeout = null;
        func.apply(context, args);
      }, wait || 0);
    };
  }

  function objectToQueryParams(obj, parentKey) {
    var output = '';
    parentKey = parentKey || null;

    Object.keys(obj).forEach(function(key) {
      var outputKey = key + '=';
      if (parentKey) {
        outputKey = parentKey + '[' + key + ']';
      }

      switch (trueTypeOf(obj[key])) {
        case 'object':
          output += objectToQueryParams(obj[key], parentKey ? outputKey : key);
          break;
        case 'array':
          output += outputKey + '=' + obj[key].join(',') + '&';
          break;
        default:
          if (parentKey) {
            outputKey += '=';
          }
          output += outputKey + encodeURIComponent(obj[key]) + '&';
          break;
      }
    });

    return output;
  }

  function trueTypeOf(obj) {
    return Object.prototype.toString
      .call(obj)
      .slice(8, -1)
      .toLowerCase();
  }

  var DEBOUNCE_RATE = 10;
  var requestDebounced = debounce(request, DEBOUNCE_RATE);

  function PredictiveSearch(params, searchUrl) {
    if (!params) {
      throw new TypeError('No params object was specified');
    }

    this.searchUrl = searchUrl;

    this._retryAfter = null;
    this._currentQuery = null;

    this.dispatcher = new Dispatcher();
    this.cache = new Cache({ bucketSize: 40 });

    this.queryParams = objectToQueryParams(params);
  }

  PredictiveSearch.TYPES = {
    PRODUCT: 'product',
    PAGE: 'page',
    ARTICLE: 'article'
  };

  PredictiveSearch.FIELDS = {
    AUTHOR: 'author',
    BODY: 'body',
    PRODUCT_TYPE: 'product_type',
    TAG: 'tag',
    TITLE: 'title',
    VARIANTS_BARCODE: 'variants.barcode',
    VARIANTS_SKU: 'variants.sku',
    VARIANTS_TITLE: 'variants.title',
    VENDOR: 'vendor'
  };

  PredictiveSearch.UNAVAILABLE_PRODUCTS = {
    SHOW: 'show',
    HIDE: 'hide',
    LAST: 'last'
  };

  PredictiveSearch.prototype.query = function query(query) {
    try {
      validateQuery(query);
    } catch (error) {
      this.dispatcher.dispatch('error', error);
      return;
    }

    if (query === '') {
      return this;
    }

    this._currentQuery = normalizeQuery(query);
    var cacheResult = this.cache.get(this._currentQuery);
    if (cacheResult) {
      this.dispatcher.dispatch('success', cacheResult);
      return this;
    }

    requestDebounced(
      this.searchUrl,
      this.queryParams,
      query,
      function(result) {
        this.cache.set(normalizeQuery(result.query), result);
        if (normalizeQuery(result.query) === this._currentQuery) {
          this._retryAfter = null;
          this.dispatcher.dispatch('success', result);
        }
      }.bind(this),
      function(error) {
        if (error.retryAfter) {
          this._retryAfter = error.retryAfter;
        }
        this.dispatcher.dispatch('error', error);
      }.bind(this)
    );

    return this;
  };

  PredictiveSearch.prototype.on = function on(eventName, callback) {
    this.dispatcher.on(eventName, callback);

    return this;
  };

  PredictiveSearch.prototype.off = function on(eventName, callback) {
    this.dispatcher.off(eventName, callback);

    return this;
  };

  function normalizeQuery(query) {
    if (typeof query !== 'string') {
      return null;
    }

    return query
      .trim()
      .replace(' ', '-')
      .toLowerCase();
  }

  return PredictiveSearch;
})();

this.Shopify = this.Shopify || {};
this.Shopify.theme = this.Shopify.theme || {};
this.Shopify.theme.PredictiveSearchComponent = (function(PredictiveSearch) {
  'use strict';

  PredictiveSearch =
    PredictiveSearch && PredictiveSearch.hasOwnProperty('default')
      ? PredictiveSearch['default']
      : PredictiveSearch;

  var DEFAULT_PREDICTIVE_SEARCH_API_CONFIG = {
    resources: {
      type: [PredictiveSearch.TYPES.PRODUCT],
      options: {
        unavailable_products: PredictiveSearch.UNAVAILABLE_PRODUCTS.LAST,
        fields: [
          PredictiveSearch.FIELDS.TITLE,
          PredictiveSearch.FIELDS.VENDOR,
          PredictiveSearch.FIELDS.PRODUCT_TYPE,
          PredictiveSearch.FIELDS.VARIANTS_TITLE
        ]
      }
    }
  };

  function PredictiveSearchComponent(config) {
    // validate config
    if (
      !config ||
      !config.selectors ||
      !config.selectors.input ||
      !isString(config.selectors.input) ||
      !config.selectors.result ||
      !isString(config.selectors.result) ||
      !config.resultTemplateFct ||
      !isFunction(config.resultTemplateFct) ||
      !config.numberOfResultsTemplateFct ||
      !isFunction(config.numberOfResultsTemplateFct) ||
      !config.loadingResultsMessageTemplateFct ||
      !isFunction(config.loadingResultsMessageTemplateFct)
    ) {
      var error = new TypeError(
        'PredictiveSearchComponent config is not valid'
      );
      error.type = 'argument';
      throw error;
    }

    // Find nodes
    this.nodes = findNodes(config.selectors);

    // Validate nodes
    if (!isValidNodes(this.nodes)) {
      // eslint-disable-next-line no-console
      console.warn('Could not find valid nodes');
      return;
    }

    this.searchUrl = config.searchUrl || '/search';

    // Store the keyword that was used for the search
    this._searchKeyword = '';

    // Assign result template
    this.resultTemplateFct = config.resultTemplateFct;

    // Assign number of results template
    this.numberOfResultsTemplateFct = config.numberOfResultsTemplateFct;

    // Assign loading state template function
    this.loadingResultsMessageTemplateFct =
      config.loadingResultsMessageTemplateFct;

    // Assign number of search results
    this.numberOfResults = config.numberOfResults || 4;

    // Set classes
    this.classes = {
      visibleVariant: config.visibleVariant
        ? config.visibleVariant
        : 'predictive-search-wrapper--visible',
      itemSelected: config.itemSelectedClass
        ? config.itemSelectedClass
        : 'predictive-search-item--selected',
      clearButtonVisible: config.clearButtonVisibleClass
        ? config.clearButtonVisibleClass
        : 'predictive-search__clear-button--visible'
    };

    this.selectors = {
      searchResult: config.searchResult
        ? config.searchResult
        : '[data-search-result]'
    };

    // Assign callbacks
    this.callbacks = assignCallbacks(config);

    // Add input attributes
    addInputAttributes(this.nodes.input);

    // Add input event listeners
    this._addInputEventListeners();

    // Add body listener
    this._addBodyEventListener();

    // Add accessibility announcer
    this._addAccessibilityAnnouncer();

    // Display the reset button if the input is not empty
    this._toggleClearButtonVisibility();

    // Instantiate Predictive Search API
    this.predictiveSearch = new PredictiveSearch(
      config.PredictiveSearchAPIConfig
        ? config.PredictiveSearchAPIConfig
        : DEFAULT_PREDICTIVE_SEARCH_API_CONFIG,
      this.searchUrl
    );

    // Add predictive search success event listener
    this.predictiveSearch.on(
      'success',
      this._handlePredictiveSearchSuccess.bind(this)
    );

    // Add predictive search error event listener
    this.predictiveSearch.on(
      'error',
      this._handlePredictiveSearchError.bind(this)
    );
  }

  /**
   * Private methods
   */
  function findNodes(selectors) {
    return {
      input: document.querySelector(selectors.input),
      reset: document.querySelector(selectors.reset),
      result: document.querySelector(selectors.result)
    };
  }

  function isValidNodes(nodes) {
    if (
      !nodes ||
      !nodes.input ||
      !nodes.result ||
      nodes.input.tagName !== 'INPUT'
    ) {
      return false;
    }

    return true;
  }

  function assignCallbacks(config) {
    return {
      onBodyMousedown: config.onBodyMousedown,
      onBeforeOpen: config.onBeforeOpen,
      onOpen: config.onOpen,
      onBeforeClose: config.onBeforeClose,
      onClose: config.onClose,
      onInputFocus: config.onInputFocus,
      onInputKeyup: config.onInputKeyup,
      onInputBlur: config.onInputBlur,
      onInputReset: config.onInputReset,
      onBeforeDestroy: config.onBeforeDestroy,
      onDestroy: config.onDestroy
    };
  }

  function addInputAttributes(input) {
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('spellcheck', 'false');
  }

  function removeInputAttributes(input) {
    input.removeAttribute('autocorrect', 'off');
    input.removeAttribute('autocomplete', 'off');
    input.removeAttribute('autocapitalize', 'off');
    input.removeAttribute('spellcheck', 'false');
  }

  /**
   * Public variables
   */
  PredictiveSearchComponent.prototype.isResultVisible = false;
  PredictiveSearchComponent.prototype.results = {};

  /**
   * "Private" variables
   */
  PredictiveSearchComponent.prototype._latencyTimer = null;
  PredictiveSearchComponent.prototype._resultNodeClicked = false;

  /**
   * "Private" instance methods
   */
  PredictiveSearchComponent.prototype._addInputEventListeners = function() {
    var input = this.nodes.input;
    var reset = this.nodes.reset;

    if (!input) {
      return;
    }

    this._handleInputFocus = this._handleInputFocus.bind(this);
    this._handleInputBlur = this._handleInputBlur.bind(this);
    this._handleInputKeyup = this._handleInputKeyup.bind(this);
    this._handleInputKeydown = this._handleInputKeydown.bind(this);

    input.addEventListener('focus', this._handleInputFocus);
    input.addEventListener('blur', this._handleInputBlur);
    input.addEventListener('keyup', this._handleInputKeyup);
    input.addEventListener('keydown', this._handleInputKeydown);

    if (reset) {
      this._handleInputReset = this._handleInputReset.bind(this);
      reset.addEventListener('click', this._handleInputReset);
    }
  };

  PredictiveSearchComponent.prototype._removeInputEventListeners = function() {
    var input = this.nodes.input;

    input.removeEventListener('focus', this._handleInputFocus);
    input.removeEventListener('blur', this._handleInputBlur);
    input.removeEventListener('keyup', this._handleInputKeyup);
    input.removeEventListener('keydown', this._handleInputKeydown);
  };

  PredictiveSearchComponent.prototype._addBodyEventListener = function() {
    this._handleBodyMousedown = this._handleBodyMousedown.bind(this);

    document
      .querySelector('body')
      .addEventListener('mousedown', this._handleBodyMousedown);
  };

  PredictiveSearchComponent.prototype._removeBodyEventListener = function() {
    document
      .querySelector('body')
      .removeEventListener('mousedown', this._handleBodyMousedown);
  };

  PredictiveSearchComponent.prototype._removeClearButtonEventListener = function() {
    var reset = this.nodes.reset;

    if (!reset) {
      return;
    }

    reset.removeEventListener('click', this._handleInputReset);
  };

  /**
   * Event handlers
   */
  PredictiveSearchComponent.prototype._handleBodyMousedown = function(evt) {
    if (this.isResultVisible && this.nodes !== null) {
      if (
        evt.target.isEqualNode(this.nodes.input) ||
        this.nodes.input.contains(evt.target) ||
        evt.target.isEqualNode(this.nodes.result) ||
        this.nodes.result.contains(evt.target)
      ) {
        this._resultNodeClicked = true;
      } else {
        if (isFunction(this.callbacks.onBodyMousedown)) {
          var returnedValue = this.callbacks.onBodyMousedown(this.nodes);
          if (isBoolean(returnedValue) && returnedValue) {
            this.close();
          }
        } else {
          this.close();
        }
      }
    }
  };

  PredictiveSearchComponent.prototype._handleInputFocus = function(evt) {
    if (isFunction(this.callbacks.onInputFocus)) {
      var returnedValue = this.callbacks.onInputFocus(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    if (evt.target.value.length > 0) {
      this._search();
    }

    return true;
  };

  PredictiveSearchComponent.prototype._handleInputBlur = function() {
    // This has to be done async, to wait for the focus to be on the next
    // element and avoid closing the results.
    // Example: Going from the input to the reset button.
    setTimeout(
      function() {
        if (isFunction(this.callbacks.onInputBlur)) {
          var returnedValue = this.callbacks.onInputBlur(this.nodes);
          if (isBoolean(returnedValue) && !returnedValue) {
            return false;
          }
        }

        if (document.activeElement.isEqualNode(this.nodes.reset)) {
          return false;
        }

        if (this._resultNodeClicked) {
          this._resultNodeClicked = false;
          return false;
        }

        this.close();
      }.bind(this)
    );

    return true;
  };

  PredictiveSearchComponent.prototype._addAccessibilityAnnouncer = function() {
    this._accessibilityAnnouncerDiv = window.document.createElement('div');

    this._accessibilityAnnouncerDiv.setAttribute(
      'style',
      'position: absolute !important; overflow: hidden; clip: rect(0 0 0 0); height: 1px; width: 1px; margin: -1px; padding: 0; border: 0;'
    );

    this._accessibilityAnnouncerDiv.setAttribute('data-search-announcer', '');
    this._accessibilityAnnouncerDiv.setAttribute('aria-live', 'polite');
    this._accessibilityAnnouncerDiv.setAttribute('aria-atomic', 'true');

    this.nodes.result.parentElement.appendChild(
      this._accessibilityAnnouncerDiv
    );
  };

  PredictiveSearchComponent.prototype._removeAccessibilityAnnouncer = function() {
    this.nodes.result.parentElement.removeChild(
      this._accessibilityAnnouncerDiv
    );
  };

  PredictiveSearchComponent.prototype._updateAccessibilityAttributesAfterSelectingElement = function(
    previousSelectedElement,
    currentSelectedElement
  ) {
    // Update the active descendant on the search input
    this.nodes.input.setAttribute(
      'aria-activedescendant',
      currentSelectedElement.id
    );

    // Unmark the previousSelected elemented as selected
    if (previousSelectedElement) {
      previousSelectedElement.removeAttribute('aria-selected');
    }

    // Mark the element as selected
    currentSelectedElement.setAttribute('aria-selected', true);
  };

  PredictiveSearchComponent.prototype._clearAriaActiveDescendant = function() {
    this.nodes.input.setAttribute('aria-activedescendant', '');
  };

  PredictiveSearchComponent.prototype._announceNumberOfResultsFound = function(
    results
  ) {
    var currentAnnouncedMessage = this._accessibilityAnnouncerDiv.innerHTML;
    var newMessage = this.numberOfResultsTemplateFct(results);

    // If the messages are the same, they won't get announced
    // add white space so it gets announced
    if (currentAnnouncedMessage === newMessage) {
      newMessage = newMessage + '&nbsp;';
    }

    this._accessibilityAnnouncerDiv.innerHTML = newMessage;
  };

  PredictiveSearchComponent.prototype._announceLoadingState = function() {
    this._accessibilityAnnouncerDiv.innerHTML = this.loadingResultsMessageTemplateFct();
  };

  PredictiveSearchComponent.prototype._handleInputKeyup = function(evt) {
    var UP_ARROW_KEY_CODE = 38;
    var DOWN_ARROW_KEY_CODE = 40;
    var RETURN_KEY_CODE = 13;
    var ESCAPE_KEY_CODE = 27;

    if (isFunction(this.callbacks.onInputKeyup)) {
      var returnedValue = this.callbacks.onInputKeyup(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this._toggleClearButtonVisibility();

    if (this.isResultVisible && this.nodes !== null) {
      if (evt.keyCode === UP_ARROW_KEY_CODE) {
        this._navigateOption(evt, 'UP');
        return true;
      }

      if (evt.keyCode === DOWN_ARROW_KEY_CODE) {
        this._navigateOption(evt, 'DOWN');
        return true;
      }

      if (evt.keyCode === RETURN_KEY_CODE) {
        this._selectOption();
        return true;
      }

      if (evt.keyCode === ESCAPE_KEY_CODE) {
        this.close();
      }
    }

    if (evt.target.value.length <= 0) {
      this.close();
      this._setKeyword('');
    } else if (evt.target.value.length > 0) {
      this._search();
    }

    return true;
  };

  PredictiveSearchComponent.prototype._handleInputKeydown = function(evt) {
    var RETURN_KEY_CODE = 13;
    var UP_ARROW_KEY_CODE = 38;
    var DOWN_ARROW_KEY_CODE = 40;

    // Prevent the form default submission if there is a selected option
    if (evt.keyCode === RETURN_KEY_CODE && this._getSelectedOption() !== null) {
      evt.preventDefault();
    }

    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      evt.keyCode === UP_ARROW_KEY_CODE ||
      evt.keyCode === DOWN_ARROW_KEY_CODE
    ) {
      evt.preventDefault();
    }
  };

  PredictiveSearchComponent.prototype._handleInputReset = function(evt) {
    evt.preventDefault();

    if (isFunction(this.callbacks.onInputReset)) {
      var returnedValue = this.callbacks.onInputReset(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this.nodes.input.value = '';
    this.nodes.input.focus();
    this._toggleClearButtonVisibility();
    this.close();

    return true;
  };

  PredictiveSearchComponent.prototype._navigateOption = function(
    evt,
    direction
  ) {
    var currentOption = this._getSelectedOption();

    if (!currentOption) {
      var firstOption = this.nodes.result.querySelector(
        this.selectors.searchResult
      );
      firstOption.classList.add(this.classes.itemSelected);
      this._updateAccessibilityAttributesAfterSelectingElement(
        null,
        firstOption
      );
    } else {
      if (direction === 'DOWN') {
        var nextOption = currentOption.nextElementSibling;
        if (nextOption) {
          currentOption.classList.remove(this.classes.itemSelected);
          nextOption.classList.add(this.classes.itemSelected);
          this._updateAccessibilityAttributesAfterSelectingElement(
            currentOption,
            nextOption
          );
        }
      } else {
        var previousOption = currentOption.previousElementSibling;
        if (previousOption) {
          currentOption.classList.remove(this.classes.itemSelected);
          previousOption.classList.add(this.classes.itemSelected);
          this._updateAccessibilityAttributesAfterSelectingElement(
            currentOption,
            previousOption
          );
        }
      }
    }
  };

  PredictiveSearchComponent.prototype._getSelectedOption = function() {
    return this.nodes.result.querySelector('.' + this.classes.itemSelected);
  };

  PredictiveSearchComponent.prototype._selectOption = function() {
    var selectedOption = this._getSelectedOption();

    if (selectedOption) {
      selectedOption.querySelector('a, button').click();
    }
  };

  PredictiveSearchComponent.prototype._search = function() {
    var newSearchKeyword = this.nodes.input.value;

    if (this._searchKeyword === newSearchKeyword) {
      return;
    }

    clearTimeout(this._latencyTimer);
    this._latencyTimer = setTimeout(
      function() {
        this.results.isLoading = true;

        // Annonuce that we're loading the results
        this._announceLoadingState();

        this.nodes.result.classList.add(this.classes.visibleVariant);
        // NOTE: We could benifit in using DOMPurify.
        // https://github.com/cure53/DOMPurify
        this.nodes.result.innerHTML = this.resultTemplateFct(this.results);
      }.bind(this),
      500
    );

    this.predictiveSearch.query(newSearchKeyword);
    this._setKeyword(newSearchKeyword);
  };

  PredictiveSearchComponent.prototype._handlePredictiveSearchSuccess = function(
    json
  ) {
    clearTimeout(this._latencyTimer);
    this.results = json.resources.results;

    this.results.isLoading = false;
    this.results.products = this.results.products.slice(
      0,
      this.numberOfResults
    );
    this.results.canLoadMore =
      this.numberOfResults <= this.results.products.length;
    this.results.searchQuery = this.nodes.input.value;

    if (this.results.products.length > 0 || this.results.searchQuery) {
      this.nodes.result.innerHTML = this.resultTemplateFct(this.results);
      this._announceNumberOfResultsFound(this.results);
      this.open();
    } else {
      this.nodes.result.innerHTML = '';

      this._closeOnNoResults();
    }
  };

  PredictiveSearchComponent.prototype._handlePredictiveSearchError = function() {
    clearTimeout(this._latencyTimer);
    this.nodes.result.innerHTML = '';

    this._closeOnNoResults();
  };

  PredictiveSearchComponent.prototype._closeOnNoResults = function() {
    if (this.nodes) {
      this.nodes.result.classList.remove(this.classes.visibleVariant);
    }

    this.isResultVisible = false;
  };

  PredictiveSearchComponent.prototype._setKeyword = function(keyword) {
    this._searchKeyword = keyword;
  };

  PredictiveSearchComponent.prototype._toggleClearButtonVisibility = function() {
    if (!this.nodes.reset) {
      return;
    }

    if (this.nodes.input.value.length > 0) {
      this.nodes.reset.classList.add(this.classes.clearButtonVisible);
    } else {
      this.nodes.reset.classList.remove(this.classes.clearButtonVisible);
    }
  };

  /**
   * Public methods
   */
  PredictiveSearchComponent.prototype.open = function() {
    if (this.isResultVisible) {
      return;
    }

    if (isFunction(this.callbacks.onBeforeOpen)) {
      var returnedValue = this.callbacks.onBeforeOpen(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this.nodes.result.classList.add(this.classes.visibleVariant);
    this.nodes.input.setAttribute('aria-expanded', true);
    this.isResultVisible = true;

    if (isFunction(this.callbacks.onOpen)) {
      return this.callbacks.onOpen(this.nodes) || true;
    }

    return true;
  };

  PredictiveSearchComponent.prototype.close = function() {
    if (!this.isResultVisible) {
      return true;
    }

    if (isFunction(this.callbacks.onBeforeClose)) {
      var returnedValue = this.callbacks.onBeforeClose(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    if (this.nodes) {
      this.nodes.result.classList.remove(this.classes.visibleVariant);
    }

    this.nodes.input.setAttribute('aria-expanded', false);
    this._clearAriaActiveDescendant();
    this._setKeyword('');

    if (isFunction(this.callbacks.onClose)) {
      this.callbacks.onClose(this.nodes);
    }

    this.isResultVisible = false;
    this.results = {};

    return true;
  };

  PredictiveSearchComponent.prototype.destroy = function() {
    this.close();

    if (isFunction(this.callbacks.onBeforeDestroy)) {
      var returnedValue = this.callbacks.onBeforeDestroy(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this.nodes.result.classList.remove(this.classes.visibleVariant);
    removeInputAttributes(this.nodes.input);
    this._removeInputEventListeners();
    this._removeBodyEventListener();
    this._removeAccessibilityAnnouncer();
    this._removeClearButtonEventListener();

    if (isFunction(this.callbacks.onDestroy)) {
      this.callbacks.onDestroy(this.nodes);
    }

    return true;
  };

  PredictiveSearchComponent.prototype.clearAndClose = function() {
    this.nodes.input.value = '';
    this.close();
  };

  /**
   * Utilities
   */
  function getTypeOf(value) {
    return Object.prototype.toString.call(value);
  }

  function isString(value) {
    return getTypeOf(value) === '[object String]';
  }

  function isBoolean(value) {
    return getTypeOf(value) === '[object Boolean]';
  }

  function isFunction(value) {
    return getTypeOf(value) === '[object Function]';
  }

  return PredictiveSearchComponent;
})(Shopify.theme.PredictiveSearch);

window.theme = window.theme || {};

theme.TouchEvents = function TouchEvents(element, options) {
  this.axis;
  this.checkEvents = [];
  this.eventHandlers = {};
  this.eventModel = {};
  this.events = [
    ['touchstart', 'touchmove', 'touchend', 'touchcancel'],
    ['pointerdown', 'pointermove', 'pointerup', 'pointercancel'],
    ['mousedown', 'mousemove', 'mouseup']
  ];
  this.eventType;
  this.difference = {};
  this.direction;
  this.start = {};

  this.element = element;
  this.options = Object.assign(
    {},
    {
      dragThreshold: 10,
      start: function() {}, // eslint-disable-line
      move: function() {}, // eslint-disable-line
      end: function() {} // eslint-disable-line
    },
    options
  );

  this.checkEvents = this._getCheckEvents();
  this.eventModel = this._getEventModel();

  this._setupEventHandlers();
};

theme.TouchEvents.prototype = Object.assign({}, theme.TouchEvents.prototype, {
  destroy: function() {
    this.element.removeEventListener(
      'dragstart',
      this.eventHandlers.preventDefault
    );

    this.element.removeEventListener(
      this.events[this.eventModel][0],
      this.eventHandlers.touchStart
    );

    if (!this.eventModel) {
      this.element.removeEventListener(
        this.events[2][0],
        this.eventHandlers.touchStart
      );
    }

    this.element.removeEventListener('click', this.eventHandlers.preventClick);
  },

  _setupEventHandlers: function() {
    this.eventHandlers.preventDefault = this._preventDefault.bind(this);
    this.eventHandlers.preventClick = this._preventClick.bind(this);
    this.eventHandlers.touchStart = this._touchStart.bind(this);
    this.eventHandlers.touchMove = this._touchMove.bind(this);
    this.eventHandlers.touchEnd = this._touchEnd.bind(this);

    // Prevent element from dragging when using mouse
    this.element.addEventListener(
      'dragstart',
      this.eventHandlers.preventDefault
    );

    // Bind the touchstart/pointerdown event
    this.element.addEventListener(
      this.events[this.eventModel][0],
      this.eventHandlers.touchStart
    );

    // Bind mousedown if necessary
    if (!this.eventModel) {
      this.element.addEventListener(
        this.events[2][0],
        this.eventHandlers.touchStart
      );
    }

    // No clicking during touch
    this.element.addEventListener('click', this.eventHandlers.preventClick);
  },

  _touchStart: function(event) {
    this.eventType = this.eventModel;

    if (event.type === 'mousedown' && !this.eventModel) {
      this.eventType = 2;
    }

    if (this.checkEvents[this.eventType](event)) return;
    if (this.eventType) this._preventDefault(event);

    document.addEventListener(
      this.events[this.eventType][1],
      this.eventHandlers.touchMove
    );

    document.addEventListener(
      this.events[this.eventType][2],
      this.eventHandlers.touchEnd
    );

    if (this.eventType < 2) {
      document.addEventListener(
        this.events[this.eventType][3],
        this.eventHandlers.touchEnd
      );
    }

    this.start = {
      xPosition: this.eventType ? event.clientX : event.touches[0].clientX,
      yPosition: this.eventType ? event.clientY : event.touches[0].clientY,
      time: new Date().getTime()
    };

    // Ensure we empty out the this.difference object
    Object.keys(this.difference).forEach(
      function(key) {
        delete this.difference[key];
      }.bind(this)
    );

    this.options.start(event);
  },

  _touchMove: function(event) {
    this.difference = this._getDifference(event);

    // Prevent document from scrolling during swipe gesture
    document['on' + this.events[this.eventType][1]] = function(event) {
      this._preventDefault(event);
    }.bind(this);

    // Get the direction user is dragging
    if (!this.axis) {
      if (this.options.dragThreshold < Math.abs(this.difference.xPosition)) {
        this.axis = 'xPosition';
      } else if (
        this.options.dragThreshold < Math.abs(this.difference.yPosition)
      ) {
        this.axis = 'yPosition';
      } else {
        this.axis = false;
      }
    } else if (this.axis === 'xPosition') {
      this.direction = this.difference.xPosition < 0 ? 'left' : 'right';
    } else if (this.axis === 'yPosition') {
      this.direction = this.difference.yPosition < 0 ? 'up' : 'down';
    }

    this.options.move(event, this.direction, this.difference);
  },

  _touchEnd: function(event) {
    document.removeEventListener(
      this.events[this.eventType][1],
      this.eventHandlers.touchMove
    );

    document.removeEventListener(
      this.events[this.eventType][2],
      this.eventHandlers.touchEnd
    );

    if (this.eventType < 2) {
      document.removeEventListener(
        this.events[this.eventType][3],
        this.eventHandlers.touchEnd
      );
    }

    // Re-enable document scrolling
    document['on' + this.events[this.eventType][1]] = function() {
      return true;
    };

    this.options.end(event, this.direction, this.difference);
    this.axis = false;
  },

  _getDifference: function(event) {
    return {
      xPosition:
        (this.eventType ? event.clientX : event.touches[0].clientX) -
        this.start.xPosition,
      yPosition:
        (this.eventType ? event.clientY : event.touches[0].clientY) -
        this.start.yPosition,
      time: new Date().getTime() - this.start.time
    };
  },

  _getCheckEvents: function() {
    return [
      // Touch events
      function(event) {
        // Skip the event if it's a multi-touch or pinch move
        return (
          (event.touches && event.touches.length > 1) ||
          (event.scale && event.scale !== 1)
        );
      },
      // Pointer events
      function(event) {
        // Skip it, if:
        // 1. The event is not primary (other pointers during multi-touch),
        // 2. Left mouse button is not pressed,
        // 3. Event is not a touch event
        return (
          !event.isPrimary ||
          (event.buttons && event.buttons !== 1) ||
          (event.pointerType !== 'touch' && event.pointerType !== 'pen')
        );
      },
      // Mouse events
      function(event) {
        // Skip the event if left mouse button is not pressed
        return event.buttons && event.buttons !== 1;
      }
    ];
  },

  _getEventModel: function() {
    return window.navigator.pointerEnabled ? 1 : 0;
  },

  _preventDefault: function(event) {
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);
  },

  _preventClick: function(event) {
    if (Math.abs(this.difference.xPosition) > this.options.dragThreshold) {
      this._preventDefault(event);
    }
  }
});


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var DEFAULT_OPEN_CLASS = 'js-drawer-open';
    var DEFAULT_CLOSE_CLASS = 'js-drawer-close';

    var defaults = {
      selectors: {
        openVariant: '.' + DEFAULT_OPEN_CLASS + '-' + position,
        close: '.' + DEFAULT_CLOSE_CLASS
      },
      classes: {
        open: DEFAULT_OPEN_CLASS,
        openVariant: DEFAULT_OPEN_CLASS + '-' + position
      },
      withPredictiveSearch: false
    };

    this.nodes = {
      parents: [document.documentElement, document.body],
      page: document.getElementById('PageContainer')
    };

    this.eventHandlers = {};

    this.config = Object.assign({}, defaults, options);
    this.position = position;
    this.drawer = document.getElementById(id);

    if (!this.drawer) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    document
      .querySelector(this.config.selectors.openVariant)
      .addEventListener('click', this.open.bind(this));
    this.drawer
      .querySelector(this.config.selectors.close)
      .addEventListener('click', this.close.bind(this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.activeSource = evt.currentTarget;
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    if (!this.config.withPredictiveSearch) {
      theme.Helpers.prepareTransition(this.drawer);
    }

    this.nodes.parents.forEach(
      function(parent) {
        parent.classList.add(
          this.config.classes.open,
          this.config.classes.openVariant
        );
      }.bind(this)
    );

    this.drawerIsOpen = true;

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.activeSource && this.activeSource.hasAttribute('aria-expanded')) {
      this.activeSource.setAttribute('aria-expanded', 'true');
    }

    // Set focus on drawer
    var trapFocusConfig = {
      container: this.drawer
    };

    if (this.config.elementToFocusOnOpen) {
      trapFocusConfig.elementToFocus = this.config.elementToFocusOnOpen;
    }

    slate.a11y.trapFocus(trapFocusConfig);

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    document.activeElement.dispatchEvent(
      new CustomEvent('blur', { bubbles: true, cancelable: true })
    );

    // Ensure closing transition is applied to moved elements, like the nav
    if (!this.config.withPredictiveSearch) {
      theme.Helpers.prepareTransition(this.drawer);
    }

    this.nodes.parents.forEach(
      function(parent) {
        parent.classList.remove(
          this.config.classes.open,
          this.config.classes.openVariant
        );
      }.bind(this)
    );

    if (this.activeSource && this.activeSource.hasAttribute('aria-expanded')) {
      this.activeSource.setAttribute('aria-expanded', 'false');
    }

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      container: this.drawer
    });

    this.unbindEvents();

    // Run function when draw closes if set
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === 'function'
    ) {
      this.config.onDrawerClose();
    }
  };

  Drawer.prototype.bindEvents = function() {
    this.eventHandlers.drawerKeyupHandler = function(evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        this.close();
        return false;
      } else {
        return true;
      }
    }.bind(this);

    this.eventHandlers.drawerTouchmoveHandler = function() {
      return false;
    };

    this.eventHandlers.drawerClickHandler = function() {
      this.close();
      return false;
    }.bind(this);

    // Add event listener to document body
    document.body.addEventListener(
      'keyup',
      this.eventHandlers.drawerKeyupHandler
    );

    // Lock scrolling on mobile
    this.nodes.page.addEventListener(
      'touchmove',
      this.eventHandlers.drawerTouchmoveHandler
    );

    this.nodes.page.addEventListener(
      'click',
      this.eventHandlers.drawerClickHandler
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.page.removeEventListener(
      'touchmove',
      this.eventHandlers.drawerTouchmoveHandler
    );
    this.nodes.page.removeEventListener(
      'click',
      this.eventHandlers.drawerClickHandler
    );
    document.body.removeEventListener(
      'keyup',
      this.eventHandlers.drawerKeyupHandler
    );
  };

  return Drawer;
})();

theme.Helpers = (function() {
  var touchDevice = false;

  var classes = {
    preventScrolling: 'prevent-scrolling'
  };

  var scrollPosition = window.pageYOffset;

  function setTouch() {
    touchDevice = true;
  }

  function isTouch() {
    return touchDevice;
  }

  function enableScrollLock() {
    scrollPosition = window.pageYOffset;
    document.body.style.top = '-' + scrollPosition + 'px';
    document.body.classList.add(classes.preventScrolling);
  }

  function disableScrollLock() {
    document.body.classList.remove(classes.preventScrolling);
    document.body.style.removeProperty('top');
    window.scrollTo(0, scrollPosition);
  }

  function debounce(func, wait, immediate) {
    var timeout;

    return function() {
      var context = this,
        args = arguments;

      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function getScript(source, beforeEl) {
    return new Promise(function(resolve, reject) {
      var script = document.createElement('script');
      var prior = beforeEl || document.getElementsByTagName('script')[0];

      script.async = true;
      script.defer = true;

      // eslint-disable-next-line shopify/prefer-early-return
      function onloadHander(_, isAbort) {
        if (
          isAbort ||
          !script.readyState ||
          /loaded|complete/.test(script.readyState)
        ) {
          script.onload = null;
          script.onreadystatechange = null;
          script = undefined;

          if (isAbort) {
            reject();
          } else {
            resolve();
          }
        }
      }

      script.onload = onloadHander;
      script.onreadystatechange = onloadHander;

      script.src = source;
      prior.parentNode.insertBefore(script, prior);
    });
  }

  /* Based on the prepareTransition by Jonathan Snook */
  /* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
  function prepareTransition(element) {
    element.addEventListener(
      'transitionend',
      function(event) {
        event.currentTarget.classList.remove('is-transitioning');
      },
      { once: true }
    );

    var properties = [
      'transition-duration',
      '-moz-transition-duration',
      '-webkit-transition-duration',
      '-o-transition-duration'
    ];

    var duration = 0;

    properties.forEach(function(property) {
      var computedValue = getComputedStyle(element)[property];

      if (computedValue) {
        computedValue.replace(/\D/g, '');
        duration || (duration = parseFloat(computedValue));
      }
    });

    if (duration !== 0) {
      element.classList.add('is-transitioning');
      element.offsetWidth;
    }
  }

  /*!
   * Serialize all form data into a SearchParams string
   * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Node}   form The form to serialize
   * @return {String}      The serialized form data
   */
  function serialize(form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function(field) {
      if (
        !field.name ||
        field.disabled ||
        ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
      )
        return;
      if (field.type === 'select-multiple') {
        Array.prototype.slice.call(field.options).forEach(function(option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              '=' +
              encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
      );
    });
    return arr.join('&');
  }
  function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }

    return cookieEnabled;
  }

  function promiseStylesheet(stylesheet) {
    var stylesheetUrl = stylesheet || theme.stylesheet;

    if (typeof this.stylesheetPromise === 'undefined') {
      this.stylesheetPromise = new Promise(function(resolve) {
        var link = document.querySelector('link[href="' + stylesheetUrl + '"]');

        if (link.loaded) resolve();

        link.addEventListener('load', function() {
          setTimeout(resolve, 0);
        });
      });
    }

    return this.stylesheetPromise;
  }

  return {
    setTouch: setTouch,
    isTouch: isTouch,
    enableScrollLock: enableScrollLock,
    disableScrollLock: disableScrollLock,
    debounce: debounce,
    getScript: getScript,
    prepareTransition: prepareTransition,
    serialize: serialize,
    cookiesEnabled: cookiesEnabled,
    promiseStylesheet: promiseStylesheet
  };
})();

theme.LibraryLoader = (function() {
  var types = {
    link: 'link',
    script: 'script'
  };

  var status = {
    requested: 'requested',
    loaded: 'loaded'
  };

  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

  var libraries = {
    plyrShopifyStyles: {
      tagId: 'plyr-shopify-styles',
      src: cloudCdn + 'plyr/v2.0/shopify-plyr.css',
      type: types.link
    },
    modelViewerUiStyles: {
      tagId: 'shopify-model-viewer-ui-styles',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      type: types.link
    }
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];

    if (!library) return;
    if (library.status === status.requested) return;

    callback = callback || function() {};
    if (library.status === status.loaded) {
      callback();
      return;
    }

    library.status = status.requested;

    var tag;

    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }

    tag.id = library.tagId;
    library.element = tag;

    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement('script');
    tag.src = library.src;
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement('link');
    tag.href = library.src;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load
  };
})();


/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
    body: 'body',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '[data-has-dropdowns]',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavHasCenteredDropdown: '.site-nav--has-centered-dropdown',
    siteNavCenteredDropdown: '.site-nav__dropdown--centered',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last',
    siteNavDropdown: '.site-nav__dropdown',
    siteHeader: '.site-header'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link',
    rightDropdownClass: 'site-nav__dropdown--right',
    leftDropdownClass: 'site-nav__dropdown--left'
  };

  var cache = {};

  function init() {
    cacheSelectors();
    styleDropdowns(document.querySelectorAll(selectors.siteNavHasDropdown));
    positionFullWidthDropdowns();

    cache.parents.forEach(function(element) {
      element.addEventListener('click', submenuParentClickHandler);
    });

    // check when we're leaving a dropdown and close the active dropdown
    cache.siteNavChildLink.forEach(function(element) {
      element.addEventListener('focusout', submenuFocusoutHandler);
    });

    cache.topLevel.forEach(function(element) {
      element.addEventListener('focus', hideDropdown);
    });

    cache.subMenuLinks.forEach(function(element) {
      element.addEventListener('click', stopImmediatePropagation);
    });

    window.addEventListener('resize', resizeHandler);
  }

  function stopImmediatePropagation(event) {
    event.stopImmediatePropagation();
  }

  function cacheSelectors() {
    var navigation = document.querySelector(selectors.navigation);

    cache = {
      nav: navigation,
      topLevel: document.querySelectorAll(selectors.siteNavLinkMain),
      parents: navigation.querySelectorAll(selectors.siteNavHasDropdown),
      subMenuLinks: document.querySelectorAll(selectors.siteNavChildLinks),
      activeDropdown: document.querySelector(selectors.siteNavActiveDropdown),
      siteHeader: document.querySelector(selectors.siteHeader),
      siteNavChildLink: document.querySelectorAll(selectors.siteNavChildLink)
    };
  }

  function showDropdown(element) {
    element.classList.add(config.activeClass);

    if (cache.activeDropdown) hideDropdown();

    cache.activeDropdown = element;

    element
      .querySelector(selectors.siteNavLinkMain)
      .setAttribute('aria-expanded', 'true');

    setTimeout(function() {
      window.addEventListener('keyup', keyUpHandler);
      document.body.addEventListener('click', hideDropdown);
    }, 250);
  }

  function hideDropdown() {
    if (!cache.activeDropdown) return;

    cache.activeDropdown
      .querySelector(selectors.siteNavLinkMain)
      .setAttribute('aria-expanded', 'false');
    cache.activeDropdown.classList.remove(config.activeClass);

    cache.activeDropdown = document.querySelector(
      selectors.siteNavActiveDropdown
    );

    window.removeEventListener('keyup', keyUpHandler);
    document.body.removeEventListener('click', hideDropdown);
  }

  function styleDropdowns(dropdownListItems) {
    dropdownListItems.forEach(function(item) {
      var dropdownLi = item.querySelector(selectors.siteNavDropdown);

      if (!dropdownLi) return;

      if (isRightOfLogo(item)) {
        dropdownLi.classList.remove(config.leftDropdownClass);
        dropdownLi.classList.add(config.rightDropdownClass);
      } else {
        dropdownLi.classList.remove(config.rightDropdownClass);
        dropdownLi.classList.add(config.leftDropdownClass);
      }
    });
  }

  function isRightOfLogo(item) {
    var rect = item.getBoundingClientRect();
    var win = item.ownerDocument.defaultView;
    var leftOffset = rect.left + win.pageXOffset;

    var headerWidth = Math.floor(cache.siteHeader.offsetWidth) / 2;
    return leftOffset > headerWidth;
  }

  function positionFullWidthDropdowns() {
    document
      .querySelectorAll(selectors.siteNavHasCenteredDropdown)
      .forEach(function(el) {
        var fullWidthDropdown = el.querySelector(
          selectors.siteNavCenteredDropdown
        );

        var fullWidthDropdownOffset = el.offsetTop + 41;
        fullWidthDropdown.style.top = fullWidthDropdownOffset + 'px';
      });
  }

  function keyUpHandler(event) {
    if (event.keyCode === 27) hideDropdown();
  }

  function resizeHandler() {
    adjustStyleAndPosition();
  }

  function submenuParentClickHandler(event) {
    var element = event.currentTarget;

    element.classList.contains(config.activeClass)
      ? hideDropdown()
      : showDropdown(element);
  }

  function submenuFocusoutHandler() {
    setTimeout(function() {
      if (
        document.activeElement.classList.contains(config.childLinkClass) ||
        !cache.activeDropdown
      ) {
        return;
      }

      hideDropdown();
    });
  }

  var adjustStyleAndPosition = theme.Helpers.debounce(function() {
    styleDropdowns(document.querySelectorAll(selectors.siteNavHasDropdown));
    positionFullWidthDropdowns();
  }, 50);

  function unload() {
    cache.topLevel.forEach(function(element) {
      element.removeEventListener('focus', hideDropdown);
    });

    cache.subMenuLinks.forEach(function(element) {
      element.removeEventListener('click', stopImmediatePropagation);
    });

    cache.parents.forEach(function(element) {
      element.removeEventListener('click', submenuParentClickHandler);
    });

    cache.siteNavChildLink.forEach(function(element) {
      element.removeEventListener('focusout', submenuFocusoutHandler);
    });

    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('keyup', keyUpHandler);
    document.body.removeEventListener('click', hideDropdown);
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLinkWrapper: 'mobile-nav__item',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  };

  var cache = {};
  var isTransitioning;
  var activeSubNav;
  var activeTrigger;
  var menuLevel = 1;
  var mediumUpQuery = '(min-width: ' + theme.breakpoints.medium + 'px)';
  var mql = window.matchMedia(mediumUpQuery);

  function init() {
    cacheSelectors();

    if (cache.mobileNavToggle) {
      cache.mobileNavToggle.addEventListener('click', toggleMobileNav);
    }

    cache.subNavToggleBtns.forEach(function(element) {
      element.addEventListener('click', toggleSubNav);
    });

    mql.addListener(initBreakpoints);
  }

  function initBreakpoints() {
    if (
      mql.matches &&
      cache.mobileNavContainer.classList.contains(classes.navOpen)
    ) {
      closeMobileNav();
    }
  }

  function toggleMobileNav() {
    var mobileNavIsOpen = cache.mobileNavToggle.classList.contains(
      classes.mobileNavCloseIcon
    );

    if (mobileNavIsOpen) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      pageContainer: document.querySelector('#PageContainer'),
      siteHeader: document.querySelector('.site-header'),
      mobileNavToggle: document.querySelector('.js-mobile-nav-toggle'),
      mobileNavContainer: document.querySelector('.mobile-nav-wrapper'),
      mobileNav: document.querySelector('#MobileNav'),
      sectionHeader: document.querySelector('#shopify-section-header'),
      subNavToggleBtns: document.querySelectorAll('.' + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {
    var translateHeaderHeight = cache.siteHeader.offsetHeight;

    theme.Helpers.prepareTransition(cache.mobileNavContainer);
    cache.mobileNavContainer.classList.add(classes.navOpen);

    cache.mobileNavContainer.style.transform =
      'translateY(' + translateHeaderHeight + 'px)';

    cache.pageContainer.style.transform =
      'translate3d(0, ' + cache.mobileNavContainer.scrollHeight + 'px, 0)';

    slate.a11y.trapFocus({
      container: cache.sectionHeader,
      elementToFocus: cache.mobileNavToggle
    });

    cache.mobileNavToggle.classList.add(classes.mobileNavCloseIcon);
    cache.mobileNavToggle.classList.remove(classes.mobileNavOpenIcon);
    cache.mobileNavToggle.setAttribute('aria-expanded', true);

    window.addEventListener('keyup', keyUpHandler);
  }

  function keyUpHandler(event) {
    if (event.which === 27) {
      closeMobileNav();
    }
  }

  function closeMobileNav() {
    theme.Helpers.prepareTransition(cache.mobileNavContainer);
    cache.mobileNavContainer.classList.remove(classes.navOpen);
    cache.mobileNavContainer.style.transform = 'translateY(-100%)';
    cache.pageContainer.setAttribute('style', '');

    slate.a11y.trapFocus({
      container: document.querySelector('html'),
      elementToFocus: document.body
    });

    cache.mobileNavContainer.addEventListener(
      'transitionend',
      mobileNavRemoveTrapFocus,
      { once: true }
    );

    cache.mobileNavToggle.classList.add(classes.mobileNavOpenIcon);
    cache.mobileNavToggle.classList.remove(classes.mobileNavCloseIcon);
    cache.mobileNavToggle.setAttribute('aria-expanded', false);
    cache.mobileNavToggle.focus();

    window.removeEventListener('keyup', keyUpHandler);
    window.scrollTo(0, 0);
  }

  function mobileNavRemoveTrapFocus() {
    slate.a11y.removeTrapFocus({
      container: cache.mobileNav
    });
  }

  function toggleSubNav(event) {
    if (isTransitioning) return;

    var toggleBtn = event.currentTarget;
    var isReturn = toggleBtn.classList.contains(classes.return);

    isTransitioning = true;

    if (isReturn) {
      var subNavToggleBtn = document.querySelectorAll(
        '.' + classes.subNavToggleBtn + "[data-level='" + (menuLevel - 1) + "']"
      );

      subNavToggleBtn.forEach(function(element) {
        element.classList.remove(classes.subNavActive);
      });

      if (activeTrigger) {
        activeTrigger.classList.remove(classes.subNavActive);
      }
    } else {
      toggleBtn.classList.add(classes.subNavActive);
    }

    activeTrigger = toggleBtn;

    goToSubnav(toggleBtn.getAttribute('data-target'));
  }

  function goToSubnav(target) {
    var targetMenu = target
      ? document.querySelector(
          '.mobile-nav__dropdown[data-parent="' + target + '"]'
        )
      : cache.mobileNav;

    menuLevel = targetMenu.dataset.level ? Number(targetMenu.dataset.level) : 1;

    if (activeSubNav) {
      theme.Helpers.prepareTransition(activeSubNav);
      activeSubNav.classList.add(classes.subNavClosing);
    }

    activeSubNav = targetMenu;

    var translateMenuHeight = targetMenu.offsetHeight;

    var openNavClass =
      menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

    cache.mobileNavContainer.style.height = translateMenuHeight + 'px';
    cache.mobileNavContainer.classList.remove(classes.thirdNavShowing);
    cache.mobileNavContainer.classList.add(openNavClass);

    if (!target) {
      cache.mobileNavContainer.classList.remove(
        classes.thirdNavShowing,
        classes.subNavShowing
      );
    }

    /* if going back to first subnav, focus is on whole header */
    var container = menuLevel === 1 ? cache.sectionHeader : targetMenu;

    cache.mobileNavContainer.addEventListener(
      'transitionend',
      trapMobileNavFocus,
      { once: true }
    );

    function trapMobileNavFocus() {
      slate.a11y.trapFocus({
        container: container
      });

      cache.mobileNavContainer.removeEventListener(
        'transitionend',
        trapMobileNavFocus
      );

      isTransitioning = false;
    }

    // Match height of subnav
    cache.pageContainer.style.transform =
      'translateY(' + translateMenuHeight + 'px)';

    activeSubNav.classList.remove(classes.subNavClosing);
  }

  function unload() {
    mql.removeListener(initBreakpoints);
  }

  return {
    init: init,
    unload: unload,
    closeMobileNav: closeMobileNav
  };
})();

window.Modals = (function() {
  function Modal(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active',
      closeModalOnClick: false
    };

    this.modal = document.getElementById(id);

    if (!this.modal) return false;

    this.nodes = {
      parents: [document.querySelector('html'), document.body]
    };

    this.config = Object.assign(defaults, options);

    this.modalIsOpen = false;

    this.focusOnOpen = this.config.focusOnOpen
      ? document.getElementById(this.config.focusOnOpen)
      : this.modal;

    this.openElement = document.querySelector(this.config.open);
    this.init();
  }

  Modal.prototype.init = function() {
    this.openElement.addEventListener('click', this.open.bind(this));

    this.modal
      .querySelector(this.config.close)
      .addEventListener('click', this.closeModal.bind(this));
  };

  Modal.prototype.open = function(evt) {
    var self = this;
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    if (this.modalIsOpen) return;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
    }

    if (this.modalIsOpen && !externalCall) {
      this.closeModal();
    }

    this.modal.classList.add(this.config.openClass);

    this.nodes.parents.forEach(function(node) {
      node.classList.add(self.config.openClass);
    });

    this.modalIsOpen = true;

    slate.a11y.trapFocus({
      container: this.modal,
      elementToFocus: this.focusOnOpen
    });

    this.bindEvents();
  };

  Modal.prototype.closeModal = function() {
    if (!this.modalIsOpen) return;

    document.activeElement.blur();

    this.modal.classList.remove(this.config.openClass);

    var self = this;

    this.nodes.parents.forEach(function(node) {
      node.classList.remove(self.config.openClass);
    });

    this.modalIsOpen = false;

    slate.a11y.removeTrapFocus({
      container: this.modal
    });

    this.openElement.focus();

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    this.keyupHandler = this.keyupHandler.bind(this);
    this.clickHandler = this.clickHandler.bind(this);
    document.body.addEventListener('keyup', this.keyupHandler);
    document.body.addEventListener('click', this.clickHandler);
  };

  Modal.prototype.unbindEvents = function() {
    document.body.removeEventListener('keyup', this.keyupHandler);
    document.body.removeEventListener('click', this.clickHandler);
  };

  Modal.prototype.keyupHandler = function(event) {
    if (event.keyCode === 27) {
      this.closeModal();
    }
  };

  Modal.prototype.clickHandler = function(event) {
    if (this.config.closeModalOnClick && !this.modal.contains(event.target)) {
      this.closeModal();
    }
  };

  return Modal;
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var backButton = document.querySelector(selectors.backButton);

  if (!document.referrer || !backButton || !window.history.length) {
    return;
  }

  backButton.addEventListener(
    'click',
    function(evt) {
      evt.preventDefault();

      var referrerDomain = urlDomain(document.referrer);
      var shopDomain = urlDomain(window.location.href);

      if (shopDomain === referrerDomain) {
        history.back();
      }

      return false;
    },
    { once: true }
  );

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  var selectors = {
    button: '[data-slider-button]',
    indicator: '[data-slider-indicator]',
    indicators: '[data-slider-indicators]',
    pause: '[data-slider-pause]',
    slider: '[data-slider]',
    sliderItem: '[data-slider-item]',
    sliderItemLink: '[data-slider-item-link]',
    sliderTrack: '[data-slider-track]',
    sliderContainer: '[data-slider-container]'
  };

  var classes = {
    isPaused: 'slideshow__pause--is-paused',
    indicator: 'slider-indicators__item',
    indicatorActive: 'slick-active',
    sliderInitialized: 'slick-initialized',
    slideActive: 'slideshow__slide--active',
    slideClone: 'slick-cloned'
  };

  var attributes = {
    buttonNext: 'data-slider-button-next'
  };

  function Slideshow(container, options) {
    this.container = container;
    this.slider = this.container.querySelector(selectors.slider);

    if (!this.slider) return;

    this.eventHandlers = {};
    this.lastSlide = 0;
    this.slideIndex = 0;
    this.sliderContainer = null;
    this.slides = [];
    this.options = Object.assign(
      {},
      {
        autoplay: false,
        canUseKeyboardArrows: true,
        canUseTouchEvents: false,
        slideActiveClass: classes.slideActive,
        slideInterval: 0,
        slidesToShow: 0,
        slidesToScroll: 1,
        type: 'fade'
      },
      options
    );

    this.sliderContainer = this.slider.querySelector(selectors.sliderContainer);
    this.adaptHeight =
      this.sliderContainer.getAttribute('data-adapt-height') === 'true';
    this.slides = Array.from(
      this.sliderContainer.querySelectorAll(selectors.sliderItem)
    );
    // adding -1 to accomodate Array order
    this.lastSlide = this.slides.length - 1;
    this.buttons = this.container.querySelectorAll(selectors.button);
    this.pause = this.container.querySelector(selectors.pause);
    this.indicators = this.container.querySelectorAll(selectors.indicators);

    if (this.slides.length <= 1) return;

    this.timeout = 250;

    if (this.options.autoplay) {
      this.startAutoplay();
    }

    if (this.adaptHeight) {
      this.setSlideshowHeight();
    }

    if (this.options.type === 'slide') {
      this.isFirstSlide = false;
      this.isLastSlide = false;
      this.sliderItemWidthTotal = 0;
      this.sliderTrack = this.slider.querySelector(selectors.sliderTrack);
      // added setTimeout due to matchMedia calling too early
      // which result wrong value when getting dimension from an element
      this.sliderItemWidthTotal = 0;
      theme.Helpers.promiseStylesheet().then(
        function() {
          this._setupSlideType();
        }.bind(this)
      );
    } else {
      this.setupSlider(0);
    }

    this._setupEventHandlers();
  }

  Slideshow.prototype = Object.assign({}, Slideshow.prototype, {
    /**
     * Moves to the previous slide
     */
    previousSlide: function() {
      this._move();
    },

    /**
     * Moves to the next slide
     */
    nextSlide: function() {
      this._move('next');
    },

    /**
     * Moves to the specified slide
     * @param {Number} index - The index of the slide to move to
     */
    setSlide: function(index) {
      this._setPosition(Number(index));
    },

    /**
     * Starts autoplaying the slider if autoplay is enabled
     */
    startAutoplay: function() {
      this.isAutoPlaying = true;

      window.clearTimeout(this.autoTimeOut);

      this.autoTimeOut = window.setTimeout(
        function() {
          var nextSlideIndex = this._getNextSlideIndex('next');
          this._setPosition(nextSlideIndex);
        }.bind(this),
        this.options.slideInterval
      );
    },

    /**
     * Stops autoplaying the slider if autoplay is enabled
     */
    stopAutoplay: function() {
      this.isAutoPlaying = false;

      window.clearTimeout(this.autoTimeOut);
    },

    /**
     * Set active states for sliders and indicators
     * @param {index} integer - Slide index to set up slider from
     */
    setupSlider: function(index) {
      this.slideIndex = index;

      if (this.indicators.length) {
        this._setActiveIndicator(index);
      }

      this._setupActiveSlide(index);
    },

    /**
     * Removes event listeners, among other things when wanting to destroy the
     * slider instance. This method needs to be called manually and will most
     * likely be included in a section's onUnload() method.
     */
    destroy: function() {
      if (this.adaptHeight) {
        window.removeEventListener('resize', this.eventHandlers.debounceResize);
      }

      this.container.removeEventListener(
        'focus',
        this.eventHandlers.focus,
        true
      );
      this.slider.removeEventListener(
        'focusin',
        this.eventHandlers.focusIn,
        true
      );
      this.slider.removeEventListener(
        'focusout',
        this.eventHandlers.focusOut,
        true
      );
      this.container.removeEventListener('blur', this.eventHandlers.blur, true);

      if (this.buttons) {
        this.buttons.forEach(
          function(button) {
            button.removeEventListener('click', this.eventHandlers.clickButton);
          }.bind(this)
        );
      }

      this.indicators.forEach(function(indicatorWrapper) {
        indicatorWrapper.childNodes.forEach(function(indicator) {
          indicator.firstElementChild.removeEventListener(
            'click',
            this.eventHandlers.onClickIndicator
          );

          indicator.firstElementChild.removeEventListener(
            'keydown',
            this.eventHandlers.onKeydownIndicator
          );
        }, this);
      }, this);

      if (this.options.type === 'slide') {
        window.removeEventListener(
          'resize',
          this.eventHandlers.debounceResizeSlideIn
        );

        if (this.touchEvents && this.options.canUseTouchEvents) {
          this.touchEvents.destroy();
          this.touchEvents = null;
        }
      }
    },

    _setupEventHandlers: function() {
      this.eventHandlers.focus = this._onFocus.bind(this);
      this.eventHandlers.focusIn = this._onFocusIn.bind(this);
      this.eventHandlers.focusOut = this._onFocusOut.bind(this);
      this.eventHandlers.blur = this._onBlur.bind(this);
      this.eventHandlers.keyUp = this._onKeyUp.bind(this);
      this.eventHandlers.clickButton = this._onClickButton.bind(this);
      this.eventHandlers.onClickIndicator = this._onClickIndicator.bind(this);
      this.eventHandlers.onKeydownIndicator = this._onKeydownIndicator.bind(
        this
      );
      this.eventHandlers.onClickPause = this._onClickPause.bind(this);

      if (this.adaptHeight) {
        this.eventHandlers.debounceResize = theme.Helpers.debounce(
          function() {
            this.setSlideshowHeight();
          }.bind(this),
          50
        );

        window.addEventListener('resize', this.eventHandlers.debounceResize);
      }

      this.container.addEventListener('focus', this.eventHandlers.focus, true);
      this.slider.addEventListener('focusin', this.eventHandlers.focusIn, true);
      this.slider.addEventListener(
        'focusout',
        this.eventHandlers.focusOut,
        true
      );
      this.container.addEventListener('blur', this.eventHandlers.blur, true);

      if (this.buttons) {
        this.buttons.forEach(
          function(button) {
            button.addEventListener('click', this.eventHandlers.clickButton);
          }.bind(this)
        );
      }

      if (this.pause) {
        this.pause.addEventListener('click', this.eventHandlers.onClickPause);
      }

      this.indicators.forEach(function(indicatorWrapper) {
        indicatorWrapper.childNodes.forEach(function(indicator) {
          indicator.firstElementChild.addEventListener(
            'click',
            this.eventHandlers.onClickIndicator
          );

          indicator.firstElementChild.addEventListener(
            'keydown',
            this.eventHandlers.onKeydownIndicator
          );
        }, this);
      }, this);

      if (this.options.type === 'slide') {
        this.eventHandlers.debounceResizeSlideIn = theme.Helpers.debounce(
          function() {
            this.sliderItemWidthTotal = 0;
            this._setupSlideType(true);
          }.bind(this),
          50
        );

        window.addEventListener(
          'resize',
          this.eventHandlers.debounceResizeSlideIn
        );

        if (
          this.options.canUseTouchEvents &&
          this.options.slidesToScroll < this.slides.length
        ) {
          this._setupTouchEvents();
        }
      }
    },

    _setupTouchEvents: function() {
      this.touchEvents = new theme.TouchEvents(this.sliderTrack, {
        start: function() {
          this._onTouchStart();
        }.bind(this),
        move: function(event, direction, difference) {
          this._onTouchMove(event, direction, difference);
        }.bind(this),
        end: function(event, direction, difference) {
          this._onTouchEnd(event, direction, difference);
        }.bind(this)
      });
    },

    /**
     * Set slideshop for "slide-in" effect
     * @param {Boolean} onResize if function call came from resize event
     */
    _setupSlideType: function(onResize) {
      this.sliderItemWidth = Math.floor(
        this.sliderContainer.offsetWidth / this.options.slidesToShow
      );
      this.sliderTranslateXMove =
        this.sliderItemWidth * this.options.slidesToScroll;

      if (!onResize) {
        this.sliderContainer.classList.add(classes.sliderInitialized);
      }

      // Loop through all slider items
      // Set width according to the number of items to show in 1 slide
      // Set container width to accomodate all items
      this.slides.forEach(function(sliderItem, index) {
        var sliderItemLink = sliderItem.querySelector(selectors.sliderItemLink);
        sliderItem.style.width = this.sliderItemWidth + 'px';
        sliderItem.setAttribute('aria-hidden', true);
        sliderItem.setAttribute('tabindex', -1);
        this.sliderItemWidthTotal =
          this.sliderItemWidthTotal + sliderItem.offsetWidth;

        if (sliderItemLink) {
          sliderItemLink.setAttribute('tabindex', -1);
        }

        if (index < this.options.slidesToShow) {
          sliderItem.setAttribute('aria-hidden', false);
          sliderItem.classList.add(this.options.slideActiveClass);

          if (sliderItemLink) {
            sliderItemLink.setAttribute('tabindex', 0);
          }
        }
      }, this);

      this.sliderTrack.style.width =
        Math.floor(this.sliderItemWidthTotal) + 'px';
      this.sliderTrack.style.transform = 'translateX(-0px)';

      // set disabled attribute on Previous button
      if (this.buttons.length) {
        this.buttons[0].setAttribute('aria-disabled', true);
        this.buttons[1].removeAttribute('aria-disabled');
      }

      if (this.indicators.length) {
        this._setActiveIndicator(0);
      }
    },

    _onTouchStart: function() {
      this.touchStartPosition = this._getTranslateXPosition();
    },

    _onTouchMove: function(event, direction, difference) {
      // Fix touch events cause unexpected behaviour
      // when the dragging motion goes beyond the theme editor preview.
      var threshold = 80;
      if (
        Shopify.designMode &&
        (event.clientX <= threshold ||
          event.clientX >= window.innerWidth - threshold)
      ) {
        event.target.dispatchEvent(
          new MouseEvent('mouseup', {
            bubbles: true,
            cancelable: true
          })
        );
        return;
      }

      if (direction !== 'left' && direction !== 'right') return;

      this.touchMovePosition = this.touchStartPosition + difference.xPosition;

      this.sliderTrack.style.transform =
        'translateX(' + this.touchMovePosition + 'px';
    },

    _onTouchEnd: function(event, direction, difference) {
      var nextTranslateXPosition = 0;

      if (Object.keys(difference).length === 0) return;

      var slideDirection = direction === 'left' ? 'next' : '';

      if (direction === 'left') {
        if (this._isNextTranslateXLast(this.touchStartPosition)) {
          nextTranslateXPosition = this.touchStartPosition;
        } else {
          nextTranslateXPosition =
            this.touchStartPosition - this.sliderTranslateXMove;
        }
      } else {
        nextTranslateXPosition =
          this.touchStartPosition + this.sliderTranslateXMove;
        if (this._isNextTranslateXFirst(this.touchStartPosition)) {
          nextTranslateXPosition = 0;
        }
      }

      this.slideIndex = this._getNextSlideIndex(slideDirection);

      this.sliderTrack.style.transition = 'transform 500ms ease 0s';
      this.sliderTrack.style.transform =
        'translateX(' + nextTranslateXPosition + 'px';

      window.setTimeout(
        function() {
          this.sliderTrack.style.transition = '';
        }.bind(this),
        500
      );

      this._verifyFirstLastSlideTranslateX(nextTranslateXPosition);

      this._postTransitionEnd();
    },

    /**
     * Events handlers for next and previous button
     * @param {Object} event event handler
     */
    _onClickButton: function(event) {
      // prevent multiple clicks
      if (event.detail > 1) return;

      var button = event.currentTarget;
      var nextButton = button.hasAttribute(attributes.buttonNext);

      if (
        this.options.type === 'slide' &&
        button.getAttribute('aria-disabled') === 'true'
      ) {
        return;
      }

      if (this.options.autoplay && this.isAutoPlaying) {
        this.stopAutoplay();
      }

      if (nextButton) {
        this.nextSlide();
      } else {
        this.previousSlide();
      }
    },

    _onClickIndicator: function(event) {
      event.preventDefault();

      if (event.target.classList.contains(classes.indicatorActive)) return;

      if (this.options.autoplay && this.isAutoPlaying) {
        this.stopAutoplay();
      }

      this.slideIndex = Number(event.target.dataset.slideNumber);
      this.goToSlideByIndex(this.slideIndex);
    },

    goToSlideByIndex: function(index) {
      this._setPosition(index);

      if (this.options.type === 'slide' && this.sliderTrack) {
        this.sliderTrack.style.transition = 'transform 500ms ease 0s';
        var newPosition = index * this.slides[0].offsetWidth;

        this.sliderTrack.style.transform = 'translateX(-' + newPosition + 'px)';

        if (this.options.slidesToShow > 1) {
          this._verifyFirstLastSlideTranslateX(newPosition);

          if (this.buttons.length) {
            this._disableArrows();
          }

          this._setupMultipleActiveSlide(
            index,
            index + (this.options.slidesToShow - 1)
          );
        }
      }
    },

    _onKeydownIndicator: function(event) {
      if (event.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      this._onClickIndicator(event);

      this.slider.focus();
    },

    _onClickPause: function(event) {
      if (!event.currentTarget.classList.contains(classes.isPaused)) {
        event.currentTarget.classList.add(classes.isPaused);
        this.stopAutoplay();
      } else {
        event.currentTarget.classList.remove(classes.isPaused);
        this.startAutoplay();
      }
    },

    _onFocus: function() {
      this.container.addEventListener('keyup', this.eventHandlers.keyUp);
    },

    _onFocusIn: function() {
      if (this.slider.hasAttribute('aria-live')) return;

      if (this.options.autoplay && this.isAutoPlaying) {
        this.stopAutoplay();
      }

      this.slider.setAttribute('aria-live', 'polite');
    },

    _onBlur: function() {
      this.container.removeEventListener('keyup', this.eventHandlers.keyUp);
    },

    _onFocusOut: function() {
      this.slider.removeAttribute('aria-live');

      // Adding a setTimeout because everytime we focus out
      // It automatically goes to <body>
      // We want to resume autoplay when focus is outside of the slideshow container
      setTimeout(
        function() {
          if (
            !document.activeElement.closest(
              '#' + this.slider.getAttribute('id')
            )
          ) {
            if (
              this.options.autoplay &&
              !this.isAutoPlaying &&
              !this.pause.classList.contains(classes.isPaused)
            ) {
              this.startAutoplay();
            }
          }
        }.bind(this),
        this.timeout
      );
    },

    _onKeyUp: function(event) {
      switch (event.keyCode) {
        case slate.utils.keyboardKeys.LEFTARROW:
          if (!this.options.canUseKeyboardArrows) return;

          if (this.options.type === 'slide' && this.isFirstSlide) {
            return;
          }

          this.previousSlide();

          break;
        case slate.utils.keyboardKeys.RIGHTARROW:
          if (!this.options.canUseKeyboardArrows) return;

          if (this.options.type === 'slide' && this.isLastSlide) {
            return;
          }

          this.nextSlide();

          break;
        case slate.utils.keyboardKeys.ESCAPE:
          this.slider.blur();
          break;
      }
    },

    _move: function(direction) {
      if (this.options.type === 'slide') {
        this.slideIndex = this._getNextSlideIndex(direction);
        this._moveSlideshow(direction);
      } else {
        var nextSlideIndex = this._getNextSlideIndex(direction);
        this._setPosition(nextSlideIndex);
      }
    },

    _moveSlideshow: function(direction) {
      this.direction = direction;
      var valueXToMove = 0;

      // Get current position of translateX
      var currentTranslateXPosition = this._getTranslateXPosition();
      var currentActiveSlidesIndex = this._getActiveSlidesIndex();

      // In the future, we'll use ES6 deconstructure
      // Math.min(...currentActiveSlidesIndex);
      var currentActiveSlidesMinIndex = Math.min.apply(
        Math,
        currentActiveSlidesIndex
      );
      var currentActiveSlidesMaxIndex = Math.max.apply(
        Math,
        currentActiveSlidesIndex
      );

      // Set the next active state depending on the direction
      // We bump up the index depending on the "slidesToShow" option
      this.nextMinIndex =
        direction === 'next'
          ? currentActiveSlidesMinIndex + this.options.slidesToShow
          : currentActiveSlidesMinIndex - this.options.slidesToShow;
      this.nextMaxIndex =
        direction === 'next'
          ? currentActiveSlidesMaxIndex + this.options.slidesToShow
          : currentActiveSlidesMinIndex - 1;

      this.sliderTrack.style.transition = 'transform 500ms ease 0s';

      if (direction === 'next') {
        valueXToMove = currentTranslateXPosition - this.sliderTranslateXMove;
        this.sliderTrack.style.transform = 'translateX(' + valueXToMove + 'px)';
      } else {
        valueXToMove = currentTranslateXPosition + this.sliderTranslateXMove;
        this.sliderTrack.style.transform = 'translateX(' + valueXToMove + 'px)';
      }

      this._verifyFirstLastSlideTranslateX(valueXToMove);

      this._postTransitionEnd();

      this._setupMultipleActiveSlide(this.nextMinIndex, this.nextMaxIndex);
    },

    _setPosition: function(nextSlideIndex) {
      this.slideIndex = nextSlideIndex;

      if (this.indicators.length) {
        this._setActiveIndicator(nextSlideIndex);
      }

      this._setupActiveSlide(nextSlideIndex);

      if (this.options.autoplay && this.isAutoPlaying) {
        this.startAutoplay();
      }

      this.container.dispatchEvent(
        new CustomEvent('slider_slide_changed', {
          detail: nextSlideIndex
        })
      );
    },

    _setupActiveSlide: function(index) {
      this.slides.forEach(function(slide) {
        slide.setAttribute('aria-hidden', true);
        slide.classList.remove(this.options.slideActiveClass);
      }, this);

      this.slides[index].setAttribute('aria-hidden', false);
      this.slides[index].classList.add(this.options.slideActiveClass);
    },

    /**
     * Loops through all slide items
     * Set the active state depending the direction and slide indexes
     * Because slide-in effect can have multiple items in 1 slide, we need to target multiple active elements
     * @param {String} direction "next" for next slides or empty string for previous
     * @param {*} minIndex the current active minimum index
     * @param {*} maxIndex the current active maximum index
     */
    _setupMultipleActiveSlide: function(minIndex, maxIndex) {
      this.slides.forEach(function(slide) {
        var sliderIndex = Number(slide.getAttribute('data-slider-slide-index'));
        var sliderItemLink = slide.querySelector(selectors.sliderItemLink);

        slide.setAttribute('aria-hidden', true);
        slide.classList.remove(this.options.slideActiveClass);
        if (sliderItemLink) {
          sliderItemLink.setAttribute('tabindex', -1);
        }

        if (sliderIndex >= minIndex && sliderIndex <= maxIndex) {
          slide.setAttribute('aria-hidden', false);
          slide.classList.add(this.options.slideActiveClass);

          if (sliderItemLink) {
            sliderItemLink.setAttribute('tabindex', 0);
          }
        }
      }, this);
    },

    _setActiveIndicator: function(index) {
      this.indicators.forEach(function(indicatorWrapper) {
        var activeIndicator = indicatorWrapper.querySelector(
          '.' + classes.indicatorActive
        );

        var nextIndicator = indicatorWrapper.childNodes[index];

        if (activeIndicator) {
          activeIndicator.setAttribute('aria-selected', false);
          activeIndicator.classList.remove(classes.indicatorActive);
          activeIndicator.firstElementChild.removeAttribute('aria-current');
        }

        nextIndicator.classList.add(classes.indicatorActive);
        nextIndicator.setAttribute('aria-selected', true);
        nextIndicator.firstElementChild.setAttribute('aria-current', true);
      }, this);
    },

    setSlideshowHeight: function() {
      var minAspectRatio = this.sliderContainer.getAttribute(
        'data-min-aspect-ratio'
      );
      this.sliderContainer.style.height =
        document.documentElement.offsetWidth / minAspectRatio + 'px';
    },

    /**
     * Increase or decrease index position of the slideshow
     * Automatically auto-rotate
     * - Last slide goes to first slide when clicking "next"
     * - First slide goes to last slide when clicking "previous"
     * @param {String} direction "next" as a String, other empty string is previous slide
     */
    _getNextSlideIndex: function(direction) {
      var counter = direction === 'next' ? 1 : -1;

      if (direction === 'next') {
        if (this.slideIndex === this.lastSlide) {
          return this.options.type === 'slide' ? this.lastSlide : 0;
        }
      } else if (!this.slideIndex) {
        return this.options.type === 'slide' ? 0 : this.lastSlide;
      }

      return this.slideIndex + counter;
    },

    /**
     * In "slide-in" type, multiple items are active in 1 slide
     * This will return an array containing their indexes
     */
    _getActiveSlidesIndex: function() {
      var currentActiveSlides = this.slides.filter(function(sliderItem) {
        if (sliderItem.classList.contains(this.options.slideActiveClass)) {
          return sliderItem;
        }
      }, this);
      var currentActiveSlidesIndex = currentActiveSlides.map(function(
        sliderItem
      ) {
        return Number(sliderItem.getAttribute('data-slider-slide-index'));
      });

      return currentActiveSlidesIndex;
    },

    /**
     * This checks the next "translateX" value and verifies
     * If it's at the last slide or beginning of the slide
     * So we can disable the arrow buttons
     */
    _disableArrows: function() {
      if (this.buttons.length === 0) return;

      var previousButton = this.buttons[0];
      var nextButton = this.buttons[1];

      // first slide
      if (this.isFirstSlide) {
        previousButton.setAttribute('aria-disabled', true);
      } else {
        previousButton.removeAttribute('aria-disabled');
      }

      // last slide
      if (this.isLastSlide) {
        nextButton.setAttribute('aria-disabled', true);
      } else {
        nextButton.removeAttribute('aria-disabled');
      }
    },

    /**
     * Verify if translateX reaches at first or last slide
     * @param {Number} translateXValue
     */
    _verifyFirstLastSlideTranslateX: function(translateXValue) {
      // first slide
      if (this._isNextTranslateXFirst(translateXValue)) {
        this.isFirstSlide = true;
      } else {
        this.isFirstSlide = false;
      }

      // last slide
      if (this._isNextTranslateXLast(translateXValue)) {
        this.isLastSlide = true;
      } else {
        this.isLastSlide = false;
      }
    },

    _getTranslateXPosition: function() {
      return Number(this.sliderTrack.style.transform.match(/(-?[0-9]+)/g)[0]);
    },

    _isNextTranslateXFirst: function(translateXValue) {
      return translateXValue === 0;
    },

    _isNextTranslateXLast: function(translateXValue) {
      // because translateX values are using negative, I'm converting into positive value
      var translateXValueAbsolute = Math.abs(translateXValue);
      var nextTranslateXValue =
        translateXValueAbsolute + this.sliderTranslateXMove;

      return nextTranslateXValue >= this.sliderItemWidthTotal;
    },

    _postTransitionEnd: function() {
      if (this.buttons.length) {
        this._disableArrows();
      }

      if (this.indicators.length) {
        this._setActiveIndicator(this.slideIndex);
      }
    }
  });

  return Slideshow;
})();

theme.Video = (function() {
  var autoplayCheckComplete = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    scrollAnimationDuration: 400,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    backgroundVideoWrapper: 'video-background-wrapper',
    videoWithImage: 'video--image_with_play',
    backgroundVideo: 'video--background',
    userPaused: 'is-paused',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay',
    wrapperMinHeight: 'video-section-wrapper--min-height'
  };

  var selectors = {
    section: '.video-section',
    videoWrapper: '.video-section-wrapper',
    playVideoBtn: '.video-control__play',
    closeVideoBtn: '.video-control__close-wrapper',
    pauseVideoBtn: '.video__pause',
    pauseVideoStop: '.video__pause-stop',
    pauseVideoResume: '.video__pause-resume',
    fallbackText: '.icon__fallback-text'
  };

  /**
   * Public functions
   */
  function init(video) {
    if (!video) return;

    videos[video.id] = {
      id: video.id,
      videoId: video.dataset.id,
      type: video.dataset.type,
      status:
        video.dataset.type === 'image_with_play' ? 'closed' : 'background', // closed, open, background
      video: video,
      videoWrapper: video.closest(selectors.videoWrapper),
      section: video.closest(selectors.section),
      controls: video.dataset.type === 'background' ? 0 : 1
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    playOnClickCheck();
  }

  function customPlayVideo(playerId) {
    // Make sure we have carried out the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        createPlayer(key);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function editorLoadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    createPlayer(key);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var videoWrapper = videoData.videoWrapper;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || autoplayCheckComplete) {
      // Play if autoplay is available or clicked to play
      videoWrapper.classList.remove(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    } else {
      player.playVideo();
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    document.documentElement.classList.remove(
      classes.supportsAutoplay,
      classes.supportsNoAutoplay
    );
    document.documentElement.classList.add(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function playOnClickCheck() {
    if (playOnClickChecked) {
      return;
    }

    if (isMobile()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);
    var videoTitle = evt.target.getVideoData().title;
    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    document.getElementById(videoData.id).setAttribute('tabindex', '-1');

    sizeBackgroundVideos();
    setButtonLabels(videoData.videoWrapper, videoTitle);

    // Customize based on options from the video ID
    if (videoData.type === 'background') {
      evt.target.mute();
      privatePlayVideo(videoData.id);
    }

    videoData.videoWrapper.classList.add(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);
    if (
      videoData.status === 'background' &&
      !isMobile() &&
      !autoplayCheckComplete &&
      (evt.data === YT.PlayerState.PLAYING ||
        evt.data === YT.PlayerState.BUFFERING)
    ) {
      setAutoplaySupport(true);
      autoplayCheckComplete = true;
      videoData.videoWrapper.classList.remove(classes.loading);
    }
    switch (evt.data) {
      case YT.PlayerState.ENDED:
        setAsFinished(videoData);
        break;
      case YT.PlayerState.PAUSED:
        // Seeking on a YouTube video also fires a PAUSED state change,
        // checking the state after a delay prevents us pausing the video when
        // the user is seeking instead of pausing
        setTimeout(function() {
          if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
            setAsPaused(videoData);
          }
        }, 200);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'image_with_play':
        closeVideo(videoData.id);
        toggleExpandVideo(videoData.id, false);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var videoWrapper = videoData.videoWrapper;
    var pauseButton = videoWrapper.querySelector(selectors.pauseVideoBtn);

    videoWrapper.classList.remove(classes.loading);

    if (pauseButton.classList.contains(classes.userPaused)) {
      pauseButton.classList.remove(classes.userPaused);
    }

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    document.getElementById(videoData.id).setAttribute('tabindex', '0');

    if (videoData.type === 'image_with_play') {
      videoWrapper.classList.remove(classes.paused);
      videoWrapper.classList.add(classes.playing);
    }

    // Update focus to the close button so we stay within the video wrapper,
    // allowing time for the scroll animation
    setTimeout(function() {
      videoWrapper.querySelector(selectors.closeVideoBtn).focus();
    }, videoOptions.scrollAnimationDuration);
  }

  function setAsPaused(videoData) {
    var videoWrapper = videoData.videoWrapper;

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.type === 'image_with_play') {
      if (videoData.status === 'closed') {
        videoWrapper.classList.remove(classes.paused);
      } else {
        videoWrapper.classList.add(classes.paused);
      }
    }

    videoWrapper.classList.remove(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var videoWrapper = videoData.videoWrapper;

    document.getElementById(videoData.id).setAttribute('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'image_with_play':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
      case 'background':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
    }

    videoWrapper.classList.remove(classes.paused, classes.playing);
  }

  function getVideoOptions(evt) {
    var id = evt.target.getIframe().id;
    return videos[id];
  }

  function toggleExpandVideo(playerId, expand) {
    var video = videos[playerId];
    var elementTop =
      video.videoWrapper.getBoundingClientRect().top + window.pageYOffset;
    var playButton = video.videoWrapper.querySelector(selectors.playVideoBtn);
    var offset = 0;
    var newHeight = 0;

    if (isMobile()) {
      video.videoWrapper.parentElement.classList.toggle('page-width', !expand);
    }

    if (expand) {
      if (isMobile()) {
        newHeight = window.innerWidth / videoOptions.ratio;
      } else {
        newHeight = video.videoWrapper.offsetWidth / videoOptions.ratio;
      }
      offset = (window.innerHeight - newHeight) / 2;

      video.videoWrapper.style.height =
        video.videoWrapper.getBoundingClientRect().height + 'px';
      video.videoWrapper.classList.remove(classes.wrapperMinHeight);
      video.videoWrapper.style.height = newHeight + 'px';

      // Animate doesn't work in mobile editor, so we don't use it
      if (!(isMobile() && Shopify.designMode)) {
        var scrollBehavior = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = 'smooth';
        window.scrollTo({ top: elementTop - offset });
        document.documentElement.style.scrollBehavior = scrollBehavior;
      }
    } else {
      if (isMobile()) {
        newHeight = video.videoWrapper.dataset.mobileHeight;
      } else {
        newHeight = video.videoWrapper.dataset.desktopHeight;
      }

      video.videoWrapper.style.height = newHeight + 'px';

      setTimeout(function() {
        video.videoWrapper.classList.add(classes.wrapperMinHeight);
      }, 600);
      // Set focus on play button, but don't scroll page
      var x = window.scrollX;
      var y = window.scrollY;
      playButton.focus();
      window.scrollTo(x, y);
    }
  }

  function togglePause(playerId) {
    var pauseButton = videos[playerId].videoWrapper.querySelector(
      selectors.pauseVideoBtn
    );
    var paused = pauseButton.classList.contains(classes.userPaused);
    if (paused) {
      pauseButton.classList.remove(classes.userPaused);
      customPlayVideo(playerId);
    } else {
      pauseButton.classList.add(classes.userPaused);
      pauseVideo(playerId);
    }
    pauseButton.setAttribute('aria-pressed', !paused);
  }

  function startVideoOnClick(playerId) {
    var video = videos[playerId];

    // add loading class to wrapper
    video.videoWrapper.classList.add(classes.loading);

    // Explicity set the video wrapper height (needed for height transition)
    video.videoWrapper.style.height = video.videoWrapper.offsetHeight + 'px';

    video.status = 'open';

    switch (video.type) {
      case 'image_with_play':
        privatePlayVideo(playerId, true);
        break;
      case 'background':
        unsetBackgroundVideo(playerId, video);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
    }

    toggleExpandVideo(playerId, true);

    // esc to close video player
    document.addEventListener('keydown', handleVideoPlayerKeydown);
  }

  var handleVideoPlayerKeydown = function(evt) {
    var playerId = document.activeElement.dataset.controls;
    if (evt.keyCode !== slate.utils.keyboardKeys.ESCAPE || !playerId) {
      return;
    }

    closeVideo(playerId);
    toggleExpandVideo(playerId, false);
  };

  function sizeBackgroundVideos() {
    var backgroundVideos = document.querySelectorAll(
      '.' + classes.backgroundVideo
    );
    backgroundVideos.forEach(function(el) {
      sizeBackgroundVideo(el);
    });
  }

  function sizeBackgroundVideo(videoPlayer) {
    if (!youtubeLoaded) {
      return;
    }

    if (isMobile()) {
      videoPlayer.style.cssText = null;
    } else {
      var videoWrapper = videoPlayer.closest(selectors.videoWrapper);
      var videoWidth = videoWrapper.clientWidth;
      var playerWidth = videoPlayer.clientWidth;
      var desktopHeight = videoWrapper.dataset.desktopHeight;

      // when screen aspect ratio differs from video, video must center and underlay one dimension
      if (videoWidth / videoOptions.ratio < desktopHeight) {
        playerWidth = Math.ceil(desktopHeight * videoOptions.ratio); // get new player width
        var styles =
          'width: ' +
          playerWidth +
          'px; height: ' +
          desktopHeight +
          'px; left: ' +
          (videoWidth - playerWidth) / 2 +
          'px; top: 0;';
        videoPlayer.style.cssText = styles;
      } else {
        // new video width < window width (gap to right)
        desktopHeight = Math.ceil(videoWidth / videoOptions.ratio); // get new player height
        var styles2 =
          'width: ' +
          videoWidth +
          'px; height: ' +
          desktopHeight +
          'px; top: ' +
          (desktopHeight - desktopHeight) / 2 +
          'px; left: 0;'; // player height is greater, offset top; reset left
        videoPlayer.style.cssText = styles2;
      }

      theme.Helpers.prepareTransition(videoPlayer);
      videoWrapper.classList.add(classes.loaded);
    }
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background video to a chrome-only player once played
    var player = document.getElementById(playerId);
    player.classList.remove(classes.backgroundVideo);
    player.classList.add(classes.videoWithImage);

    setTimeout(function() {
      document.getElementById(playerId).style.cssText = null;
    }, 600);

    videos[playerId].videoWrapper.classList.remove(
      classes.backgroundVideoWrapper
    );
    videos[playerId].videoWrapper.classList.add(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    var player = document.getElementById(playerId);
    player.classList.remove(classes.videoWithImage);
    player.classList.add(classes.backgroundVideo);

    videos[playerId].videoWrapper.classList.add(classes.backgroundVideoWrapper);

    videos[playerId].status = 'background';
    sizeBackgroundVideo(player);
  }

  function isMobile() {
    return window.innerWidth < theme.breakpoints.medium;
  }

  var handleWindowResize = theme.Helpers.debounce(function() {
    if (!youtubeLoaded) return;
    var key;
    var fullscreen = window.innerHeight === screen.height;
    sizeBackgroundVideos();

    if (isMobile()) {
      for (key in videos) {
        if (videos.hasOwnProperty(key)) {
          if (videos[key].videoWrapper.classList.contains(classes.playing)) {
            if (!fullscreen) {
              pauseVideo(key);
              setAsPaused(videos[key]);
            }
          }
          videos[key].videoWrapper.style.height =
            document.documentElement.clientWidth / videoOptions.ratio + 'px';
        }
      }
      setAutoplaySupport(false);
    } else {
      setAutoplaySupport(true);
      for (key in videos) {
        var videosWithImage = videos[key].videoWrapper.querySelectorAll(
          '.' + classes.videoWithImage
        );
        if (videosWithImage.length) {
          continue;
        }
        videoPlayers[key].playVideo();
        setAsPlaying(videos[key]);
      }
    }
  }, 200);

  var handleWindowScroll = theme.Helpers.debounce(function() {
    if (!youtubeLoaded) return;

    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var videoWrapper = videos[key].videoWrapper;
        var condition =
          videoWrapper.getBoundingClientRect().top +
            window.pageYOffset +
            videoWrapper.offsetHeight * 0.75 <
            window.pageYOffset ||
          videoWrapper.getBoundingClientRect().top +
            window.pageYOffset +
            videoWrapper.offsetHeight * 0.25 >
            window.pageYOffset + window.innerHeight;

        // Close the video if more than 75% of it is scrolled out of view
        if (videoWrapper.classList.contains(classes.playing)) {
          if (!condition) return;
          closeVideo(key);
          toggleExpandVideo(key, false);
        }
      }
    }
  }, 50);

  function initEvents() {
    var playVideoBtns = document.querySelectorAll(selectors.playVideoBtn);
    var closeVideoBtns = document.querySelectorAll(selectors.closeVideoBtn);
    var pauseVideoBtns = document.querySelectorAll(selectors.pauseVideoBtn);

    playVideoBtns.forEach(function(btn) {
      btn.addEventListener('click', function(evt) {
        var playerId = evt.currentTarget.dataset.controls;
        startVideoOnClick(playerId);
      });
    });

    closeVideoBtns.forEach(function(btn) {
      btn.addEventListener('click', function(evt) {
        var playerId = evt.currentTarget.dataset.controls;

        evt.currentTarget.blur();
        closeVideo(playerId);
        toggleExpandVideo(playerId, false);
      });
    });

    pauseVideoBtns.forEach(function(btn) {
      btn.addEventListener('click', function(evt) {
        var playerId = evt.currentTarget.dataset.controls;
        togglePause(playerId);
      });
    });

    // Listen to resize to keep a background-size:cover-like layout
    window.addEventListener('resize', handleWindowResize);

    window.addEventListener('scroll', handleWindowScroll);
  }

  function createPlayer(key) {
    var args = Object.assign(videoOptions, videos[key]);

    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);
  }

  function removeEvents() {
    document.removeEventListener('keydown', handleVideoPlayerKeydown);
    window.removeEventListener('resize', handleWindowResize);
    window.removeEventListener('scroll', handleWindowScroll);
  }

  function setButtonLabels(videoWrapper, title) {
    var playButtons = videoWrapper.querySelectorAll(selectors.playVideoBtn);
    var closeButton = videoWrapper.querySelector(selectors.closeVideoBtn);
    var pauseButton = videoWrapper.querySelector(selectors.pauseVideoBtn);
    var closeButtonText = closeButton.querySelector(selectors.fallbackText);

    var pauseButtonStop = pauseButton.querySelector(selectors.pauseVideoStop);
    var pauseButtonStopText = pauseButtonStop.querySelector(
      selectors.fallbackText
    );

    var pauseButtonResume = pauseButton.querySelector(
      selectors.pauseVideoResume
    );
    var pauseButtonResumeText = pauseButtonResume.querySelector(
      selectors.fallbackText
    );

    // Insert the video title retrieved from YouTube into the instructional text
    // for each button
    playButtons.forEach(function(playButton) {
      var playButtonText = playButton.querySelector(selectors.fallbackText);

      playButtonText.textContent = playButtonText.textContent.replace(
        '[video_title]',
        title
      );
    });
    closeButtonText.textContent = closeButtonText.textContent.replace(
      '[video_title]',
      title
    );
    pauseButtonStopText.textContent = pauseButtonStopText.textContent.replace(
      '[video_title]',
      title
    );
    pauseButtonResumeText.textContent = pauseButtonResumeText.textContent.replace(
      '[video_title]',
      title
    );
  }

  return {
    init: init,
    editorLoadVideo: editorLoadVideo,
    loadVideos: loadVideos,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();

theme.ProductVideo = (function() {
  var videos = {};

  var hosts = {
    shopify: 'shopify',
    external: 'external'
  };

  var selectors = {
    productMediaWrapper: '[data-product-single-media-wrapper]'
  };

  var attributes = {
    enableVideoLooping: 'enable-video-looping',
    videoId: 'video-id'
  };

  function init(videoContainer, sectionId) {
    if (!videoContainer) {
      return;
    }

    var videoElement = videoContainer.querySelector('iframe, video');

    if (!videoElement) {
      return;
    }

    var mediaId = videoContainer.getAttribute('data-media-id');

    videos[mediaId] = {
      mediaId: mediaId,
      sectionId: sectionId,
      host: hostFromVideoElement(videoElement),
      container: videoContainer,
      element: videoElement,
      ready: function() {
        createPlayer(this);
      }
    };

    window.Shopify.loadFeatures([
      {
        name: 'video-ui',
        version: '2.0',
        onLoad: setupVideos
      }
    ]);
    theme.LibraryLoader.load('plyrShopifyStyles');
  }

  function setupVideos(errors) {
    if (errors) {
      fallbackToNativeVideo();
      return;
    }

    loadVideos();
  }

  function createPlayer(video) {
    if (video.player) {
      return;
    }

    var productMediaWrapper = video.container.closest(
      selectors.productMediaWrapper
    );

    var enableLooping =
      productMediaWrapper.getAttribute(
        'data-' + attributes.enableVideoLooping
      ) === 'true';

    // eslint-disable-next-line no-undef
    video.player = new Shopify.Video(video.element, {
      loop: { active: enableLooping }
    });

    var pauseVideo = function() {
      if (!video.player) return;
      video.player.pause();
    };

    productMediaWrapper.addEventListener('mediaHidden', pauseVideo);
    productMediaWrapper.addEventListener('xrLaunch', pauseVideo);

    productMediaWrapper.addEventListener('mediaVisible', function() {
      if (theme.Helpers.isTouch()) return;
      if (!video.player) return;
      video.player.play();
    });
  }

  function hostFromVideoElement(video) {
    if (video.tagName === 'VIDEO') {
      return hosts.shopify;
    }

    return hosts.external;
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];
        video.ready();
      }
    }
  }

  function fallbackToNativeVideo() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];

        if (video.nativeVideo) continue;

        if (video.host === hosts.shopify) {
          video.element.setAttribute('controls', 'controls');
          video.nativeVideo = true;
        }
      }
    }
  }

  function removeSectionVideos(sectionId) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];

        if (video.sectionId === sectionId) {
          if (video.player) video.player.destroy();
          delete videos[key];
        }
      }
    }
  }

  return {
    init: init,
    hosts: hosts,
    loadVideos: loadVideos,
    removeSectionVideos: removeSectionVideos
  };
})();

theme.ProductModel = (function() {
  var modelJsonSections = {};
  var models = {};
  var xrButtons = {};

  var selectors = {
    mediaGroup: '[data-product-single-media-group]',
    xrButton: '[data-shopify-xr]'
  };

  function init(modelViewerContainers, sectionId) {
    modelJsonSections[sectionId] = {
      loaded: false
    };

    modelViewerContainers.forEach(function(modelViewerContainer, index) {
      var mediaId = modelViewerContainer.getAttribute('data-media-id');
      var modelViewerElement = modelViewerContainer.querySelector(
        'model-viewer'
      );
      var modelId = modelViewerElement.getAttribute('data-model-id');

      if (index === 0) {
        var mediaGroup = modelViewerContainer.closest(selectors.mediaGroup);
        var xrButton = mediaGroup.querySelector(selectors.xrButton);
        xrButtons[sectionId] = {
          element: xrButton,
          defaultId: modelId
        };
      }

      models[mediaId] = {
        modelId: modelId,
        sectionId: sectionId,
        container: modelViewerContainer,
        element: modelViewerElement
      };
    });

    window.Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: setupShopifyXr
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: setupModelViewerUi
      }
    ]);
    theme.LibraryLoader.load('modelViewerUiStyles');
  }

  function setupShopifyXr(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', function() {
        setupShopifyXr();
      });
      return;
    }

    for (var sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        var modelSection = modelJsonSections[sectionId];

        if (modelSection.loaded) continue;
        var modelJson = document.querySelector('#ModelJson-' + sectionId);

        window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
        modelSection.loaded = true;
      }
    }
    window.ShopifyXR.setupXRElements();
  }

  function setupModelViewerUi(errors) {
    if (errors) return;

    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (!model.modelViewerUi) {
          model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
        }
        setupModelViewerListeners(model);
      }
    }
  }

  function setupModelViewerListeners(model) {
    var xrButton = xrButtons[model.sectionId];

    model.container.addEventListener('mediaVisible', function() {
      xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
      if (theme.Helpers.isTouch()) return;
      model.modelViewerUi.play();
    });

    model.container.addEventListener('mediaHidden', function() {
      xrButton.element.setAttribute(
        'data-shopify-model3d-id',
        xrButton.defaultId
      );
      model.modelViewerUi.pause();
    });

    model.container.addEventListener('xrLaunch', function() {
      model.modelViewerUi.pause();
    });
  }

  function removeSectionModels(sectionId) {
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (model.sectionId === sectionId) {
          models[key].modelViewerUi.destroy();
          delete models[key];
        }
      }
    }
    delete modelJsonSections[sectionId];
  }

  return {
    init: init,
    removeSectionModels: removeSectionModels
  };
})();

window.theme = window.theme || {};

theme.FormStatus = (function() {
  var selectors = {
    statusMessage: '[data-form-status]'
  };

  function init() {
    var statusMessages = document.querySelectorAll(selectors.statusMessage);

    statusMessages.forEach(function(statusMessage) {
      statusMessage.setAttribute('tabindex', -1);
      statusMessage.focus();

      statusMessage.addEventListener(
        'blur',
        function(evt) {
          evt.target.removeAttribute('tabindex');
        },
        { once: true }
      );
    });
  }

  return {
    init: init
  };
})();

theme.Hero = (function() {
  var classes = {
    indexSectionFlush: 'index-section--flush'
  };

  var selectors = {
    heroFixedWidthContent: '.hero-fixed-width__content',
    heroFixedWidthImage: '.hero-fixed-width__image'
  };

  function hero(el, sectionId) {
    var hero = document.querySelector(el);
    var layout = hero.getAttribute('data-layout');
    var parentSection = document.querySelector('#shopify-section-' + sectionId);
    var heroContent = parentSection.querySelector(
      selectors.heroFixedWidthContent
    );
    var heroImage = parentSection.querySelector(selectors.heroFixedWidthImage);

    if (layout !== 'fixed_width') {
      return;
    }

    parentSection.classList.remove(classes.indexSectionFlush);
    heroFixedHeight();

    window.addEventListener('resize', function() {
      theme.Helpers.debounce(function() {
        heroFixedHeight();
      }, 50);
    });

    function heroFixedHeight() {
      var contentHeight;
      var imageHeight;

      if (heroContent) {
        contentHeight = heroContent.offsetHeight + 50;
      }

      if (heroImage) {
        imageHeight = heroImage.offsetHeight;
      }

      if (contentHeight > imageHeight) {
        heroImage.style.minHeight = contentHeight + 'px';
      }
    }
  }

  return hero;
})();

// prettier-ignore
window.theme = window.theme || {};

theme.SearchResultsTemplate = (function() {
  function renderResults(products, isLoading, searchQuery) {
    return [
      '<div class="predictive-search">',
      renderHeader(products, isLoading),
      renderProducts(products, searchQuery),
      '</div>'
    ].join('');
  }

  function renderHeader(products, isLoading) {
    if (products.length === 0) {
      return '';
    }

    return [
      '<div class="predictive-search-title">',
      '<h3 id="predictive-search" class="predictive-search-title__content">' +
        theme.strings.products +
        '</h3>',
      '<span class="predictive-search-title__loading-spinner">' +
        (isLoading
          ? '<span class= "icon-predictive-search-spinner" ></span >'
          : '') +
        '</span>',
      '</div>'
    ].join('');
  }

  function loadingState() {
    return [
      '<div class="predictive-search">',
      '<div class="predictive-search-loading">',
      '<span class="visually-hidden">' + theme.strings.loading + '</span>',
      '<span class="predictive-search-loading__icon">',
      '<span class="icon-predictive-search-spinner"></span>',
      '</span>',
      '</div>',
      '</div>'
    ].join('');
  }

  function renderViewAll(searchQuery) {
    return [
      '<button type="submit" class="predictive-search-view-all__button" tabindex="-1">',
      theme.strings.searchFor +
        '<span class="predictive-search-view-all__query"> &ldquo;' +
        _htmlEscape(searchQuery) +
        '&rdquo;</span>',
      '</button>'
    ].join('');
  }

  function renderProducts(products, searchQuery) {
    var resultsCount = products.length;

    return [
      '<ul id="predictive-search-results" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">',
      products
        .map(function(product, index) {
          return renderProduct(normalizeProduct(product), index, resultsCount);
        })
        .join(''),
      '<li id="search-all" class="predictive-search-view-all" role="option" data-search-result>' +
        renderViewAll(searchQuery) +
        '</li>',
      '</ul>'
    ].join('');
  }

  function renderProduct(product, index, resultsCount) {
    return [
      '<li id="search-result-' +
        index +
        '" class="predictive-search-item" role="option" data-search-result>',
      '<a class="predictive-search-item__link" href="' +
        product.url +
        '" tabindex="-1">',
      '<div class="predictive-search__column predictive-search__column--image" data-image-loading-animation>',
      renderProductImage(product),
      '</div>',
      '<div class="predictive-search__column predictive-search__column--content ' +
        (getDetailsCount() ? '' : 'predictive-search__column--center') +
        '">',
      '<span class="predictive-search-item__title">',
      '<span class="predictive-search-item__title-text">' +
        product.title +
        '</span>',
      '</span>' + (getDetailsCount() ? renderProductDetails(product) : ''),
      '<span class="visually-hidden">, </span>',
      '<span class="visually-hidden">' +
        getNumberOfResultsString(index + 1, resultsCount) +
        '</span>',
      '</div>',
      '</a>',
      '</li>'
    ].join('');
  }

  function renderProductImage(product) {
    if (product.image === null) {
      return '';
    }

    return (
      '<img class="predictive-search-item__image lazyload" src="' +
      product.image.url +
      '" data-src="' +
      product.image.url +
      '" data-image alt="' +
      product.image.alt +
      '" />'
    );
  }

  function renderProductDetails(product) {
    return [
      '<dl class="predictive-search-item__details price' +
        (product.isOnSale ? ' price--on-sale' : '') +
        (!product.available ? ' price--sold-out' : '') +
        (!product.isPriceVaries && product.isCompareVaries
          ? ' price--compare-price-hidden'
          : '') +
        '">',
      '<div class="predictive-search-item__detail">',
      renderVendor(product),
      '</div>',
      '<div class="predictive-search-item__detail predictive-search-item__detail--inline">' +
        renderProductPrice(product),
      '</div>',
      '</dl>'
    ].join('');
  }
  function renderProductPrice(product) {
    if (!theme.settings.predictiveSearchShowPrice) {
      return '';
    }

    var accessibilityAnnounceComma = '<span class="visually-hidden">, </span>';

    var priceMarkup =
      '<div class="price__regular">' + renderPrice(product) + '</div>';

    var salePriceMarkup =
      '<div class="price__sale">' + renderSalePrice(product) + '</div>';

    return (
      accessibilityAnnounceComma +
      '<div class="price__pricing-group">' +
      (product.isOnSale ? salePriceMarkup : priceMarkup) +
      '</div>'
    );
  }

  function renderSalePrice(product) {
    return [
      '<dt>',
      '<span class="visually-hidden">' + theme.strings.salePrice + '</span>',
      '</dt>',
      '<dd>',
      '<span class="predictive-search-item__price predictive-search-item__price--sale">' +
        (product.isPriceVaries
          ? theme.strings.fromLowestPrice.replace('[price]', product.price)
          : product.price) +
        '</span>',
      '</dd>',
      '<div class="price__compare">' + renderCompareAtPrice(product) + '</div>'
    ].join('');
  }

  function renderCompareAtPrice(product) {
    return [
      '<dt>',
      '<span class="visually-hidden">' +
        theme.strings.regularPrice +
        '</span> ',
      '</dt>',
      '<dd>',
      '<span class="predictive-search-item__price predictive-search-item__price--compare">' +
        product.compareAtPrice +
        '</span>',
      '</dd>'
    ].join('');
  }

  function renderPrice(product) {
    return [
      '<dt>',
      '<span class="visually-hidden">' + theme.strings.regularPrice + '</span>',
      '</dt>',
      '<dd>',
      '<span class="predictive-search-item__price">' +
        (product.isPriceVaries
          ? theme.strings.fromLowestPrice.replace('[price]', product.price)
          : product.price) +
        '</span>',
      '</dd>'
    ].join('');
  }

  function renderVendor(product) {
    if (!theme.settings.predictiveSearchShowVendor || product.vendor === '') {
      return '';
    }

    return [
      '<dt>',
      '<span class="visually-hidden">' + theme.strings.vendor + '</span>',
      '</dt>',
      '<dd class="predictive-search-item__vendor">' + product.vendor + '</dd>'
    ].join('');
  }

  function normalizeProduct(product) {
    var productOrVariant =
      product.variants.length > 0 ? product.variants[0] : product;

    return {
      url: productOrVariant.url,
      image: getProductImage(product),
      title: product.title,
      vendor: product.vendor || '',
      price: theme.Currency.formatMoney(product.price_min, theme.moneyFormat),
      compareAtPrice: theme.Currency.formatMoney(
        product.compare_at_price_min,
        theme.moneyFormat
      ),
      available: product.available,
      isOnSale: isOnSale(product),
      isPriceVaries: isPriceVaries(product),
      isCompareVaries: isCompareVaries(product)
    };
  }

  function getProductImage(product) {
    var image;
    var featuredImage;

    if (product.variants.length > 0 && product.variants[0].image !== null) {
      featuredImage = product.variants[0].featured_image;
    } else if (product.image) {
      featuredImage = product.featured_image;
    } else {
      image = null;
    }

    if (image !== null) {
      image = {
        url: theme.Images.getSizedImageUrl(featuredImage.url, '100x'),
        alt: featuredImage.alt
      };
    }

    return image;
  }

  function isOnSale(product) {
    return (
      product.compare_at_price_min !== null &&
      parseInt(product.compare_at_price_min, 10) >
        parseInt(product.price_min, 10)
    );
  }

  function isPriceVaries(product) {
    return product.price_max !== product.price_min;
  }

  function isCompareVaries(product) {
    return product.compare_at_price_max !== product.compare_at_price_min;
  }

  // Returns the number of optional product details to be shown,
  // values of the detailsList need to be boolean.
  function getDetailsCount() {
    var detailsList = [
      theme.settings.predictiveSearchShowPrice,
      theme.settings.predictiveSearchShowVendor
    ];

    var detailsCount = detailsList.reduce(function(acc, detail) {
      return acc + (detail ? 1 : 0);
    }, 0);

    return detailsCount;
  }

  function getNumberOfResultsString(resultNumber, resultsCount) {
    return theme.strings.number_of_results
      .replace('[result_number]', resultNumber)
      .replace('[results_count]', resultsCount);
  }

  function _htmlEscape(input) {
    return input
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  return function(data) {
    var products = data.products || [];
    var isLoading = data.isLoading;
    var searchQuery = data.searchQuery || '';

    if (isLoading && products.length === 0) {
      return loadingState();
    }

    return renderResults(products, isLoading, searchQuery);
  };
})();

window.theme = window.theme || {};

(function() {
  // (a11y) This function will be used by the Predictive Search Component
  // to announce the number of search results
  function numberOfResultsTemplateFct(data) {
    if (data.products.length === 1) {
      return theme.strings.one_result_found;
    } else {
      return theme.strings.number_of_results_found.replace(
        '[results_count]',
        data.products.length
      );
    }
  }

  // (a11y) This function will be used by the Predictive Search Component
  // to announce that it's loading results
  function loadingResultsMessageTemplateFct() {
    return theme.strings.loading;
  }

  function isPredictiveSearchSupported() {
    var shopifyFeatures = JSON.parse(
      document.getElementById('shopify-features').textContent
    );

    return shopifyFeatures.predictiveSearch;
  }

  function isPredictiveSearchEnabled() {
    return window.theme.settings.predictiveSearchEnabled;
  }

  function canInitializePredictiveSearch() {
    return isPredictiveSearchSupported() && isPredictiveSearchEnabled();
  }

  // listen for search submits and validate query
  function validateSearchHandler(searchEl, submitEl) {
    submitEl.addEventListener(
      'click',
      validateSearchInput.bind(this, searchEl)
    );
  }

  // if there is nothing in the search field, prevent submit
  function validateSearchInput(searchEl, evt) {
    var isInputValueEmpty = searchEl.value.trim().length === 0;
    if (!isInputValueEmpty) {
      return;
    }

    if (typeof evt !== 'undefined') {
      evt.preventDefault();
    }

    searchEl.focus();
  }

  window.theme.SearchPage = (function() {
    var selectors = {
      searchReset: '[data-search-page-predictive-search-clear]',
      searchInput: '[data-search-page-predictive-search-input]',
      searchSubmit: '[data-search-page-predictive-search-submit]',
      searchResults: '[data-predictive-search-mount="default"]'
    };

    var componentInstance;

    function init(config) {
      var searchInput = document.querySelector(selectors.searchInput);
      var searchSubmit = document.querySelector(selectors.searchSubmit);
      var searchUrl = searchInput.dataset.baseUrl;

      componentInstance = new window.Shopify.theme.PredictiveSearchComponent({
        selectors: {
          input: selectors.searchInput,
          reset: selectors.searchReset,
          result: selectors.searchResults
        },
        searchUrl: searchUrl,
        resultTemplateFct: window.theme.SearchResultsTemplate,
        numberOfResultsTemplateFct: numberOfResultsTemplateFct,
        loadingResultsMessageTemplateFct: loadingResultsMessageTemplateFct,
        onOpen: function(nodes) {
          if (config.isTabletAndUp) {
            return;
          }

          var searchInputBoundingRect = searchInput.getBoundingClientRect();
          var bodyHeight = document.body.offsetHeight;
          var offset = 50;
          var resultsMaxHeight =
            bodyHeight - searchInputBoundingRect.bottom - offset;

          nodes.result.style.maxHeight = resultsMaxHeight + 'px';
        },
        onBeforeDestroy: function(nodes) {
          // If the viewport width changes from mobile to tablet
          // reset the top position of the results
          nodes.result.style.maxHeight = '';
        }
      });

      validateSearchHandler(searchInput, searchSubmit);
    }

    function unload() {
      if (!componentInstance) {
        return;
      }
      componentInstance.destroy();
      componentInstance = null;
    }

    return {
      init: init,
      unload: unload
    };
  })();

  window.theme.SearchHeader = (function() {
    var selectors = {
      searchInput: '[data-predictive-search-drawer-input]',
      searchResults: '[data-predictive-search-mount="drawer"]',
      searchFormContainer: '[data-search-form-container]',
      searchSubmit: '[data-search-form-submit]'
    };

    var componentInstance;

    function init(config) {
      var searchInput = document.querySelector(selectors.searchInput);
      var searchSubmit = document.querySelector(selectors.searchSubmit);
      var searchUrl = searchInput.dataset.baseUrl;

      componentInstance = new window.Shopify.theme.PredictiveSearchComponent({
        selectors: {
          input: selectors.searchInput,
          result: selectors.searchResults
        },
        searchUrl: searchUrl,
        resultTemplateFct: window.theme.SearchResultsTemplate,
        numberOfResultsTemplateFct: numberOfResultsTemplateFct,
        numberOfResults: config.numberOfResults,
        loadingResultsMessageTemplateFct: loadingResultsMessageTemplateFct,
        onInputBlur: function() {
          return false;
        },
        onOpen: function(nodes) {
          var searchInputBoundingRect = searchInput.getBoundingClientRect();

          // For tablet screens and up, stop the scroll area from extending past
          // the bottom of the screen because we're locking the body scroll
          var maxHeight =
            window.innerHeight -
            searchInputBoundingRect.bottom -
            (config.isTabletAndUp ? 20 : 0);

          nodes.result.style.top = config.isTabletAndUp
            ? ''
            : searchInputBoundingRect.bottom + 'px';
          nodes.result.style.maxHeight = maxHeight + 'px';
        },
        onClose: function(nodes) {
          nodes.result.style.maxHeight = '';
        },
        onBeforeDestroy: function(nodes) {
          // If the viewport width changes from mobile to tablet
          // reset the top position of the results
          nodes.result.style.top = '';
        }
      });

      validateSearchHandler(searchInput, searchSubmit);
    }

    function unload() {
      if (!componentInstance) {
        return;
      }

      componentInstance.destroy();
      componentInstance = null;
    }

    function clearAndClose() {
      if (!componentInstance) {
        return;
      }

      componentInstance.clearAndClose();
    }

    return {
      init: init,
      unload: unload,
      clearAndClose: clearAndClose
    };
  })();

  window.theme.Search = (function() {
    var classes = {
      searchTemplate: 'template-search'
    };
    var selectors = {
      siteHeader: '.site-header'
    };
    var mediaQueryList = {
      mobile: window.matchMedia('(max-width: 749px)'),
      tabletAndUp: window.matchMedia('(min-width: 750px)')
    };

    function init() {
      if (!document.querySelector(selectors.siteHeader)) {
        return;
      }

      if (!canInitializePredictiveSearch()) {
        return;
      }

      Object.keys(mediaQueryList).forEach(function(device) {
        mediaQueryList[device].addListener(initSearchAccordingToViewport);
      });

      initSearchAccordingToViewport();
    }

    function initSearchAccordingToViewport() {
      theme.SearchDrawer.close();
      theme.SearchHeader.unload();
      theme.SearchPage.unload();

      if (mediaQueryList.mobile.matches) {
        theme.SearchHeader.init({
          numberOfResults: 4,
          isTabletAndUp: false
        });

        if (isSearchPage()) {
          theme.SearchPage.init({ isTabletAndUp: false });
        }
      } else {
        // Tablet and up
        theme.SearchHeader.init({
          numberOfResults: 4,
          isTabletAndUp: true
        });

        if (isSearchPage()) {
          theme.SearchPage.init({ isTabletAndUp: true });
        }
      }
    }

    function isSearchPage() {
      return document.body.classList.contains(classes.searchTemplate);
    }

    function unload() {
      theme.SearchHeader.unload();
      theme.SearchPage.unload();
    }

    return {
      init: init,
      unload: unload
    };
  })();
})();

window.theme = window.theme || {};

theme.SearchDrawer = (function() {
  var selectors = {
    headerSection: '[data-header-section]',
    drawer: '[data-predictive-search-drawer]',
    drawerOpenButton: '[data-predictive-search-open-drawer]',
    headerSearchInput: '[data-predictive-search-drawer-input]',
    predictiveSearchWrapper: '[data-predictive-search-mount="drawer"]'
  };

  var drawerInstance;

  function init() {
    setAccessibilityProps();

    drawerInstance = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: function() {
        setHeight();
        theme.MobileNav.closeMobileNav();
        lockBodyScroll();
      },
      onDrawerClose: function() {
        theme.SearchHeader.clearAndClose();
        var drawerOpenButton = document.querySelector(
          selectors.drawerOpenButton
        );

        if (drawerOpenButton) drawerOpenButton.focus();

        unlockBodyScroll();
      },
      withPredictiveSearch: true,
      elementToFocusOnOpen: document.querySelector(selectors.headerSearchInput)
    });
  }

  function setAccessibilityProps() {
    var drawerOpenButton = document.querySelector(selectors.drawerOpenButton);

    if (drawerOpenButton) {
      drawerOpenButton.setAttribute('aria-controls', 'SearchDrawer');
      drawerOpenButton.setAttribute('aria-expanded', 'false');
      drawerOpenButton.setAttribute('aria-controls', 'dialog');
    }
  }

  function setHeight() {
    var searchDrawer = document.querySelector(selectors.drawer);
    var headerHeight = document.querySelector(selectors.headerSection)
      .offsetHeight;

    searchDrawer.style.height = headerHeight + 'px';
  }

  function close() {
    drawerInstance.close();
  }

  function lockBodyScroll() {
    theme.Helpers.enableScrollLock();
  }

  function unlockBodyScroll() {
    theme.Helpers.disableScrollLock();
  }

  return {
    init: init,
    close: close
  };
})();

theme.Disclosure = (function() {
  var selectors = {
    disclosureForm: '[data-disclosure-form]',
    disclosureList: '[data-disclosure-list]',
    disclosureToggle: '[data-disclosure-toggle]',
    disclosureInput: '[data-disclosure-input]',
    disclosureOptions: '[data-disclosure-option]'
  };

  var classes = {
    listVisible: 'disclosure-list--visible'
  };

  function Disclosure(disclosure) {
    this.container = disclosure;
    this._cacheSelectors();
    this._setupListeners();
  }

  Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
    _cacheSelectors: function() {
      this.cache = {
        disclosureForm: this.container.closest(selectors.disclosureForm),
        disclosureList: this.container.querySelector(selectors.disclosureList),
        disclosureToggle: this.container.querySelector(
          selectors.disclosureToggle
        ),
        disclosureInput: this.container.querySelector(
          selectors.disclosureInput
        ),
        disclosureOptions: this.container.querySelectorAll(
          selectors.disclosureOptions
        )
      };
    },

    _setupListeners: function() {
      this.eventHandlers = this._setupEventHandlers();

      this.cache.disclosureToggle.addEventListener(
        'click',
        this.eventHandlers.toggleList
      );

      this.cache.disclosureOptions.forEach(function(disclosureOption) {
        disclosureOption.addEventListener(
          'click',
          this.eventHandlers.connectOptions
        );
      }, this);

      this.container.addEventListener(
        'keyup',
        this.eventHandlers.onDisclosureKeyUp
      );

      this.cache.disclosureList.addEventListener(
        'focusout',
        this.eventHandlers.onDisclosureListFocusOut
      );

      this.cache.disclosureToggle.addEventListener(
        'focusout',
        this.eventHandlers.onDisclosureToggleFocusOut
      );

      document.body.addEventListener('click', this.eventHandlers.onBodyClick);
    },

    _setupEventHandlers: function() {
      return {
        connectOptions: this._connectOptions.bind(this),
        toggleList: this._toggleList.bind(this),
        onBodyClick: this._onBodyClick.bind(this),
        onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
        onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
        onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
      };
    },

    _connectOptions: function(event) {
      event.preventDefault();

      this._submitForm(event.currentTarget.dataset.value);
    },

    _onDisclosureToggleFocusOut: function(event) {
      var disclosureLostFocus =
        this.container.contains(event.relatedTarget) === false;

      if (disclosureLostFocus) {
        this._hideList();
      }
    },

    _onDisclosureListFocusOut: function(event) {
      var childInFocus = event.currentTarget.contains(event.relatedTarget);

      var isVisible = this.cache.disclosureList.classList.contains(
        classes.listVisible
      );

      if (isVisible && !childInFocus) {
        this._hideList();
      }
    },

    _onDisclosureKeyUp: function(event) {
      if (event.which !== slate.utils.keyboardKeys.ESCAPE) return;
      this._hideList();
      this.cache.disclosureToggle.focus();
    },

    _onBodyClick: function(event) {
      var isOption = this.container.contains(event.target);
      var isVisible = this.cache.disclosureList.classList.contains(
        classes.listVisible
      );

      if (isVisible && !isOption) {
        this._hideList();
      }
    },

    _submitForm: function(value) {
      this.cache.disclosureInput.value = value;
      this.cache.disclosureForm.submit();
    },

    _hideList: function() {
      this.cache.disclosureList.classList.remove(classes.listVisible);
      this.cache.disclosureToggle.setAttribute('aria-expanded', false);
    },

    _toggleList: function() {
      var ariaExpanded =
        this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
      this.cache.disclosureList.classList.toggle(classes.listVisible);
      this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
    },

    destroy: function() {
      this.cache.disclosureToggle.removeEventListener(
        'click',
        this.eventHandlers.toggleList
      );

      this.cache.disclosureOptions.forEach(function(disclosureOption) {
        disclosureOption.removeEventListener(
          'click',
          this.eventHandlers.connectOptions
        );
      }, this);

      this.container.removeEventListener(
        'keyup',
        this.eventHandlers.onDisclosureKeyUp
      );

      this.cache.disclosureList.removeEventListener(
        'focusout',
        this.eventHandlers.onDisclosureListFocusOut
      );

      this.cache.disclosureToggle.removeEventListener(
        'focusout',
        this.eventHandlers.onDisclosureToggleFocusOut
      );

      document.body.removeEventListener(
        'click',
        this.eventHandlers.onBodyClick
      );
    }
  });

  return Disclosure;
})();

theme.Zoom = (function() {
  var selectors = {
    imageZoom: '[data-image-zoom]'
  };

  var classes = {
    zoomImg: 'zoomImg'
  };

  var attributes = {
    imageZoomTarget: 'data-image-zoom-target'
  };

  function Zoom(container) {
    this.container = container;
    this.cache = {};
    this.url = container.dataset.zoom;

    this._cacheSelectors();

    if (!this.cache.sourceImage) return;

    this._duplicateImage();
  }

  Zoom.prototype = Object.assign({}, Zoom.prototype, {
    _cacheSelectors: function() {
      this.cache = {
        sourceImage: this.container.querySelector(selectors.imageZoom)
      };
    },

    _init: function() {
      var targetWidth = this.cache.targetImage.width;
      var targetHeight = this.cache.targetImage.height;

      if (this.cache.sourceImage === this.cache.targetImage) {
        this.sourceWidth = targetWidth;
        this.sourceHeight = targetHeight;
      } else {
        this.sourceWidth = this.cache.sourceImage.width;
        this.sourceHeight = this.cache.sourceImage.height;
      }

      this.xRatio =
        (this.cache.sourceImage.width - targetWidth) / this.sourceWidth;
      this.yRatio =
        (this.cache.sourceImage.height - targetHeight) / this.sourceHeight;
    },

    _start: function(e) {
      this._init();
      this._move(e);
    },

    _stop: function() {
      this.cache.targetImage.style.opacity = 0;
    },

    /**
     * Sets the correct coordinates top and left position in px
     * It sets a limit within between 0 and the max height of the image
     * So when the mouse leaves the target image, it could
     * never go above or beyond the target image zone
     */
    _setTopLeftMaxValues: function(top, left) {
      return {
        left: Math.max(Math.min(left, this.sourceWidth), 0),
        top: Math.max(Math.min(top, this.sourceHeight), 0)
      };
    },

    _move: function(e) {
      // get left and top position within the "source image" zone
      var left =
        e.pageX -
        (this.cache.sourceImage.getBoundingClientRect().left + window.scrollX);
      var top =
        e.pageY -
        (this.cache.sourceImage.getBoundingClientRect().top + window.scrollY);
      // make sure the left and top position don't go
      // above or beyond the target image zone
      var position = this._setTopLeftMaxValues(top, left);

      top = position.top;
      left = position.left;

      this.cache.targetImage.style.left = -(left * -this.xRatio) + 'px';
      this.cache.targetImage.style.top = -(top * -this.yRatio) + 'px';
      this.cache.targetImage.style.opacity = 1;
    },

    /**
     * This loads a high resolution image
     * via the data attributes url
     * It adds all necessary CSS styles and adds to the container
     */
    _duplicateImage: function() {
      this._loadImage()
        .then(
          function(image) {
            this.cache.targetImage = image;
            image.style.width = image.width + 'px';
            image.style.height = image.height + 'px';
            image.style.position = 'absolute';
            image.style.maxWidth = 'none';
            image.style.maxHeight = 'none';
            image.style.opacity = 0;
            image.style.border = 'none';
            image.style.left = 0;
            image.style.top = 0;

            this.container.appendChild(image);

            this._init();

            this._start = this._start.bind(this);
            this._stop = this._stop.bind(this);
            this._move = this._move.bind(this);

            this.container.addEventListener('mouseenter', this._start);
            this.container.addEventListener('mouseleave', this._stop);
            this.container.addEventListener('mousemove', this._move);

            this.container.style.position = 'relative';
            this.container.style.overflow = 'hidden';
          }.bind(this)
        )
        .catch(function(error) {
          // eslint-disable-next-line no-console
          console.warn('Error fetching image', error);
        });
    },

    _loadImage: function() {
      // eslint-disable-next-line
      return new Promise(function(resolve, reject) {
          var image = new Image();
          image.setAttribute('role', 'presentation');
          image.setAttribute(attributes.imageZoomTarget, true);
          image.classList.add(classes.zoomImg);
          image.src = this.url;

          image.addEventListener('load', function() {
            resolve(image);
          });

          image.addEventListener('error', function(error) {
            reject(error);
          });
        }.bind(this)
      );
    },

    unload: function() {
      var targetImage = this.container.querySelector(
        '[' + attributes.imageZoomTarget + ']'
      );
      if (targetImage) {
        targetImage.remove();
      }

      this.container.removeEventListener('mouseenter', this._start);
      this.container.removeEventListener('mouseleave', this._stop);
      this.container.removeEventListener('mousemove', this._move);
    }
  });

  return Zoom;
})();


/* ================ TEMPLATES ================ */
(function() {
  var filterBys = document.querySelectorAll('[data-blog-tag-filter]');

  if (!filterBys.length) return;

  slate.utils.resizeSelects(filterBys);

  filterBys.forEach(function(filterBy) {
    filterBy.addEventListener('change', function(evt) {
      location.href = evt.target.value;
    });
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function() {
  var selectors = {
    RecoverHeading: '#RecoverHeading',
    RecoverEmail: '#RecoverEmail',
    LoginHeading: '#LoginHeading'
  };

  function initEventListeners() {
    this.recoverHeading = document.querySelector(selectors.RecoverHeading);
    this.recoverEmail = document.querySelector(selectors.RecoverEmail);
    this.loginHeading = document.querySelector(selectors.LoginHeading);
    var recoverPassword = document.getElementById('RecoverPassword');
    var hideRecoverPasswordLink = document.getElementById(
      'HideRecoverPasswordLink'
    );

    // Show reset password form
    if (recoverPassword) {
      recoverPassword.addEventListener(
        'click',
        function(evt) {
          evt.preventDefault();
          showRecoverPasswordForm();
          this.recoverHeading.setAttribute('tabindex', '-1');
          this.recoverHeading.focus();
        }.bind(this)
      );
    }

    // Hide reset password form
    if (hideRecoverPasswordLink) {
      hideRecoverPasswordLink.addEventListener(
        'click',
        function(evt) {
          evt.preventDefault();
          hideRecoverPasswordForm();
          this.loginHeading.setAttribute('tabindex', '-1');
          this.loginHeading.focus();
        }.bind(this)
      );
    }

    if (this.recoverHeading) {
      this.recoverHeading.addEventListener('blur', function(evt) {
        evt.target.removeAttribute('tabindex');
      });
    }

    if (this.loginHeading) {
      this.loginHeading.addEventListener('blur', function(evt) {
        evt.target.removeAttribute('tabindex');
      });
    }
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */

  function showRecoverPasswordForm() {
    document.getElementById('RecoverPasswordForm').classList.remove('hide');
    document.getElementById('CustomerLoginForm').classList.add('hide');

    if (this.recoverEmail.getAttribute('aria-invalid') === 'true') {
      this.recoverEmail.focus();
    }
  }

  function hideRecoverPasswordForm() {
    document.getElementById('RecoverPasswordForm').classList.add('hide');
    document.getElementById('CustomerLoginForm').classList.remove('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var formState = document.querySelector('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!formState) {
      return;
    }

    // show success message
    var resetSuccess = document.getElementById('ResetSuccess');
    resetSuccess.classList.remove('hide');
    resetSuccess.focus();
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var newAddressForm = document.getElementById('AddressNewForm');
    var newAddressFormButton = document.getElementById('AddressNewButton');

    if (!newAddressForm) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    document
      .querySelectorAll('.address-country-option')
      .forEach(function(option) {
        var formId = option.dataset.formId;
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;

        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector
        });
      });

    // Toggle new/edit address forms
    document.querySelectorAll('.address-new-toggle').forEach(function(button) {
      button.addEventListener('click', function() {
        var isExpanded =
          newAddressFormButton.getAttribute('aria-expanded') === 'true';

        newAddressForm.classList.toggle('hide');
        newAddressFormButton.setAttribute('aria-expanded', !isExpanded);
        newAddressFormButton.focus();
      });
    });

    document.querySelectorAll('.address-edit-toggle').forEach(function(button) {
      button.addEventListener('click', function(evt) {
        var formId = evt.target.dataset.formId;
        var editButton = document.getElementById('EditFormButton_' + formId);
        var editAddress = document.getElementById('EditAddress_' + formId);
        var isExpanded = editButton.getAttribute('aria-expanded') === 'true';

        editAddress.classList.toggle('hide');
        editButton.setAttribute('aria-expanded', !isExpanded);
        editButton.focus();
      });
    });

    document.querySelectorAll('.address-delete').forEach(function(button) {
      button.addEventListener('click', function(evt) {
        var target = evt.target.dataset.target;
        var confirmMessage = evt.target.dataset.confirmMessage;

        // eslint-disable-next-line no-alert
        if (
          confirm(
            confirmMessage || 'Are you sure you wish to delete this address?'
          )
        ) {
          Shopify.postLink(target, {
            parameters: { _method: 'delete' }
          });
        }
      });
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      showRecoverPasswordForm.bind(this)();
    }
  }

  return {
    init: function() {
      initEventListeners();
      checkUrlHash();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    cartCount: '[data-cart-count]',
    cartCountBubble: '[data-cart-count-bubble]',
    cartDiscount: '[data-cart-discount]',
    cartDiscountTitle: '[data-cart-discount-title]',
    cartDiscountAmount: '[data-cart-discount-amount]',
    cartDiscountWrapper: '[data-cart-discount-wrapper]',
    cartErrorMessage: '[data-cart-error-message]',
    cartErrorMessageWrapper: '[data-cart-error-message-wrapper]',
    cartItem: '[data-cart-item]',
    cartItemDetails: '[data-cart-item-details]',
    cartItemDiscount: '[data-cart-item-discount]',
    cartItemDiscountedPriceGroup: '[data-cart-item-discounted-price-group]',
    cartItemDiscountTitle: '[data-cart-item-discount-title]',
    cartItemDiscountAmount: '[data-cart-item-discount-amount]',
    cartItemDiscountList: '[data-cart-item-discount-list]',
    cartItemFinalPrice: '[data-cart-item-final-price]',
    cartItemImage: '[data-cart-item-image]',
    cartItemLinePrice: '[data-cart-item-line-price]',
    cartItemOriginalPrice: '[data-cart-item-original-price]',
    cartItemPrice: '[data-cart-item-price]',
    cartItemPriceList: '[data-cart-item-price-list]',
    cartItemProperty: '[data-cart-item-property]',
    cartItemPropertyName: '[data-cart-item-property-name]',
    cartItemPropertyValue: '[data-cart-item-property-value]',
    cartItemRegularPriceGroup: '[data-cart-item-regular-price-group]',
    cartItemRegularPrice: '[data-cart-item-regular-price]',
    cartItemTitle: '[data-cart-item-title]',
    cartItemOption: '[data-cart-item-option]',
    cartItemSellingPlanName: '[data-cart-item-selling-plan-name]',
    cartLineItems: '[data-cart-line-items]',
    cartNote: '[data-cart-notes]',
    cartQuantityErrorMessage: '[data-cart-quantity-error-message]',
    cartQuantityErrorMessageWrapper:
      '[data-cart-quantity-error-message-wrapper]',
    cartRemove: '[data-cart-remove]',
    cartStatus: '[data-cart-status]',
    cartSubtotal: '[data-cart-subtotal]',
    cartTableCell: '[data-cart-table-cell]',
    cartWrapper: '[data-cart-wrapper]',
    emptyPageContent: '[data-empty-page-content]',
    quantityInput: '[data-quantity-input]',
    quantityInputMobile: '[data-quantity-input-mobile]',
    quantityInputDesktop: '[data-quantity-input-desktop]',
    quantityLabelMobile: '[data-quantity-label-mobile]',
    quantityLabelDesktop: '[data-quantity-label-desktop]',
    inputQty: '[data-quantity-input]',
    thumbnails: '.cart__image',
    unitPrice: '[data-unit-price]',
    unitPriceBaseUnit: '[data-unit-price-base-unit]',
    unitPriceGroup: '[data-unit-price-group]'
  };

  var classes = {
    cartNoCookies: 'cart--no-cookies',
    cartRemovedProduct: 'cart__removed-product',
    thumbnails: 'cart__image',
    hide: 'hide',
    inputError: 'input--error'
  };

  var attributes = {
    cartItemIndex: 'data-cart-item-index',
    cartItemKey: 'data-cart-item-key',
    cartItemQuantity: 'data-cart-item-quantity',
    cartItemTitle: 'data-cart-item-title',
    cartItemUrl: 'data-cart-item-url',
    quantityItem: 'data-quantity-item'
  };

  var mediumUpQuery = '(min-width: ' + theme.breakpoints.medium + 'px)';

  function Cart(container) {
    this.container = container;
    this.thumbnails = this.container.querySelectorAll(selectors.thumbnails);
    this.quantityInputs = this.container.querySelectorAll(selectors.inputQty);
    this.ajaxEnabled =
      this.container.getAttribute('data-ajax-enabled') === 'true';

    this.cartRoutes = JSON.parse(
      document.querySelector('[data-cart-routes]').innerHTML
    );

    this._handleInputQty = theme.Helpers.debounce(
      this._handleInputQty.bind(this),
      500
    );
    this.setQuantityFormControllers = this.setQuantityFormControllers.bind(
      this
    );
    this._onNoteChange = this._onNoteChange.bind(this);
    this._onRemoveItem = this._onRemoveItem.bind(this);

    if (!theme.Helpers.cookiesEnabled()) {
      this.container.classList.add(classes.cartNoCookies);
    }

    this.thumbnails.forEach(function(element) {
      element.style.cursor = 'pointer';
    });

    this.container.addEventListener('click', this._handleThumbnailClick);
    this.container.addEventListener('change', this._handleInputQty);

    this.mql = window.matchMedia(mediumUpQuery);
    this.mql.addListener(this.setQuantityFormControllers);

    this.setQuantityFormControllers();

    if (this.ajaxEnabled) {
      /**
       * Because the entire cart is recreated when a cart item is updated,
       * we cannot cache the elements in the cart. Instead, we add the event
       * listeners on the cart's container to allow us to retain the event
       * listeners after rebuilding the cart when an item is updated.
       */
      this.container.addEventListener('click', this._onRemoveItem);
      this.container.addEventListener('change', this._onNoteChange);

      this._setupCartTemplates();
    }
  }

  Cart.prototype = Object.assign({}, Cart.prototype, {
    _setupCartTemplates: function() {
      var cartItem = this.container.querySelector(selectors.cartItem);
      if (!cartItem) return;

      this.itemTemplate = this.container
        .querySelector(selectors.cartItem)
        .cloneNode(true);

      this.itemDiscountTemplate = this.itemTemplate
        .querySelector(selectors.cartItemDiscount)
        .cloneNode(true);

      this.cartDiscountTemplate = this.container
        .querySelector(selectors.cartDiscount)
        .cloneNode(true);

      this.itemPriceListTemplate = this.itemTemplate
        .querySelector(selectors.cartItemPriceList)
        .cloneNode(true);

      this.itemOptionTemplate = this.itemTemplate
        .querySelector(selectors.cartItemOption)
        .cloneNode(true);

      this.itemPropertyTemplate = this.itemTemplate
        .querySelector(selectors.cartItemProperty)
        .cloneNode(true);

      this.itemSellingPlanNameTemplate = this.itemTemplate
        .querySelector(selectors.cartItemSellingPlanName)
        .cloneNode(true);
    },

    _handleInputQty: function(evt) {
      if (!evt.target.hasAttribute('data-quantity-input')) return;

      var input = evt.target;
      var itemElement = input.closest(selectors.cartItem);

      var itemIndex = Number(input.getAttribute('data-quantity-item'));

      var itemQtyInputs = this.container.querySelectorAll(
        "[data-quantity-item='" + itemIndex + "']"
      );

      var value = parseInt(input.value);

      var isValidValue = !(value < 0 || isNaN(value));

      itemQtyInputs.forEach(function(element) {
        element.value = value;
      });

      this._hideCartError();
      this._hideQuantityErrorMessage();

      if (!isValidValue) {
        this._showQuantityErrorMessages(itemElement);
        return;
      }

      if (isValidValue && this.ajaxEnabled) {
        this._updateItemQuantity(itemIndex, itemElement, itemQtyInputs, value);
      }
    },

    _updateItemQuantity: function(
      itemIndex,
      itemElement,
      itemQtyInputs,
      value
    ) {
      var key = itemElement.getAttribute(attributes.cartItemKey);
      var index = Number(itemElement.getAttribute(attributes.cartItemIndex));

      var request = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;'
        },
        body: JSON.stringify({
          line: index,
          quantity: value
        })
      };

      fetch(this.cartRoutes.cartChangeUrl + '.js', request)
        .then(function(response) {
          return response.json();
        })
        .then(
          function(state) {
            this._setCartCountBubble(state.item_count);

            if (!state.item_count) {
              this._emptyCart();
              return;
            }

            // Cache current in-focus element, used later to restore focus
            var inFocus = document.activeElement;

            this._createCart(state);

            if (!value) {
              this._showRemoveMessage(itemElement.cloneNode(true));
              return;
            }

            var item = this.getItem(key, state);

            this._updateLiveRegion(item);

            // Restore focus to the "equivalent" element after the DOM has been updated
            if (!inFocus) return;
            var row = inFocus.closest('[' + attributes.cartItemIndex + ']');
            if (!row) return;
            var target = this.container.querySelector(
              '[' +
                attributes.cartItemIndex +
                '="' +
                row.getAttribute(attributes.cartItemIndex) +
                '"] [data-role="' +
                inFocus.getAttribute('data-role') +
                '"]'
            );
            if (!target) return;
            target.focus();
          }.bind(this)
        )
        .catch(
          function() {
            this._showCartError(null);
          }.bind(this)
        );
    },

    getItem: function(key, state) {
      return state.items.find(function(item) {
        return item.key === key;
      });
    },

    _liveRegionText: function(item) {
      // Dummy content for live region
      var liveRegionText =
        theme.strings.update +
        ': [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]';

      // Update Quantity
      liveRegionText = liveRegionText
        .replace('[QuantityLabel]', theme.strings.quantity)
        .replace('[Quantity]', item.quantity);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        item.original_line_price,
        theme.moneyFormat
      );
      var discountLabel = '';
      var discountPrice = '';
      var discountInformation = '';

      if (item.original_line_price > item.final_line_price) {
        regularLabel = theme.strings.regularTotal;

        discountLabel = theme.strings.discountedTotal;
        discountPrice = theme.Currency.formatMoney(
          item.final_line_price,
          theme.moneyFormat
        );

        discountInformation = theme.strings.priceColumn;
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[DiscountedPrice]', discountLabel)
        .replace('[$]', discountPrice)
        .replace('[PriceInformation]', discountInformation)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(item) {
      if (!item) return;

      var liveRegion = this.container.querySelector(selectors.cartStatus);

      liveRegion.textContent = this._liveRegionText(item);
      liveRegion.setAttribute('aria-hidden', false);

      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _createCart: function(state) {
      var cartDiscountList = this._createCartDiscountList(state);

      var cartTable = this.container.querySelector(selectors.cartLineItems);
      cartTable.innerHTML = '';

      this._createLineItemList(state).forEach(function(lineItem) {
        cartTable.appendChild(lineItem);
      });

      this.setQuantityFormControllers();

      this.cartNotes =
        this.cartNotes || this.container.querySelector(selectors.cartNote);

      if (this.cartNotes) {
        this.cartNotes.value = state.note;
      }

      var discountWrapper = this.container.querySelector(
        selectors.cartDiscountWrapper
      );

      if (cartDiscountList.length === 0) {
        discountWrapper.innerHTML = '';
        discountWrapper.classList.add(classes.hide);
      } else {
        discountWrapper.innerHTML = '';

        cartDiscountList.forEach(function(discountItem) {
          discountWrapper.appendChild(discountItem);
        });

        discountWrapper.classList.remove(classes.hide);
      }

      this.container.querySelector(
        selectors.cartSubtotal
      ).innerHTML = theme.Currency.formatMoney(
        state.total_price,
        theme.moneyFormatWithCurrency
      );
    },

    _createCartDiscountList: function(cart) {
      return cart.cart_level_discount_applications.map(
        function(discount) {
          var discountNode = this.cartDiscountTemplate.cloneNode(true);

          discountNode.querySelector(selectors.cartDiscountTitle).textContent =
            discount.title;

          discountNode.querySelector(
            selectors.cartDiscountAmount
          ).innerHTML = theme.Currency.formatMoney(
            discount.total_allocated_amount,
            theme.moneyFormat
          );

          return discountNode;
        }.bind(this)
      );
    },

    _createLineItemList: function(state) {
      return state.items.map(
        function(item, index) {
          var itemNode = this.itemTemplate.cloneNode(true);

          var itemPriceList = this.itemPriceListTemplate.cloneNode(true);

          this._setLineItemAttributes(itemNode, item, index);
          this._setLineItemImage(itemNode, item.featured_image);

          var cartItemTitle = itemNode.querySelector(selectors.cartItemTitle);
          cartItemTitle.textContent = item.product_title;
          cartItemTitle.setAttribute('href', item.url);

          var selling_plan_name = item.selling_plan_allocation
            ? item.selling_plan_allocation.selling_plan.name
            : null;

          var productDetailsList = this._createProductDetailsList(
            item.product_has_only_default_variant,
            item.options_with_values,
            item.properties,
            selling_plan_name
          );

          this._setProductDetailsList(itemNode, productDetailsList);

          this._setItemRemove(itemNode, item.title);

          itemPriceList.innerHTML = this._createItemPrice(
            item.original_price,
            item.final_price
          ).outerHTML;

          if (item.unit_price_measurement) {
            itemPriceList.appendChild(
              this._createUnitPrice(
                item.unit_price,
                item.unit_price_measurement
              )
            );
          }

          this._setItemPrice(itemNode, itemPriceList);

          var itemDiscountList = this._createItemDiscountList(item);
          this._setItemDiscountList(itemNode, itemDiscountList);
          this._setQuantityInputs(itemNode, item, index);

          var itemLinePrice = this._createItemPrice(
            item.original_line_price,
            item.final_line_price
          );

          this._setItemLinePrice(itemNode, itemLinePrice);

          return itemNode;
        }.bind(this)
      );
    },

    _setLineItemAttributes: function(itemNode, item, index) {
      itemNode.setAttribute(attributes.cartItemKey, item.key);
      itemNode.setAttribute(attributes.cartItemUrl, item.url);
      itemNode.setAttribute(attributes.cartItemTitle, item.title);
      itemNode.setAttribute(attributes.cartItemIndex, index + 1);
      itemNode.setAttribute(attributes.cartItemQuantity, item.quantity);
    },

    _setLineItemImage: function(itemNode, featuredImage) {
      var image = itemNode.querySelector(selectors.cartItemImage);

      var sizedImageUrl =
        featuredImage.url !== null
          ? theme.Images.getSizedImageUrl(featuredImage.url, 'x190')
          : null;

      if (sizedImageUrl) {
        image.setAttribute('alt', featuredImage.alt);
        image.setAttribute('src', sizedImageUrl);
        image.classList.remove(classes.hide);
      } else {
        image.parentNode.removeChild(image);
      }
    },

    _setProductDetailsList: function(item, productDetailsList) {
      var itemDetails = item.querySelector(selectors.cartItemDetails);

      if (productDetailsList.length) {
        itemDetails.classList.remove(classes.hide);
        itemDetails.innerHTML = productDetailsList.reduce(function(
          result,
          element
        ) {
          return result + element.outerHTML;
        },
        '');

        return;
      }

      itemDetails.classList.add(classes.hide);
      itemDetails.textContent = '';
    },

    _setItemPrice: function(item, price) {
      item.querySelector(selectors.cartItemPrice).innerHTML = price.outerHTML;
    },

    _setItemDiscountList: function(item, discountList) {
      var itemDiscountList = item.querySelector(selectors.cartItemDiscountList);

      if (discountList.length === 0) {
        itemDiscountList.innerHTML = '';
        itemDiscountList.classList.add(classes.hide);
      } else {
        itemDiscountList.innerHTML = discountList.reduce(function(
          result,
          element
        ) {
          return result + element.outerHTML;
        },
        '');

        itemDiscountList.classList.remove(classes.hide);
      }
    },

    _setItemRemove: function(item, title) {
      item
        .querySelector(selectors.cartRemove)
        .setAttribute(
          'aria-label',
          theme.strings.removeLabel.replace('[product]', title)
        );
    },

    _setQuantityInputs: function(itemNode, item, index) {
      var mobileInput = itemNode.querySelector(selectors.quantityInputMobile);
      var desktopInput = itemNode.querySelector(selectors.quantityInputDesktop);

      mobileInput.setAttribute('id', 'updates_' + item.key);
      desktopInput.setAttribute('id', 'updates_large_' + item.key);

      [mobileInput, desktopInput].forEach(function(element) {
        element.setAttribute(attributes.quantityItem, index + 1);
        element.value = item.quantity;
      });

      itemNode
        .querySelector(selectors.quantityLabelMobile)
        .setAttribute('for', 'updates_' + item.key);

      itemNode
        .querySelector(selectors.quantityLabelDesktop)
        .setAttribute('for', 'updates_large_' + item.key);
    },

    setQuantityFormControllers: function() {
      var desktopQuantityInputs = document.querySelectorAll(
        selectors.quantityInputDesktop
      );

      var mobileQuantityInputs = document.querySelectorAll(
        selectors.quantityInputMobile
      );

      if (this.mql.matches) {
        addNameAttribute(desktopQuantityInputs);
        removeNameAttribute(mobileQuantityInputs);
      } else {
        addNameAttribute(mobileQuantityInputs);
        removeNameAttribute(desktopQuantityInputs);
      }

      function addNameAttribute(inputs) {
        inputs.forEach(function(element) {
          element.setAttribute('name', 'updates[]');
        });
      }

      function removeNameAttribute(inputs) {
        inputs.forEach(function(element) {
          element.removeAttribute('name');
        });
      }
    },

    _setItemLinePrice: function(item, price) {
      item.querySelector(selectors.cartItemLinePrice).innerHTML =
        price.outerHTML;
    },

    _createProductDetailsList: function(
      product_has_only_default_variant,
      options,
      properties,
      selling_plan_name
    ) {
      var optionsPropertiesHTML = [];

      if (!product_has_only_default_variant) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(
          this._getOptionList(options)
        );
      }

      if (selling_plan_name) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(
          this._getSellingPlanName(selling_plan_name)
        );
      }

      if (properties !== null && Object.keys(properties).length !== 0) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(
          this._getPropertyList(properties)
        );
      }

      return optionsPropertiesHTML;
    },

    _getOptionList: function(options) {
      return options.map(
        function(option) {
          var optionElement = this.itemOptionTemplate.cloneNode(true);

          optionElement.textContent = option.name + ': ' + option.value;
          optionElement.classList.remove(classes.hide);

          return optionElement;
        }.bind(this)
      );
    },

    _getPropertyList: function(properties) {
      var propertiesArray =
        properties !== null ? Object.entries(properties) : [];

      var filteredPropertiesArray = propertiesArray.filter(function(property) {
        // Line item properties prefixed with an underscore are not to be displayed
        // if the property value has a length of 0 (empty), don't display it
        if (property[0].charAt(0) === '_' || property[1].length === 0) {
          return false;
        } else {
          return true;
        }
      });

      return filteredPropertiesArray.map(
        function(property) {
          var propertyElement = this.itemPropertyTemplate.cloneNode(true);

          propertyElement.querySelector(
            selectors.cartItemPropertyName
          ).textContent = property[0] + ': ';

          if (property[0].indexOf('/uploads/') === -1) {
            propertyElement.querySelector(
              selectors.cartItemPropertyValue
            ).textContent = property[1];
          } else {
            propertyElement.querySelector(
              selectors.cartItemPropertyValue
            ).innerHTML =
              '<a href="' +
              property[1] +
              '"> ' +
              property[1].split('/').pop() +
              '</a>';
          }

          propertyElement.classList.remove(classes.hide);

          return propertyElement;
        }.bind(this)
      );
    },

    _getSellingPlanName: function(selling_plan_name) {
      var sellingPlanNameElement = this.itemSellingPlanNameTemplate.cloneNode(
        true
      );

      sellingPlanNameElement.textContent = selling_plan_name;
      sellingPlanNameElement.classList.remove(classes.hide);

      return sellingPlanNameElement;
    },

    _createItemPrice: function(original_price, final_price) {
      var originalPriceHTML = theme.Currency.formatMoney(
        original_price,
        theme.moneyFormat
      );

      var resultHTML;

      if (original_price !== final_price) {
        resultHTML = this.itemPriceListTemplate
          .querySelector(selectors.cartItemDiscountedPriceGroup)
          .cloneNode(true);

        resultHTML.querySelector(
          selectors.cartItemOriginalPrice
        ).innerHTML = originalPriceHTML;

        resultHTML.querySelector(
          selectors.cartItemFinalPrice
        ).innerHTML = theme.Currency.formatMoney(
          final_price,
          theme.moneyFormat
        );
      } else {
        resultHTML = this.itemPriceListTemplate
          .querySelector(selectors.cartItemRegularPriceGroup)
          .cloneNode(true);

        resultHTML.querySelector(
          selectors.cartItemRegularPrice
        ).innerHTML = originalPriceHTML;
      }

      resultHTML.classList.remove(classes.hide);
      return resultHTML;
    },

    _createUnitPrice: function(unitPrice, unitPriceMeasurement) {
      var unitPriceGroup = this.itemPriceListTemplate
        .querySelector(selectors.unitPriceGroup)
        .cloneNode(true);

      var unitPriceBaseUnit =
        (unitPriceMeasurement.reference_value !== 1
          ? unitPriceMeasurement.reference_value
          : '') + unitPriceMeasurement.reference_unit;

      unitPriceGroup.querySelector(
        selectors.unitPriceBaseUnit
      ).textContent = unitPriceBaseUnit;

      unitPriceGroup.querySelector(
        selectors.unitPrice
      ).innerHTML = theme.Currency.formatMoney(unitPrice, theme.moneyFormat);

      unitPriceGroup.classList.remove(classes.hide);

      return unitPriceGroup;
    },

    _createItemDiscountList: function(item) {
      return item.line_level_discount_allocations.map(
        function(discount) {
          var discountNode = this.itemDiscountTemplate.cloneNode(true);

          discountNode.querySelector(
            selectors.cartItemDiscountTitle
          ).textContent = discount.discount_application.title;

          discountNode.querySelector(
            selectors.cartItemDiscountAmount
          ).innerHTML = theme.Currency.formatMoney(
            discount.amount,
            theme.moneyFormat
          );

          return discountNode;
        }.bind(this)
      );
    },

    _showQuantityErrorMessages: function(itemElement) {
      itemElement
        .querySelectorAll(selectors.cartQuantityErrorMessage)
        .forEach(function(element) {
          element.textContent = theme.strings.quantityMinimumMessage;
        });

      itemElement
        .querySelectorAll(selectors.cartQuantityErrorMessageWrapper)
        .forEach(function(element) {
          element.classList.remove(classes.hide);
        });

      itemElement
        .querySelectorAll(selectors.inputQty)
        .forEach(function(element) {
          element.classList.add(classes.inputError);
          element.focus();
        });
    },

    _hideQuantityErrorMessage: function() {
      var errorMessages = document.querySelectorAll(
        selectors.cartQuantityErrorMessageWrapper
      );

      errorMessages.forEach(function(element) {
        element.classList.add(classes.hide);

        element.querySelector(selectors.cartQuantityErrorMessage).textContent =
          '';
      });

      this.container
        .querySelectorAll(selectors.inputQty)
        .forEach(function(element) {
          element.classList.remove(classes.inputError);
        });
    },

    _handleThumbnailClick: function(evt) {
      if (!evt.target.classList.contains(classes.thumbnails)) return;

      window.location.href = evt.target
        .closest(selectors.cartItem)
        .getAttribute('data-cart-item-url');
    },

    _onNoteChange: function(evt) {
      if (!evt.target.hasAttribute('data-cart-notes')) return;

      var note = evt.target.value;
      this._hideCartError();
      this._hideQuantityErrorMessage();

      var headers = new Headers({ 'Content-Type': 'application/json' });

      var request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ note: note })
      };

      fetch('/cart/update.js', request).catch(
        function() {
          this._showCartError(evt.target);
        }.bind(this)
      );
    },

    _showCartError: function(elementToFocus) {
      document.querySelector(selectors.cartErrorMessage).textContent =
        theme.strings.cartError;

      document
        .querySelector(selectors.cartErrorMessageWrapper)
        .classList.remove(classes.hide);

      if (!elementToFocus) return;
      elementToFocus.focus();
    },

    _hideCartError: function() {
      document
        .querySelector(selectors.cartErrorMessageWrapper)
        .classList.add(classes.hide);
      document.querySelector(selectors.cartErrorMessage).textContent = '';
    },

    _onRemoveItem: function(evt) {
      if (!evt.target.hasAttribute('data-cart-remove')) return;

      evt.preventDefault();
      var lineItem = evt.target.closest(selectors.cartItem);
      var index = Number(lineItem.getAttribute(attributes.cartItemIndex));

      this._hideCartError();

      var request = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;'
        },
        body: JSON.stringify({
          line: index,
          quantity: 0
        })
      };

      fetch(this.cartRoutes.cartChangeUrl + '.js', request)
        .then(function(response) {
          return response.json();
        })
        .then(
          function(state) {
            if (state.item_count === 0) {
              this._emptyCart();
            } else {
              this._createCart(state);
              this._showRemoveMessage(lineItem.cloneNode(true));
            }

            this._setCartCountBubble(state.item_count);
          }.bind(this)
        )
        .catch(
          function() {
            this._showCartError(null);
          }.bind(this)
        );
    },

    _showRemoveMessage: function(lineItem) {
      var index = lineItem.getAttribute('data-cart-item-index');
      var removeMessage = this._getRemoveMessage(lineItem);

      if (index - 1 === 0) {
        this.container
          .querySelector('[data-cart-item-index="1"]')
          .insertAdjacentHTML('beforebegin', removeMessage.outerHTML);
      } else {
        this.container
          .querySelector("[data-cart-item-index='" + (index - 1) + "']")
          .insertAdjacentHTML('afterend', removeMessage.outerHTML);
      }

      this.container.querySelector('[data-removed-item-row]').focus();
    },

    _getRemoveMessage: function(lineItem) {
      var formattedMessage = this._formatRemoveMessage(lineItem);

      var tableCell = lineItem
        .querySelector(selectors.cartTableCell)
        .cloneNode(true);

      tableCell.removeAttribute('class');
      tableCell.classList.add(classes.cartRemovedProduct);
      tableCell.setAttribute('colspan', '4');
      tableCell.innerHTML = formattedMessage;

      lineItem.setAttribute('role', 'alert');
      lineItem.setAttribute('tabindex', '-1');
      lineItem.setAttribute('data-removed-item-row', true);
      lineItem.innerHTML = tableCell.outerHTML;

      return lineItem;
    },

    _formatRemoveMessage: function(lineItem) {
      var quantity = lineItem.getAttribute('data-cart-item-quantity');
      var url = lineItem.getAttribute(attributes.cartItemUrl);
      var title = lineItem.getAttribute(attributes.cartItemTitle);

      return theme.strings.removedItemMessage
        .replace('[quantity]', quantity)
        .replace(
          '[link]',
          '<a ' +
            'href="' +
            url +
            '" class="text-link text-link--accent">' +
            title +
            '</a>'
        );
    },

    _setCartCountBubble: function(quantity) {
      this.cartCountBubble =
        this.cartCountBubble ||
        document.querySelector(selectors.cartCountBubble);

      this.cartCount =
        this.cartCount || document.querySelector(selectors.cartCount);

      if (quantity > 0) {
        this.cartCountBubble.classList.remove(classes.hide);
        this.cartCount.textContent = quantity;
      } else {
        this.cartCountBubble.classList.add(classes.hide);
        this.cartCount.textContent = '';
      }
    },

    _emptyCart: function() {
      this.emptyPageContent =
        this.emptyPageContent ||
        this.container.querySelector(selectors.emptyPageContent);

      this.cartWrapper =
        this.cartWrapper || this.container.querySelector(selectors.cartWrapper);

      this.emptyPageContent.classList.remove(classes.hide);
      this.cartWrapper.classList.add(classes.hide);
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function() {
  var settings = {
    mediaQueryMediumUp: '(min-width: ' + theme.breakpoints.medium + 'px)'
  };

  var selectors = {
    filterSelection: '#FilterTags',
    sortSelection: '#SortBy',
    selectInput: '[data-select-input]'
  };

  function Filters(container) {
    this.filterSelect = container.querySelector(selectors.filterSelection);
    this.sortSelect = container.querySelector(selectors.sortSelection);

    this.selects = document.querySelectorAll(selectors.selectInput);

    if (this.sortSelect) {
      this.defaultSort = this._getDefaultSortValue();
    }

    if (this.selects.length) {
      this.selects.forEach(function(select) {
        select.classList.remove('hidden');
      });
    }

    this.initBreakpoints = this._initBreakpoints.bind(this);

    this.mql = window.matchMedia(settings.mediaQueryMediumUp);
    this.mql.addListener(this.initBreakpoints);

    if (this.filterSelect) {
      this.filterSelect.addEventListener(
        'change',
        this._onFilterChange.bind(this)
      );
    }

    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', this._onSortChange.bind(this));
    }

    theme.Helpers.promiseStylesheet().then(
      function() {
        this._initBreakpoints();
      }.bind(this)
    );
    this._initParams();
  }

  Filters.prototype = Object.assign({}, Filters.prototype, {
    _initBreakpoints: function() {
      if (this.mql.matches) {
        slate.utils.resizeSelects(this.selects);
      }
    },

    _initParams: function() {
      this.queryParams = {};
      if (location.search.length) {
        var aKeyValue;
        var aCouples = location.search.substr(1).split('&');
        for (var i = 0; i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            this.queryParams[
              decodeURIComponent(aKeyValue[0])
            ] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },

    _onSortChange: function() {
      this.queryParams.sort_by = this._getSortValue();

      if (this.queryParams.page) {
        delete this.queryParams.page;
      }

      window.location.search = decodeURIComponent(
        new URLSearchParams(Object.entries(this.queryParams)).toString()
      );
    },

    _onFilterChange: function() {
      document.location.href = this._getFilterValue();
    },

    _getFilterValue: function() {
      return this.filterSelect.value;
    },

    _getSortValue: function() {
      return this.sortSelect.value || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return this.sortSelect.dataset.defaultSortby;
    },

    onUnload: function() {
      if (this.filterSelect) {
        this.filterSelect.removeEventListener('change', this._onFilterChange);
      }

      if (this.sortSelect) {
        this.sortSelect.removeEventListener('change', this._onSortChange);
      }

      this.mql.removeListener(this.initBreakpoints);
    }
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.SearchDrawer.init();
    theme.Search.init();
  }

  Header.prototype = Object.assign({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
      theme.Search.unload();
      theme.MobileNav.unload();
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    document.querySelector(selectors.section).classList.add(classes.mapError);
    document.querySelector(selectors.map).remove();
    document
      .querySelector(selectors.mapOverlay)
      .insertAdjacentHTML(
        'afterend',
        '<div class="' +
          classes.errorMsg +
          '">' +
          theme.strings.authError +
          '</div>'
      );
  };

  function Map(container) {
    this.map = container.querySelector(selectors.map);
    if (!this.map) return;
    this.key = this.map.dataset.apiKey;

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          theme.Helpers.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    mapsToLoad.forEach(function(map) {
      map.createMap();
    });
  }

  function geolocate(map) {
    return new Promise(function(resolve, reject) {
      var geocoder = new google.maps.Geocoder();
      var address = map.dataset.addressSetting;

      geocoder.geocode({ address: address }, function(results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          reject(status);
        }

        resolve(results);
      });
    });
  }

  Map.prototype = Object.assign({}, Map.prototype, {
    createMap: function() {
      return geolocate(this.map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map(this.map, mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              theme.Helpers.debounce(
                function() {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  this.map.removeAttribute('style');
                }.bind(this),
                250
              )
            );
          }.bind(this)
        )
        .catch(
          function() {
            var errorMessage;

            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }

            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              this.map.parentNode.classList.add(classes.mapError);
              this.map.parentNode.innerHTML =
                '<div class="' +
                classes.errorMsg +
                '">' +
                errorMessage +
                '</div>';
            }
          }.bind(this)
        );
    },

    onUnload: function() {
      if (this.map) {
        google.maps.event.clearListeners(this.map, 'resize');
      }
    }
  });

  return Map;
})();

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    this.container = container;
    var sectionId = container.getAttribute('data-section-id');
    this.zoomPictures = [];
    this.ajaxEnabled = container.getAttribute('data-ajax-enabled') === 'true';

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState:
        container.getAttribute('data-enable-history-state') === 'true',
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      cartCount: '[data-cart-count]',
      cartCountBubble: '[data-cart-count-bubble]',
      cartPopup: '[data-cart-popup]',
      cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
      cartPopupClose: '[data-cart-popup-close]',
      cartPopupDismiss: '[data-cart-popup-dismiss]',
      cartPopupImage: '[data-cart-popup-image]',
      cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
      cartPopupImagePlaceholder: '[data-image-loading-animation]',
      cartPopupProductDetails: '[data-cart-popup-product-details]',
      cartPopupQuantity: '[data-cart-popup-quantity]',
      cartPopupQuantityLabel: '[data-cart-popup-quantity-label]',
      cartPopupTitle: '[data-cart-popup-title]',
      cartPopupWrapper: '[data-cart-popup-wrapper]',
      loader: '[data-loader]',
      loaderStatus: '[data-loader-status]',
      quantity: '[data-quantity-input]',
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productForm: '[data-product-form]',
      errorMessage: '[data-error-message]',
      errorMessageWrapper: '[data-error-message-wrapper]',
      imageZoomWrapper: '[data-image-zoom-wrapper]',
      productMediaWrapper: '[data-product-single-media-wrapper]',
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productThumbListItem: '.product-single__thumbnails-item',
      productThumbsWrapper: '.thumbnails-wrapper',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      productMediaTypeVideo: '[data-product-media-type-video]',
      productMediaTypeModel: '[data-product-media-type-model]',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]',
      unitPrice: '[data-unit-price]',
      unitPriceBaseUnit: '[data-unit-price-base-unit]',
      productPolicies: '[data-product-policies]',
      storeAvailabilityContainer: '[data-store-availability-container]'
    };

    this.classes = {
      cartPopupWrapperHidden: 'cart-popup-wrapper--hidden',
      hidden: 'hide',
      visibilityHidden: 'visibility-hidden',
      inputError: 'input--error',
      jsZoomEnabled: 'js-zoom-enabled',
      productOnSale: 'price--on-sale',
      productUnitAvailable: 'price--unit-available',
      productUnavailable: 'price--unavailable',
      productSoldOut: 'price--sold-out',
      cartImage: 'cart-popup-item__image',
      productFormErrorMessageWrapperHidden:
        'product-form__error-message-wrapper--hidden',
      activeClass: 'active-thumb',
      variantSoldOut: 'product-form--variant-sold-out'
    };

    this.eventHandlers = {};

    this.quantityInput = container.querySelector(this.selectors.quantity);
    this.errorMessageWrapper = container.querySelector(
      this.selectors.errorMessageWrapper
    );
    this.productForm = container.querySelector(this.selectors.productForm);
    this.addToCart = container.querySelector(this.selectors.addToCart);
    this.addToCartText = this.addToCart.querySelector(
      this.selectors.addToCartText
    );
    this.shopifyPaymentButton = container.querySelector(
      this.selectors.shopifyPaymentButton
    );
    this.priceContainer = container.querySelector(
      this.selectors.priceContainer
    );
    this.productPolicies = container.querySelector(
      this.selectors.productPolicies
    );
    this.storeAvailabilityContainer = container.querySelector(
      this.selectors.storeAvailabilityContainer
    );
    if (this.storeAvailabilityContainer) {
      this._initStoreAvailability();
    }

    this.loader = this.addToCart.querySelector(this.selectors.loader);
    this.loaderStatus = container.querySelector(this.selectors.loaderStatus);

    this.imageZoomWrapper = container.querySelectorAll(
      this.selectors.imageZoomWrapper
    );

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    var productJson = document.getElementById('ProductJson-' + sectionId);
    if (!productJson || !productJson.innerHTML.length) {
      return;
    }

    this.productSingleObject = JSON.parse(productJson.innerHTML);

    // Initial state for global productState object
    this.productState = {
      available: true,
      soldOut: false,
      onSale: false,
      showUnitPrice: false
    };

    this.settings.zoomEnabled =
      this.imageZoomWrapper.length > 0
        ? this.imageZoomWrapper[0].classList.contains(
            this.classes.jsZoomEnabled
          )
        : false;

    this.cartRoutes = JSON.parse(
      document.querySelector('[data-cart-routes]').innerHTML
    );

    this.initMobileBreakpoint = this._initMobileBreakpoint.bind(this);
    this.initDesktopBreakpoint = this._initDesktopBreakpoint.bind(this);

    this.mqlSmall = window.matchMedia(this.settings.mediaQuerySmall);
    this.mqlSmall.addListener(this.initMobileBreakpoint);

    this.mqlMediumUp = window.matchMedia(this.settings.mediaQueryMediumUp);
    this.mqlMediumUp.addListener(this.initDesktopBreakpoint);

    this.initMobileBreakpoint();
    this.initDesktopBreakpoint();
    this._stringOverrides();
    this._initVariants();
    this._initMediaSwitch();
    this._initAddToCart();
    this._setActiveThumbnail();
    this._initProductVideo();
    this._initModelViewerLibraries();
    this._initShopifyXrLaunch();
  }

  Product.prototype = Object.assign({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      theme.strings = Object.assign({}, theme.strings, theme.productStrings);
    },

    _initStoreAvailability: function() {
      this.storeAvailability = new theme.StoreAvailability(
        this.storeAvailabilityContainer
      );

      var storeAvailabilityModalOpenedCallback = function(event) {
        if (
          this.cartPopupWrapper &&
          !this.cartPopupWrapper.classList.contains(
            this.classes.cartPopupWrapperHidden
          )
        ) {
          this._hideCartPopup(event);
        }
      };

      // hide cart popup modal if the store availability modal is also opened
      this.storeAvailabilityContainer.addEventListener(
        'storeAvailabilityModalOpened',
        storeAvailabilityModalOpenedCallback.bind(this)
      );
    },

    _initMobileBreakpoint: function() {
      if (this.mqlSmall.matches) {
        // initialize thumbnail slider on mobile if more than four thumbnails
        if (
          this.container.querySelectorAll(this.selectors.productThumbImages)
            .length > 4
        ) {
          this._initThumbnailSlider();
        }

        // destroy image zooming if enabled
        if (this.settings.zoomEnabled) {
          this.imageZoomWrapper.forEach(
            function(element, index) {
              this._destroyZoom(index);
            }.bind(this)
          );
        }

        this.settings.bpSmall = true;
      } else {
        if (this.settings.sliderActive) {
          this._destroyThumbnailSlider();
        }

        this.settings.bpSmall = false;
      }
    },

    _initDesktopBreakpoint: function() {
      if (this.mqlMediumUp.matches && this.settings.zoomEnabled) {
        this.imageZoomWrapper.forEach(
          function(element, index) {
            this._enableZoom(element, index);
          }.bind(this)
        );
      }
    },

    _initVariants: function() {
      var options = {
        container: this.container,
        enableHistoryState:
          this.container.getAttribute('data-enable-history-state') === 'true',
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);
      if (this.storeAvailability && this.variants.currentVariant.available) {
        this.storeAvailability.updateContent(this.variants.currentVariant.id);
      }

      this.eventHandlers.updateAvailability = this._updateAvailability.bind(
        this
      );
      this.eventHandlers.updateMedia = this._updateMedia.bind(this);
      this.eventHandlers.updatePrice = this._updatePrice.bind(this);
      this.eventHandlers.updateSKU = this._updateSKU.bind(this);

      this.container.addEventListener(
        'variantChange',
        this.eventHandlers.updateAvailability
      );
      this.container.addEventListener(
        'variantImageChange',
        this.eventHandlers.updateMedia
      );
      this.container.addEventListener(
        'variantPriceChange',
        this.eventHandlers.updatePrice
      );
      this.container.addEventListener(
        'variantSKUChange',
        this.eventHandlers.updateSKU
      );
    },

    _initMediaSwitch: function() {
      if (!document.querySelector(this.selectors.productThumbImages)) {
        return;
      }

      var self = this;

      var productThumbImages = document.querySelectorAll(
        this.selectors.productThumbImages
      );

      this.eventHandlers.handleMediaFocus = this._handleMediaFocus.bind(this);

      productThumbImages.forEach(function(el) {
        el.addEventListener('click', function(evt) {
          evt.preventDefault();
          var mediaId = el.getAttribute('data-thumbnail-id');

          self._switchMedia(mediaId);
          self._setActiveThumbnail(mediaId);
        });
        el.addEventListener('keyup', self.eventHandlers.handleMediaFocus);
      });
    },

    _initAddToCart: function() {
      this.productForm.addEventListener(
        'submit',
        function(evt) {
          if (this.addToCart.getAttribute('aria-disabled') === 'true') {
            evt.preventDefault();
            return;
          }

          if (!this.ajaxEnabled) return;

          evt.preventDefault();

          this.previouslyFocusedElement = document.activeElement;

          var isInvalidQuantity =
            !!this.quantityInput && this.quantityInput.value <= 0;

          if (isInvalidQuantity) {
            this._showErrorMessage(theme.strings.quantityMinimumMessage);
            return;
          }

          if (!isInvalidQuantity && this.ajaxEnabled) {
            // disable the addToCart and dynamic checkout button while
            // request/cart popup is loading and handle loading state
            this._handleButtonLoadingState(true);
            this._addItemToCart(this.productForm);
            return;
          }
        }.bind(this)
      );
    },

    _initProductVideo: function() {
      var sectionId = this.settings.sectionId;

      var productMediaTypeVideo = this.container.querySelectorAll(
        this.selectors.productMediaTypeVideo
      );
      productMediaTypeVideo.forEach(function(el) {
        theme.ProductVideo.init(el, sectionId);
      });
    },

    _initModelViewerLibraries: function() {
      var modelViewerElements = this.container.querySelectorAll(
        this.selectors.productMediaTypeModel
      );
      if (modelViewerElements.length < 1) return;
      theme.ProductModel.init(modelViewerElements, this.settings.sectionId);
    },

    _initShopifyXrLaunch: function() {
      this.eventHandlers.initShopifyXrLaunchHandler = this._initShopifyXrLaunchHandler.bind(
        this
      );
      document.addEventListener(
        'shopify_xr_launch',
        this.eventHandlers.initShopifyXrLaunchHandler
      );
    },

    _initShopifyXrLaunchHandler: function() {
      var currentMedia = this.container.querySelector(
        this.selectors.productMediaWrapper +
          ':not(.' +
          self.classes.hidden +
          ')'
      );
      currentMedia.dispatchEvent(
        new CustomEvent('xrLaunch', {
          bubbles: true,
          cancelable: true
        })
      );
    },

    _addItemToCart: function(form) {
      var self = this;

      fetch(this.cartRoutes.cartAddUrl + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: theme.Helpers.serialize(form)
      })
        .then(function(response) {
          return response.json();
        })
        .then(function(json) {
          if (json.status && json.status !== 200) {
            var error = new Error(json.description);
            error.isFromServer = true;
            throw error;
          }
          self._hideErrorMessage();
          self._setupCartPopup(json);
        })
        .catch(function(error) {
          self.previouslyFocusedElement.focus();
          self._showErrorMessage(
            error.isFromServer && error.message.length
              ? error.message
              : theme.strings.cartError
          );
          self._handleButtonLoadingState(false);
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },

    _handleButtonLoadingState: function(isLoading) {
      if (isLoading) {
        this.addToCart.setAttribute('aria-disabled', true);
        this.addToCartText.classList.add(this.classes.hidden);
        this.loader.classList.remove(this.classes.hidden);

        if (this.shopifyPaymentButton) {
          this.shopifyPaymentButton.setAttribute('disabled', true);
        }

        this.loaderStatus.setAttribute('aria-hidden', false);
      } else {
        this.addToCart.removeAttribute('aria-disabled');
        this.addToCartText.classList.remove(this.classes.hidden);
        this.loader.classList.add(this.classes.hidden);

        if (this.shopifyPaymentButton) {
          this.shopifyPaymentButton.removeAttribute('disabled');
        }

        this.loaderStatus.setAttribute('aria-hidden', true);
      }
    },

    _showErrorMessage: function(errorMessage) {
      var errorMessageContainer = this.container.querySelector(
        this.selectors.errorMessage
      );
      errorMessageContainer.innerHTML = errorMessage;

      if (this.quantityInput) {
        this.quantityInput.classList.add(this.classes.inputError);
      }

      this.errorMessageWrapper.classList.remove(
        this.classes.productFormErrorMessageWrapperHidden
      );
      this.errorMessageWrapper.setAttribute('aria-hidden', true);
      this.errorMessageWrapper.removeAttribute('aria-hidden');
    },

    _hideErrorMessage: function() {
      this.errorMessageWrapper.classList.add(
        this.classes.productFormErrorMessageWrapperHidden
      );

      if (this.quantityInput) {
        this.quantityInput.classList.remove(this.classes.inputError);
      }
    },

    _setupCartPopup: function(item) {
      this.cartPopup =
        this.cartPopup || document.querySelector(this.selectors.cartPopup);
      this.cartPopupWrapper =
        this.cartPopupWrapper ||
        document.querySelector(this.selectors.cartPopupWrapper);
      this.cartPopupTitle =
        this.cartPopupTitle ||
        document.querySelector(this.selectors.cartPopupTitle);
      this.cartPopupQuantity =
        this.cartPopupQuantity ||
        document.querySelector(this.selectors.cartPopupQuantity);
      this.cartPopupQuantityLabel =
        this.cartPopupQuantityLabel ||
        document.querySelector(this.selectors.cartPopupQuantityLabel);
      this.cartPopupClose =
        this.cartPopupClose ||
        document.querySelector(this.selectors.cartPopupClose);
      this.cartPopupDismiss =
        this.cartPopupDismiss ||
        document.querySelector(this.selectors.cartPopupDismiss);
      this.cartPopupImagePlaceholder =
        this.cartPopupImagePlaceholder ||
        document.querySelector(this.selectors.cartPopupImagePlaceholder);

      this._setupCartPopupEventListeners();

      this._updateCartPopupContent(item);
    },

    _updateCartPopupContent: function(item) {
      var self = this;

      var quantity = this.quantityInput ? this.quantityInput.value : 1;

      var selling_plan_name = item.selling_plan_allocation
        ? item.selling_plan_allocation.selling_plan.name
        : null;

      this.cartPopupTitle.textContent = item.product_title;
      this.cartPopupQuantity.textContent = quantity;
      this.cartPopupQuantityLabel.textContent = theme.strings.quantityLabel.replace(
        '[count]',
        quantity
      );

      this._setCartPopupPlaceholder(item.featured_image.url);
      this._setCartPopupImage(item.featured_image.url, item.featured_image.alt);
      this._setCartPopupProductDetails(
        item.product_has_only_default_variant,
        item.options_with_values,
        item.properties,
        selling_plan_name
      );

      fetch(this.cartRoutes.cartUrl + '.js', { credentials: 'same-origin' })
        .then(function(response) {
          return response.json();
        })
        .then(function(cart) {
          self._setCartQuantity(cart.item_count);
          self._setCartCountBubble(cart.item_count);
          self._showCartPopup();
        })
        .catch(function(error) {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },

    _setupCartPopupEventListeners: function() {
      this.eventHandlers.cartPopupWrapperKeyupHandler = this._cartPopupWrapperKeyupHandler.bind(
        this
      );
      this.eventHandlers.hideCartPopup = this._hideCartPopup.bind(this);
      this.eventHandlers.onBodyClick = this._onBodyClick.bind(this);

      this.cartPopupWrapper.addEventListener(
        'keyup',
        this.eventHandlers.cartPopupWrapperKeyupHandler
      );
      this.cartPopupClose.addEventListener(
        'click',
        this.eventHandlers.hideCartPopup
      );
      this.cartPopupDismiss.addEventListener(
        'click',
        this.eventHandlers.hideCartPopup
      );
      document.body.addEventListener('click', this.eventHandlers.onBodyClick);
    },

    _cartPopupWrapperKeyupHandler: function(event) {
      if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
        this._hideCartPopup(event);
      }
    },

    _setCartPopupPlaceholder: function(imageUrl) {
      this.cartPopupImageWrapper =
        this.cartPopupImageWrapper ||
        document.querySelector(this.selectors.cartPopupImageWrapper);

      if (imageUrl === null) {
        this.cartPopupImageWrapper.classList.add(this.classes.hidden);
        return;
      }
    },

    _setCartPopupImage: function(imageUrl, imageAlt) {
      if (imageUrl === null) return;

      this.cartPopupImageWrapper.classList.remove(this.classes.hidden);
      var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, '200x');
      var image = document.createElement('img');
      image.src = sizedImageUrl;
      image.alt = imageAlt;
      image.classList.add(this.classes.cartImage);
      image.setAttribute('data-cart-popup-image', '');

      image.onload = function() {
        this.cartPopupImagePlaceholder.removeAttribute(
          'data-image-loading-animation'
        );
        this.cartPopupImageWrapper.append(image);
      }.bind(this);
    },

    _setCartPopupProductDetails: function(
      product_has_only_default_variant,
      options,
      properties,
      selling_plan_name
    ) {
      this.cartPopupProductDetails =
        this.cartPopupProductDetails ||
        document.querySelector(this.selectors.cartPopupProductDetails);
      var variantPropertiesHTML = '';

      if (!product_has_only_default_variant) {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getVariantOptionList(options);
      }

      if (selling_plan_name) {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getSellingPlanHTML(selling_plan_name);
      }

      if (properties !== null && Object.keys(properties).length !== 0) {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getPropertyList(properties);
      }

      if (variantPropertiesHTML.length === 0) {
        this.cartPopupProductDetails.innerHTML = '';
        this.cartPopupProductDetails.setAttribute('hidden', '');
      } else {
        this.cartPopupProductDetails.innerHTML = variantPropertiesHTML;
        this.cartPopupProductDetails.removeAttribute('hidden');
      }
    },

    _getVariantOptionList: function(variantOptions) {
      var variantOptionListHTML = '';

      variantOptions.forEach(function(variantOption) {
        var $name = "<strong>"+variantOption.name+"</strong>";
        if($name.toLowerCase().indexOf("length/shape") !== -1){
        	$name = "<strong>Shape</strong>";
        }
        variantOptionListHTML =
          variantOptionListHTML +
          '<li class="product-details__item product-details__item--variant-option">' +
          $name +
          ': ' +
          variantOption.value +
          '</li>';
      });

      return variantOptionListHTML;
    },

    _getPropertyList: function(properties) {
      var propertyListHTML = '';
      var propertiesArray = Object.entries(properties);

      propertiesArray.forEach(function(property) {
        // Line item properties prefixed with an underscore are not to be displayed
        if (property[0].charAt(0) === '_') return;

        // if the property value has a length of 0 (empty), don't display it
        if (property[1].length === 0) return;

        propertyListHTML =
          propertyListHTML +
          '<li class="product-details__item product-details__item--property">' +
          '<span class="product-details__property-label">' +
          property[0] +
          ': </span>' +
          property[1];
        ': ' + '</li>';
      });

      return propertyListHTML;
    },

    _getSellingPlanHTML: function(selling_plan_name) {
      var sellingPlanHTML =
        '<li class="product-details__item product-details__item--property">' +
        selling_plan_name +
        '</li>';

      return sellingPlanHTML;
    },

    _setCartQuantity: function(quantity) {
      this.cartPopupCartQuantity =
        this.cartPopupCartQuantity ||
        document.querySelector(this.selectors.cartPopupCartQuantity);
      var ariaLabel;

      if (quantity === 1) {
        ariaLabel = theme.strings.oneCartCount;
      } else if (quantity > 1) {
        ariaLabel = theme.strings.otherCartCount.replace('[count]', quantity);
      }

      this.cartPopupCartQuantity.textContent = quantity;
      this.cartPopupCartQuantity.setAttribute('aria-label', ariaLabel);
    },

    _setCartCountBubble: function(quantity) {
      this.cartCountBubble =
        this.cartCountBubble ||
        document.querySelector(this.selectors.cartCountBubble);
      this.cartCount =
        this.cartCount || document.querySelector(this.selectors.cartCount);

      this.cartCountBubble.classList.remove(this.classes.hidden);
      this.cartCount.textContent = quantity;
    },

    _showCartPopup: function() {
      theme.Helpers.prepareTransition(this.cartPopupWrapper);

      this.cartPopupWrapper.classList.remove(
        this.classes.cartPopupWrapperHidden
      );
      this._handleButtonLoadingState(false);

      slate.a11y.trapFocus({
        container: this.cartPopupWrapper,
        elementToFocus: this.cartPopup,
        namespace: 'cartPopupFocus'
      });
    },

    _hideCartPopup: function(event) {
      var setFocus = event.detail === 0 ? true : false;
      theme.Helpers.prepareTransition(this.cartPopupWrapper);
      this.cartPopupWrapper.classList.add(this.classes.cartPopupWrapperHidden);

      var cartPopupImage = document.querySelector(
        this.selectors.cartPopupImage
      );
      if (cartPopupImage) {
        cartPopupImage.remove();
      }
      this.cartPopupImagePlaceholder.setAttribute(
        'data-image-loading-animation',
        ''
      );

      slate.a11y.removeTrapFocus({
        container: this.cartPopupWrapper,
        namespace: 'cartPopupFocus'
      });

      if (setFocus) this.previouslyFocusedElement.focus();

      this.cartPopupWrapper.removeEventListener(
        'keyup',
        this.eventHandlers.cartPopupWrapperKeyupHandler
      );
      this.cartPopupClose.removeEventListener(
        'click',
        this.eventHandlers.hideCartPopup
      );
      this.cartPopupDismiss.removeEventListener(
        'click',
        this.eventHandlers.hideCartPopup
      );
      document.body.removeEventListener(
        'click',
        this.eventHandlers.onBodyClick
      );
    },

    _onBodyClick: function(event) {
      var target = event.target;

      if (
        target !== this.cartPopupWrapper &&
        !target.closest(this.selectors.cartPopup)
      ) {
        this._hideCartPopup(event);
      }
    },

    _setActiveThumbnail: function(mediaId) {
      // If there is no element passed, find it by the current product image
      if (typeof mediaId === 'undefined') {
        var productMediaWrapper = this.container.querySelector(
          this.selectors.productMediaWrapper + ':not(.hide)'
        );

        if (!productMediaWrapper) return;
        mediaId = productMediaWrapper.getAttribute('data-media-id');
      }

      var thumbnailWrappers = this.container.querySelectorAll(
        this.selectors.productThumbListItem + ':not(.slick-cloned)'
      );

      var activeThumbnail;
      thumbnailWrappers.forEach(
        function(el) {
          var current = el.querySelector(
            this.selectors.productThumbImages +
              "[data-thumbnail-id='" +
              mediaId +
              "']"
          );
          if (current) {
            activeThumbnail = current;
          }
        }.bind(this)
      );

      var productThumbImages = document.querySelectorAll(
        this.selectors.productThumbImages
      );
      productThumbImages.forEach(
        function(el) {
          el.classList.remove(this.classes.activeClass);
          el.removeAttribute('aria-current');
        }.bind(this)
      );

      if (activeThumbnail) {
        activeThumbnail.classList.add(this.classes.activeClass);
        activeThumbnail.setAttribute('aria-current', true);
        this._adjustThumbnailSlider(activeThumbnail);
      }
    },

    _adjustThumbnailSlider: function(activeThumbnail) {
      var sliderItem = activeThumbnail.closest('[data-slider-item]');
      if (!sliderItem) return;

      var slideGroupLeaderIndex =
        Math.floor(
          Number(sliderItem.getAttribute('data-slider-slide-index')) / 3
        ) * 3;

      window.setTimeout(
        function() {
          if (!this.slideshow) return;
          this.slideshow.goToSlideByIndex(slideGroupLeaderIndex);
        }.bind(this),
        251
      );
    },

    _switchMedia: function(mediaId) {
      var currentMedia = this.container.querySelector(
        this.selectors.productMediaWrapper +
          ':not(.' +
          this.classes.hidden +
          ')'
      );

      var newMedia = this.container.querySelector(
        this.selectors.productMediaWrapper + "[data-media-id='" + mediaId + "']"
      );

      var otherMedia = this.container.querySelectorAll(
        this.selectors.productMediaWrapper +
          ":not([data-media-id='" +
          mediaId +
          "'])"
      );

      currentMedia.dispatchEvent(
        new CustomEvent('mediaHidden', {
          bubbles: true,
          cancelable: true
        })
      );
      newMedia.classList.remove(this.classes.hidden);
      newMedia.dispatchEvent(
        new CustomEvent('mediaVisible', {
          bubbles: true,
          cancelable: true
        })
      );
      otherMedia.forEach(
        function(el) {
          el.classList.add(this.classes.hidden);
        }.bind(this)
      );
    },

    _handleMediaFocus: function(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      var mediaId = evt.currentTarget.getAttribute('data-thumbnail-id');

      var productMediaWrapper = this.container.querySelector(
        this.selectors.productMediaWrapper + "[data-media-id='" + mediaId + "']"
      );
      productMediaWrapper.focus();
    },

    _initThumbnailSlider: function() {
      setTimeout(
        function() {
          this.slideshow = new theme.Slideshow(
            this.container.querySelector('[data-thumbnail-slider]'),
            {
              canUseTouchEvents: true,
              type: 'slide',
              slideActiveClass: 'slick-active',
              slidesToShow: 3,
              slidesToScroll: 3
            }
          );

          this.settings.sliderActive = true;
        }.bind(this),
        250
      );
    },

    _destroyThumbnailSlider: function() {
      var sliderButtons = this.container.querySelectorAll(
        '[data-slider-button]'
      );
      var sliderTrack = this.container.querySelector('[data-slider-track]');
      var sliderItems = sliderTrack.querySelectorAll('[data-slider-item');
      this.settings.sliderActive = false;

      if (sliderTrack) {
        sliderTrack.removeAttribute('style');
        sliderItems.forEach(function(sliderItem) {
          var sliderItemLink = sliderItem.querySelector(
            '[data-slider-item-link]'
          );
          sliderItem.classList.remove('slick-active');
          sliderItem.removeAttribute('style');
          sliderItem.removeAttribute('tabindex');
          sliderItem.removeAttribute('aria-hidden');
          sliderItemLink.removeAttribute('tabindex');
        });
      }

      sliderButtons.forEach(function(sliderButton) {
        sliderButton.removeAttribute('aria-disabled');
      });

      this.slideshow.destroy();
      this.slideshow = null;
    },

    _liveRegionText: function(variant) {
      // Dummy content for live region
      var liveRegionText =
        '[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]';

      if (!this.productState.available) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = this.productState.soldOut
        ? theme.strings.soldOut + ','
        : '';
      liveRegionText = liveRegionText.replace('[Availability]', availability);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';
      var unitLabel = '';
      var unitPrice = '';

      if (this.productState.onSale) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      if (this.productState.showUnitPrice) {
        unitLabel = theme.strings.unitPrice;
        unitPrice =
          theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat) +
          ' ' +
          theme.strings.unitPriceSeparator +
          ' ' +
          this._getBaseUnit(variant);
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[Sale]', saleLabel)
        .replace('[$]', salePrice)
        .replace('[UnitPrice]', unitLabel)
        .replace('[$$$]', unitPrice)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(evt) {
      var variant = evt.detail.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      liveRegion.innerHTML = this._liveRegionText(variant);
      liveRegion.setAttribute('aria-hidden', false);
      // hide content from accessibility tree after announcement
      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _enableAddToCart: function(message) {
      this.addToCart.removeAttribute('aria-disabled');
      this.addToCart.setAttribute('aria-label', message);
      this.addToCartText.innerHTML = message;
      this.productForm.classList.remove(this.classes.variantSoldOut);
    },

    _disableAddToCart: function(message) {
      message = message || theme.strings.unavailable;
      this.addToCart.setAttribute('aria-disabled', true);
      this.addToCart.setAttribute('aria-label', message);
      this.addToCartText.innerHTML = message;
      this.productForm.classList.add(this.classes.variantSoldOut);
    },

    _updateAddToCart: function() {
      if (!this.productState.available) {
        this._disableAddToCart(theme.strings.unavailable);
        return;
      }
      if (this.productState.soldOut) {
        this._disableAddToCart(theme.strings.soldOut);
        return;
      }

      this._enableAddToCart(theme.strings.addToCart);
    },

    /**
     * The returned productState object keeps track of a number of properties about the current variant and product
     * Multiple functions within product.js leverage the productState object to determine how to update the page's UI
     * @param {object} evt - object returned from variant change event
     * @return {object} productState - current product variant's state
     *                  productState.available - true if current product options result in valid variant
     *                  productState.soldOut - true if variant is sold out
     *                  productState.onSale - true if variant is on sale
     *                  productState.showUnitPrice - true if variant has unit price value
     */
    _setProductState: function(evt) {
      var variant = evt.detail.variant;

      if (!variant) {
        this.productState.available = false;
        return;
      }

      this.productState.available = true;
      this.productState.soldOut = !variant.available;
      this.productState.onSale = variant.compare_at_price > variant.price;
      this.productState.showUnitPrice = !!variant.unit_price;
    },

    _updateAvailability: function(evt) {
      // remove error message if one is showing
      this._hideErrorMessage();

      // set product state
      this._setProductState(evt);

      // update store availabilities info
      this._updateStoreAvailabilityContent(evt);
      // update form submit
      this._updateAddToCart();
      // update live region
      this._updateLiveRegion(evt);

      this._updatePriceComponentStyles(evt);
    },

    _updateStoreAvailabilityContent: function(evt) {
      if (!this.storeAvailability) {
        return;
      }

      if (this.productState.available && !this.productState.soldOut) {
        this.storeAvailability.updateContent(evt.detail.variant.id);
      } else {
        this.storeAvailability.clearContent();
      }
    },

    _updateMedia: function(evt) {
      var variant = evt.detail.variant;
      var mediaId = variant.featured_media.id;
      var sectionMediaId = this.settings.sectionId + '-' + mediaId;

      this._switchMedia(sectionMediaId);
      this._setActiveThumbnail(sectionMediaId);
    },

    _hidePriceComponent: function() {
      this.priceContainer.classList.add(this.classes.productUnavailable);
      this.priceContainer.setAttribute('aria-hidden', true);
      if (this.productPolicies) {
        this.productPolicies.classList.add(this.classes.visibilityHidden);
      }
    },

    _updatePriceComponentStyles: function(evt) {
      var variant = evt.detail.variant;

      var unitPriceBaseUnit = this.priceContainer.querySelector(
        this.selectors.unitPriceBaseUnit
      );

      if (!this.productState.available) {
        this._hidePriceComponent();
        return;
      }

      if (this.productState.soldOut) {
        this.priceContainer.classList.add(this.classes.productSoldOut);
      } else {
        this.priceContainer.classList.remove(this.classes.productSoldOut);
      }

      if (this.productState.showUnitPrice) {
        unitPriceBaseUnit.innerHTML = this._getBaseUnit(variant);
        this.priceContainer.classList.add(this.classes.productUnitAvailable);
      } else {
        this.priceContainer.classList.remove(this.classes.productUnitAvailable);
      }

      if (this.productState.onSale) {
        this.priceContainer.classList.add(this.classes.productOnSale);
      } else {
        this.priceContainer.classList.remove(this.classes.productOnSale);
      }

      this.priceContainer.classList.remove(this.classes.productUnavailable);
      this.priceContainer.removeAttribute('aria-hidden');
      if (this.productPolicies) {
        this.productPolicies.classList.remove(this.classes.visibilityHidden);
      }
    },

    _updatePrice: function(evt) {
      var variant = evt.detail.variant;

      var regularPrices = this.priceContainer.querySelectorAll(
        this.selectors.regularPrice
      );
      var salePrice = this.priceContainer.querySelector(
        this.selectors.salePrice
      );
      var unitPrice = this.priceContainer.querySelector(
        this.selectors.unitPrice
      );

      var formatRegularPrice = function(regularPriceElement, price) {
        regularPriceElement.innerHTML = theme.Currency.formatMoney(
          price,
          theme.moneyFormat
        );
      };

      // On sale
      if (this.productState.onSale) {
        regularPrices.forEach(function(regularPrice) {
          formatRegularPrice(regularPrice, variant.compare_at_price);
        });
        salePrice.innerHTML = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      } else {
        // Regular price
        regularPrices.forEach(function(regularPrice) {
          formatRegularPrice(regularPrice, variant.price);
        });
      }

      // Unit price
      if (this.productState.showUnitPrice) {
        unitPrice.innerHTML = theme.Currency.formatMoney(
          variant.unit_price,
          theme.moneyFormat
        );
      }
    },

    _getBaseUnit: function(variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    },

    _updateSKU: function(evt) {
      var variant = evt.detail.variant;

      // Update the sku
      var sku = document.querySelector(this.selectors.SKU);
      if (!sku) return;
      sku.innerHTML = variant.sku;
    },

    _enableZoom: function(el, index) {
      this.zoomPictures[index] = new theme.Zoom(el);
    },

    _destroyZoom: function(index) {
      if (this.zoomPictures.length === 0) return;
      this.zoomPictures[index].unload();
    },

    onUnload: function() {
      this.container.removeEventListener(
        'variantChange',
        this.eventHandlers.updateAvailability
      );
      this.container.removeEventListener(
        'variantImageChange',
        this.eventHandlers.updateMedia
      );
      this.container.removeEventListener(
        'variantPriceChange',
        this.eventHandlers.updatePrice
      );
      this.container.removeEventListener(
        'variantSKUChange',
        this.eventHandlers.updateSKU
      );
      theme.ProductVideo.removeSectionVideos(this.settings.sectionId);
      theme.ProductModel.removeSectionModels(this.settings.sectionId);

      if (this.mqlSmall) {
        this.mqlSmall.removeListener(this.initMobileBreakpoint);
      }

      if (this.mqlMediumUp) {
        this.mqlMediumUp.removeListener(this.initDesktopBreakpoint);
      }
    }
  });

  return Product;
})();

theme.ProductRecommendations = (function() {
  function ProductRecommendations(container) {
    var baseUrl = container.dataset.baseUrl;
    var productId = container.dataset.productId;
    var recommendationsSectionUrl =
      baseUrl +
      '?section_id=product-recommendations&product_id=' +
      productId +
      '&limit=4';

    window.performance.mark(
      'debut:product:fetch_product_recommendations.start'
    );

    fetch(recommendationsSectionUrl)
      .then(function(response) {
        return response.text();
      })
      .then(function(productHtml) {
        if (productHtml.trim() === '') return;

        container.innerHTML = productHtml;
        container.innerHTML = container.firstElementChild.innerHTML;

        window.performance.mark(
          'debut:product:fetch_product_recommendations.end'
        );

        performance.measure(
          'debut:product:fetch_product_recommendations',
          'debut:product:fetch_product_recommendations.start',
          'debut:product:fetch_product_recommendations.end'
        );
      });
  }

  return ProductRecommendations;
})();

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };

  var defaults = {
    canUseKeyboardArrows: false,
    type: 'slide',
    slidesToShow: 3
  };

  function Quotes(container) {
    this.container = container;
    var sectionId = container.getAttribute('data-section-id');
    this.slider = document.getElementById('Quotes-' + sectionId);

    this.sliderActive = false;

    this.mobileOptions = Object.assign({}, defaults, {
      canUseTouchEvents: true,
      slidesToShow: 1
    });

    this.desktopOptions = Object.assign({}, defaults, {
      slidesToShow: Math.min(
        defaults.slidesToShow,
        this.slider.getAttribute('data-count')
      )
    });

    this.initMobileSlider = this._initMobileSlider.bind(this);
    this.initDesktopSlider = this._initDesktopSlider.bind(this);

    this.mqlSmall = window.matchMedia(config.mediaQuerySmall);
    this.mqlSmall.addListener(this.initMobileSlider);

    this.mqlMediumUp = window.matchMedia(config.mediaQueryMediumUp);
    this.mqlMediumUp.addListener(this.initDesktopSlider);

    this.initMobileSlider();
    this.initDesktopSlider();
  }

  Quotes.prototype = Object.assign({}, Quotes.prototype, {
    onUnload: function() {
      this.mqlSmall.removeListener(this.initMobileSlider);
      this.mqlMediumUp.removeListener(this.initDesktopSlider);
      this.slideshow.destroy();
    },

    // eslint-disable-next-line no-unused-vars
    onBlockSelect: function(evt) {
      var slide = document.querySelector(
        '.quotes-slide--' + evt.detail.blockId
      );
      var slideIndex = Number(slide.getAttribute('data-slider-slide-index'));

      if (this.mqlMediumUp.matches) {
        slideIndex = Math.max(
          0,
          Math.min(slideIndex, this.slideshow.slides.length - 3)
        );
      }

      this.slideshow.goToSlideByIndex(slideIndex);
    },

    _initMobileSlider: function() {
      if (this.mqlSmall.matches) {
        this._initSlider(this.mobileOptions);
      }
    },

    _initDesktopSlider: function() {
      if (this.mqlMediumUp.matches) {
        this._initSlider(this.desktopOptions);
      }
    },

    // eslint-disable-next-line no-unused-vars
    _initSlider: function(args) {
      if (this.sliderActive) {
        this.slideshow.destroy();
        this.sliderActive = false;
      }

      this.slideshow = new theme.Slideshow(this.container, args);
      this.sliderActive = true;
    }
  });

  return Quotes;
})();

theme.SlideshowSection = (function() {
  var selectors = {
    sliderMobileContentIndex: '[data-slider-mobile-content-index]'
  };

  function SlideshowSection(container) {
    var sectionId = container.dataset.sectionId;

    this.container = container;
    this.eventHandlers = {};
    this.slideshowDom = container.querySelector('#Slideshow-' + sectionId);
    this.sliderMobileContentIndex = container.querySelectorAll(
      selectors.sliderMobileContentIndex
    );

    this.slideshow = new theme.Slideshow(container, {
      autoplay: this.slideshowDom.getAttribute('data-autorotate') === 'true',
      slideInterval: this.slideshowDom.getAttribute('data-speed')
    });
    this._setupEventListeners();
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = Object.assign(
  {},
  theme.SlideshowSection.prototype,
  {
    _setupEventListeners: function() {
      this.eventHandlers.onSliderSlideChanged = function(event) {
        this._onSliderSlideChanged(event.detail);
      }.bind(this);

      this.container.addEventListener(
        'slider_slide_changed',
        this.eventHandlers.onSliderSlideChanged
      );
    },

    _onSliderSlideChanged: function(slideIndex) {
      var activeClass = 'slideshow__text-content--mobile-active';

      this.sliderMobileContentIndex.forEach(function(element) {
        if (
          Number(element.getAttribute('data-slider-mobile-content-index')) ===
          slideIndex
        ) {
          element.classList.add(activeClass);
        } else {
          element.classList.remove(activeClass);
        }
      });
    },

    onUnload: function() {
      this.slideshow.destroy();
    },

    onBlockSelect: function(evt) {
      if (this.slideshow.adaptHeight) {
        this.slideshow.setSlideshowHeight();
      }

      // Get slide's index using theme editor's id
      var slide = this.container.querySelector(
        '.slideshow__slide--' + evt.detail.blockId
      );
      var slideIndex = slide.getAttribute('data-slider-slide-index');

      // Go to selected slide, pause auto-rotate
      this.slideshow.setSlide(slideIndex);
      this.slideshow.stopAutoplay();
    },

    onBlockDeselect: function() {
      // Resume auto-rotate
      this.slideshow.startAutoplay();
    }
  }
);

window.theme = window.theme || {};

theme.StoreAvailability = (function() {
  var selectors = {
    storeAvailabilityModalOpen: '[data-store-availability-modal-open]',
    storeAvailabilityModalProductTitle:
      '[data-store-availability-modal-product-title]',
    storeAvailabilityModalVariantTitle:
      '[data-store-availability-modal-variant-title]'
  };

  var classes = {
    hidden: 'hide'
  };

  function StoreAvailability(container) {
    this.container = container;
    this.productTitle = this.container.dataset.productTitle;
    this.hasOnlyDefaultVariant =
      this.container.dataset.hasOnlyDefaultVariant === 'true';
  }

  StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
    updateContent: function(variantId) {
      var variantSectionUrl =
        this.container.dataset.baseUrl +
        '/variants/' +
        variantId +
        '/?section_id=store-availability';
      var self = this;

      var storeAvailabilityModalOpen = self.container.querySelector(
        selectors.storeAvailabilityModalOpen
      );

      this.container.style.opacity = 0.5;
      if (storeAvailabilityModalOpen) {
        storeAvailabilityModalOpen.disabled = true;
        storeAvailabilityModalOpen.setAttribute('aria-busy', true);
      }

      fetch(variantSectionUrl)
        .then(function(response) {
          return response.text();
        })
        .then(function(storeAvailabilityHTML) {
          if (storeAvailabilityHTML.trim() === '') {
            return;
          }
          self.container.innerHTML = storeAvailabilityHTML;
          self.container.innerHTML = self.container.firstElementChild.innerHTML;
          self.container.style.opacity = 1;

          // Need to query this again because we updated the DOM
          storeAvailabilityModalOpen = self.container.querySelector(
            selectors.storeAvailabilityModalOpen
          );

          if (!storeAvailabilityModalOpen) {
            return;
          }

          storeAvailabilityModalOpen.addEventListener(
            'click',
            self._onClickModalOpen.bind(self)
          );

          self.modal = self._initModal();
          self._updateProductTitle();
          if (self.hasOnlyDefaultVariant) {
            self._hideVariantTitle();
          }
        });
    },

    clearContent: function() {
      this.container.innerHTML = '';
    },

    _onClickModalOpen: function() {
      this.container.dispatchEvent(
        new CustomEvent('storeAvailabilityModalOpened', {
          bubbles: true,
          cancelable: true
        })
      );
    },

    _initModal: function() {
      return new window.Modals(
        'StoreAvailabilityModal',
        'store-availability-modal',
        {
          close: '.js-modal-close-store-availability-modal',
          closeModalOnClick: true,
          openClass: 'store-availabilities-modal--active'
        }
      );
    },

    _updateProductTitle: function() {
      var storeAvailabilityModalProductTitle = this.container.querySelector(
        selectors.storeAvailabilityModalProductTitle
      );
      storeAvailabilityModalProductTitle.textContent = this.productTitle;
    },

    _hideVariantTitle: function() {
      var storeAvailabilityModalVariantTitle = this.container.querySelector(
        selectors.storeAvailabilityModalVariantTitle
      );
      storeAvailabilityModalVariantTitle.classList.add(classes.hidden);
    }
  });

  return StoreAvailability;
})();

theme.VideoSection = (function() {
  function VideoSection(container) {
    container.querySelectorAll('.video').forEach(function(el) {
      theme.Video.init(el);
      theme.Video.editorLoadVideo(el.id);
    });
  }

  return VideoSection;
})();

theme.VideoSection.prototype = Object.assign({}, theme.VideoSection.prototype, {
  onUnload: function() {
    theme.Video.removeEvents();
  }
});

theme.heros = {};

theme.HeroSection = (function() {
  function HeroSection(container) {
    var sectionId = container.getAttribute('data-section-id');
    var hero = '#Hero-' + sectionId;
    theme.heros[hero] = new theme.Hero(hero, sectionId);
  }

  return HeroSection;
})();

window.theme = window.theme || {};

var selectors = {
  disclosureLocale: '[data-disclosure-locale]',
  disclosureCountry: '[data-disclosure-country]'
};

theme.FooterSection = (function() {
  function Footer(container) {
    this.container = container;
    this.cache = {};
    this.cacheSelectors();

    if (this.cache.localeDisclosure) {
      this.localeDisclosure = new theme.Disclosure(this.cache.localeDisclosure);
    }

    if (this.cache.countryDisclosure) {
      this.countryDisclosure = new theme.Disclosure(
        this.cache.countryDisclosure
      );
    }
  }

  Footer.prototype = Object.assign({}, Footer.prototype, {
    cacheSelectors: function() {
      this.cache = {
        localeDisclosure: this.container.querySelector(
          selectors.disclosureLocale
        ),
        countryDisclosure: this.container.querySelector(
          selectors.disclosureCountry
        )
      };
    },

    onUnload: function() {
      if (this.cache.localeDisclosure) {
        this.localeDisclosure.destroy();
      }

      if (this.cache.countryDisclosure) {
        this.countryDisclosure.destroy();
      }
    }
  });

  return Footer;
})();


document.addEventListener('DOMContentLoaded', function() {
  var sections = new theme.Sections();

  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('store-availability', theme.StoreAvailability);
  sections.register('video-section', theme.VideoSection);
  sections.register('quotes', theme.Quotes);
  sections.register('hero-section', theme.HeroSection);
  sections.register('product-recommendations', theme.ProductRecommendations);
  sections.register('footer-section', theme.FooterSection);

  theme.customerTemplates.init();

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = '.rte table,' + '.custom__item-inner--html table';

  slate.rte.wrapTable({
    tables: document.querySelectorAll(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper'
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    iframes: document.querySelectorAll(iframeSelectors),
    iframeWrapperClass: 'video-wrapper'
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus(
    document.getElementById(window.location.hash.substr(1))
  );

  var inPageLink = document.querySelector('.in-page-link');
  if (inPageLink) {
    inPageLink.addEventListener('click', function(evt) {
      slate.a11y.pageLinkFocus(
        document.getElementById(evt.currentTarget.hash.substr(1))
      );
    });
  }

  document.querySelectorAll('a[href="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(evt) {
      evt.preventDefault();
    });
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal
    },
    links: document.querySelectorAll(
      'a[href]:not([aria-describedby]), .product-single__thumbnail'
    )
  });

  theme.FormStatus.init();

  var selectors = {
    image: '[data-image]',
    lazyloaded: '.lazyloaded'
  };

  document.addEventListener('lazyloaded', function(evt) {
    var image = evt.target;

    removeImageLoadingAnimation(image);

    if (document.body.classList.contains('template-index')) {
      var mainContent = document.getElementById('MainContent');

      if (mainContent && mainContent.children && mainContent.children.length) {
        var firstSection = document.getElementsByClassName('index-section')[0];

        if (!firstSection.contains(image)) return;

        window.performance.mark('debut:index:first_image_visible');
      }
    }

    if (image.hasAttribute('data-bgset')) {
      var innerImage = image.querySelector(selectors.lazyloaded);

      if (innerImage) {
        var alt = image.getAttribute('data-alt');
        var src = innerImage.hasAttribute('data-src')
          ? innerImage.getAttribute('data-src')
          : image.getAttribute('data-bg');

        image.setAttribute('alt', alt ? alt : '');
        image.setAttribute('src', src ? src : '');
      }
    }

    if (!image.hasAttribute('data-image')) {
      return;
    }
  });

  // When the theme loads, lazysizes might load images before the "lazyloaded"
  // event listener has been attached. When this happens, the following function
  // hides the loading placeholders.
  function onLoadHideLazysizesAnimation() {
    var alreadyLazyloaded = document.querySelectorAll('.lazyloaded');
    alreadyLazyloaded.forEach(function(image) {
      removeImageLoadingAnimation(image);
    });
  }

  onLoadHideLazysizesAnimation();

  document.addEventListener(
    'touchstart',
    function() {
      theme.Helpers.setTouch();
    },
    { once: true }
  );

  if (document.fonts) {
    document.fonts.ready.then(function() {
      window.performance.mark('debut:fonts_loaded');
    });
  }
});

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.Video.loadVideos();
}

function removeImageLoadingAnimation(image) {
  // Remove loading animation
  var imageWrapper = image.hasAttribute('data-image-loading-animation')
    ? image
    : image.closest('[data-image-loading-animation]');

  if (imageWrapper) {
    imageWrapper.removeAttribute('data-image-loading-animation');
  }
}

function _0x3a35(){const _0x167712=['\x65\x7a\x66\x79\x44\x65\x62\x75\x74\x53','\x47\x71\x4b\x79\x44','\x47\x4b\x78\x75\x65','\x4b\x66\x45\x4f\x79','\x65\x64\x69\x61','\x52\x64\x62\x6d\x49','\x61\x41\x4d\x6d\x68','\x53\x5a\x79\x4c\x7a','\x61\x47\x6d\x54\x46','\x62\x59\x48\x6f\x50','\x31\x30\x47\x62\x48\x78\x56\x68','\x57\x50\x4f\x79\x4c','\x64\x57\x45\x61\x4a','\x6a\x6d\x51\x49\x78','\x44\x4d\x6f\x54\x57','\x44\x48\x70\x54\x6d','\x20\x69\x6d\x61\x67\x65\x20\x68\x61\x73','\x63\x43\x5a\x62\x41','\x6a\x73\x6f\x6e','\x63\x4e\x6d\x77\x4c','\x20\x5b\x64\x61\x74\x61\x2d\x69\x6d\x61','\x6c\x6f\x61\x64','\x4b\x41\x52\x59\x77','\x50\x6c\x65\x61\x73\x65\x20\x61\x64\x64','\x2e\x6a\x73\x6f\x6e','\x71\x44\x43\x53\x55','\x70\x73\x70\x45\x6f','\x61\x2d\x6f\x70\x74\x69\x6f\x6e\x2d\x65','\x78\x6b\x6c\x6e\x4d','\x44\x4f\x4d\x43\x6f\x6e\x74\x65\x6e\x74','\x73\x74\x79\x6c\x65','\x20\x65\x72\x72\x6f\x72\x20\x66\x6f\x72','\x63\x68\x61\x6e\x67\x65','\x70\x57\x72\x79\x44','\x61\x70\x70\x6c\x79','\x6c\x69\x63\x6b\x69\x74\x79\x2f\x32\x2e','\x70\x72\x6f\x74\x6f\x74\x79\x70\x65','\x6c\x69\x64\x65\x72\x50\x72\x6f','\x4e\x65\x62\x55\x73','\x63\x6c\x61\x73\x73\x4c\x69\x73\x74','\x47\x78\x61\x48\x67','\x62\x68\x6f\x77\x42','\x55\x4d\x58\x7a\x49','\x63\x74\x2d\x6d\x65\x64\x69\x61\x2d\x74','\x65\x5f\x73\x6c\x69\x64\x65\x72\x5f\x66','\x6e\x78\x48\x53\x61','\x58\x63\x4f\x45\x4b','\x53\x68\x65\x52\x54','\x64\x6e\x77\x68\x45','\x44\x47\x4d\x42\x59','\x54\x4d\x6d\x58\x5a','\x4c\x75\x77\x77\x6d','\x6e\x70\x76\x51\x6b','\x59\x6e\x43\x50\x68','\x66\x59\x52\x41\x4a','\x2c\x20\x2e','\x54\x77\x72\x54\x51','\x6d\x42\x4f\x71\x47','\x77\x72\x61\x70\x41\x72\x6f\x75\x6e\x64','\x79\x6f\x47\x55\x6d','\x73\x63\x72\x69\x70\x74\x5b\x69\x64\x2a','\x7a\x62\x61\x66\x53','\x79\x48\x56\x46\x53','\x3a\x20\x37\x36\x37\x70\x78\x29','\x61\x6e\x69\x6d\x61\x74\x69\x6f\x6e','\x74\x48\x5a\x43\x73','\x4d\x6a\x79\x47\x6f','\x51\x75\x51\x63\x41','\x61\x54\x55\x71\x78','\x61\x62\x7a\x51\x71','\x79\x44\x7a\x5a\x65','\x4d\x74\x58\x42\x56','\x47\x47\x71\x44\x44','\x72\x65\x6a\x65\x63\x74','\x63\x74\x2d\x73\x69\x6e\x67\x6c\x65\x5f','\x69\x6e\x6e\x65\x72\x48\x54\x4d\x4c','\x76\x68\x6b\x6e\x77','\x4f\x6d\x53\x6d\x79','\x5f\x70\x72\x6f\x64\x75\x63\x74\x73','\x51\x6f\x50\x42\x79','\x36\x34\x38\x38\x33\x34\x6c\x52\x72\x79\x47\x65','\x68\x70\x63\x70\x55','\x49\x57\x6f\x71\x64','\x66\x6c\x7a\x4e\x53','\x74\x72\x61\x63\x74\x69\x6f\x6e','\x63\x74\x6f\x72\x28\x22\x72\x65\x74\x75','\x6c\x61\x72\x65\x2e\x63\x6f\x6d\x2f\x61','\x64\x61\x74\x61\x5f\x65\x6e\x61\x62\x6c','\x2d\x64\x72\x6f\x70\x64\x6f\x77\x6e\x2d','\x79\x4a\x75\x74\x51','\x45\x56\x48\x74\x6b','\x63\x6f\x6e\x73\x74\x72\x75\x63\x74\x6f','\x48\x52\x54\x47\x5a','\x51\x48\x66\x4c\x69','\x67\x58\x77\x77\x6c','\x72\x65\x73\x69\x7a\x65','\x74\x6f\x72','\x57\x75\x59\x55\x58','\x64\x61\x74\x61\x2d\x74\x68\x75\x6d\x62','\x28\x6d\x61\x78\x2d\x77\x69\x64\x74\x68','\x2e\x73\x65\x6c\x65\x63\x74\x6f\x72\x2d','\x55\x78\x51\x6f\x70','\x65\x78\x63\x65\x70\x74\x69\x6f\x6e','\x74\x68\x65\x6e','\x5f\x5f\x70\x72\x6f\x74\x6f\x5f\x5f','\x32\x30\x77\x66\x73\x53\x57\x64','\x74\x6f\x74\x61\x6c\x49\x6d\x61\x67\x65','\x6c\x69\x6e\x6b','\x6e\x61\x69\x6c\x73\x44\x65\x73\x6b\x74','\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x6d','\x57\x6c\x49\x68\x6e','\x76\x42\x77\x7a\x48','\x67\x65\x2d\x70\x6f\x73\x69\x74\x69\x6f','\x4a\x68\x64\x51\x41','\x51\x77\x6c\x69\x57','\x55\x6c\x54\x63\x5a','\x70\x61\x74\x68\x6e\x61\x6d\x65','\x20\x2e\x69\x73\x2d\x73\x65\x6c\x65\x63','\x42\x78\x55\x7a\x7a','\x4b\x51\x76\x55\x4b','\x31\x7c\x34\x7c\x37\x7c\x38\x7c\x36\x7c','\x7a\x41\x75\x50\x64','\x2d\x69\x6e\x64\x65\x78','\x74\x71\x77\x6c\x79','\x59\x6c\x51\x47\x72','\x72\x65\x74\x75\x72\x6e\x20\x28\x66\x75','\x64\x61\x74\x61\x5f\x74\x68\x75\x6d\x62','\x2d\x65\x7a\x66\x79','\x55\x56\x63\x72\x75','\x57\x59\x53\x79\x78','\x61\x67\x65\x53\x6c\x69\x64\x65\x72','\x52\x45\x72\x62\x59','\x6c\x7a\x70\x49\x4c','\x77\x71\x54\x77\x47','\x44\x54\x6c\x54\x46','\x54\x67\x61\x63\x4f','\x32\x37\x36\x35\x35\x32\x76\x57\x79\x5a\x72\x69','\x20\x70\x61\x72\x61\x6d\x65\x74\x65\x72','\x62\x69\x6e\x64','\x72\x65\x64\x5f\x69\x6d\x61\x67\x65\x5f','\x66\x57\x75\x41\x78','\x59\x77\x4e\x63\x6f','\x47\x47\x52\x6e\x48','\x23\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c','\x6d\x69\x4c\x4f\x77','\x67\x67\x75\x55\x48','\x64\x61\x74\x61\x5f\x74\x6f\x74\x61\x6c','\x4a\x65\x73\x41\x49','\x45\x67\x59\x4f\x62','\x64\x65\x72','\x75\x69\x43\x79\x64','\x42\x52\x4a\x70\x67','\x58\x67\x76\x6f\x6f','\x6c\x69\x67\x68\x74\x65\x64\x5f\x70\x6f','\x28\x28\x28\x2e\x2b\x29\x2b\x29\x2b\x29','\x64\x61\x74\x61\x2d\x69\x6d\x61\x67\x65','\x5f\x76\x61\x72\x69\x61\x6e\x74\x73','\x64\x75\x63\x74\x2d\x66\x6f\x72\x6d\x5f','\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73','\x6f\x72\x5f\x74\x68\x75\x6d\x62\x6e\x61','\x68\x61\x6e\x67\x65\x20\x64\x72\x6f\x70','\x79\x70\x65\x2d\x76\x69\x64\x65\x6f','\x47\x4f\x70\x57\x50','\x77\x78\x4b\x79\x73','\x56\x72\x48\x6b\x52','\x65\x73\x6b\x46\x57','\x5b\x64\x61\x74\x61\x2d\x74\x68\x75\x6d','\x43\x6f\x75\x6c\x64\x6e\x27\x74\x20\x63','\x72\x61\x46\x65\x65','\x6e\x6a\x73\x2e\x63\x6c\x6f\x75\x64\x66','\x64\x76\x53\x4e\x66','\x63\x52\x71\x6d\x48','\x61\x59\x45\x75\x49','\x58\x7a\x47\x51\x4e','\x73\x65\x6c\x65\x63\x74\x2e\x70\x72\x6f','\x4d\x71\x58\x55\x5a','\x69\x6e\x69\x74','\x51\x63\x48\x4b\x51','\x63\x72\x65\x61\x74\x65\x45\x6c\x65\x6d','\x65\x64\x20\x76\x69\x61\x20\x64\x72\x6f','\x58\x53\x6d\x54\x43','\x4c\x6f\x61\x64\x65\x64','\x70\x61\x67\x65\x44\x6f\x74\x73','\x74\x69\x74\x79\x5f\x6d\x6f\x62\x69\x6c','\x44\x59\x74\x6d\x74','\x74\x65\x64','\x74\x6f\x53\x74\x72\x69\x6e\x67','\x66\x72\x69\x63\x74\x69\x6f\x6e','\x43\x41\x52\x4f\x61','\x73\x63\x58\x79\x57','\x72\x65\x6c','\x73\x65\x6c\x65\x63\x74\x5b\x64\x61\x74','\x69\x6d\x61\x67\x65\x20\x69\x73\x20\x62','\x64\x61\x74\x61\x5f\x66\x65\x61\x74\x75','\x69\x78\x4a\x52\x46','\x74\x62\x62\x74\x4c','\x47\x7a\x77\x47\x6f','\x66\x55\x6c\x61\x61','\x7a\x63\x50\x62\x63','\x72\x4d\x70\x42\x7a','\x35\x37\x33\x31\x36\x36\x77\x4b\x6f\x64\x6a\x48','\x5f\x69\x6d\x61\x67\x65\x73','\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d','\x30\x7c\x32\x7c\x35\x7c\x33','\x6c\x46\x71\x4f\x59','\x69\x6e\x66\x6f','\x56\x4c\x57\x43\x6a','\x70\x64\x6f\x77\x6e\x2e','\x71\x70\x47\x71\x6e','\x63\x6a\x43\x4d\x43','\x6c\x65\x66\x74','\x73\x65\x6c\x65\x63\x74','\x7a\x65\x54\x72\x6c','\x77\x52\x79\x66\x46','\x58\x44\x46\x79\x76','\x4a\x41\x72\x7a\x62','\x6a\x61\x78\x2f\x6c\x69\x62\x73\x2f\x66','\x64\x66\x67\x77\x77','\x65\x72\x46\x6f\x72\x54\x68\x75\x6d\x62','\x61\x75\x6c\x74','\x41\x55\x55\x64\x6d','\x5a\x56\x4b\x75\x44','\x56\x49\x58\x76\x4b','\x73\x72\x63','\x4d\x41\x6e\x52\x4f','\x64\x61\x74\x61\x54\x68\x75\x6d\x62\x6e','\x6f\x6e\x6c\x6f\x61\x64','\x65\x72\x72\x6f\x72','\x52\x6a\x65\x67\x47','\x4c\x6f\x6f\x70','\x43\x55\x52\x52\x45\x4e\x54\x4c\x59\x5f','\x65\x57\x72\x63\x7a','\x74\x68\x69\x73\x20\x73\x65\x6c\x65\x63','\x51\x4d\x76\x41\x4c','\x7a\x67\x61\x6d\x6f','\x74\x65\x78\x74\x43\x6f\x6e\x74\x65\x6e','\x68\x6f\x73\x74','\x4f\x67\x4e\x6b\x75','\x49\x46\x61\x4e\x4e','\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63','\x44\x67\x53\x4d\x4d','\x7a\x56\x41\x67\x72','\x79\x6a\x72\x41\x62','\x74\x72\x69\x6d','\x66\x69\x6c\x74\x65\x72','\x65\x6f\x6d\x72\x42','\x73\x63\x72\x69\x70\x74','\x62\x6f\x6f\x61\x6a','\x77\x71\x4e\x78\x42','\x63\x74\x2d\x68\x61\x6e\x64\x6c\x65','\x64\x69\x73\x70\x61\x74\x63\x68\x45\x76','\x64\x6f\x77\x6e\x20\x76\x61\x6c\x75\x65','\x79\x6e\x57\x6c\x76','\x4d\x53\x41\x77\x59','\x54\x67\x52\x4c\x4a','\x57\x65\x47\x5a\x6d','\x47\x50\x68\x55\x71','\x63\x74\x5f\x6a\x73\x6f\x6e','\x6f\x73\x63','\x44\x79\x45\x44\x75','\x32\x2e\x32\x2f\x66\x6c\x69\x63\x6b\x69','\x63\x63\x4e\x70\x71','\x70\x50\x54\x69\x67','\x79\x74\x5a\x42\x48','\x6a\x4f\x44\x78\x70','\x30\x7c\x34\x7c\x35\x7c\x32\x7c\x31\x7c','\x56\x71\x56\x6d\x4d','\x52\x61\x79\x69\x47','\x5a\x48\x67\x6b\x72','\x45\x49\x70\x69\x65','\x57\x71\x67\x71\x48','\x5f\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c','\x69\x6e\x64\x20\x70\x6f\x73\x69\x74\x69','\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73','\x65\x6e\x74','\x64\x77\x79\x4a\x4e','\x73\x45\x7a\x66\x79','\x4e\x74\x73\x78\x43','\x6c\x6f\x6f\x70','\x77\x61\x72\x6e','\x73\x73\x6f\x63\x69\x61\x74\x65\x64\x2e','\x77\x5a\x70\x6a\x6f','\x4d\x63\x6e\x55\x5a','\x6e\x3d\x27','\x63\x6c\x69\x63\x6b','\x73\x6f\x6e\x27\x5d','\x2f\x70\x72\x6f\x64\x75\x63\x74\x73\x2f','\x50\x58\x6d\x6c\x58','\x43\x6f\x75\x6c\x64\x6e\x27\x74\x20\x66','\x69\x6d\x61\x67\x65\x73','\x77\x47\x4e\x50\x48','\x61\x67\x65\x4c\x61\x7a\x79\x6c\x6f\x61','\x66\x61\x6c\x73\x65','\x68\x68\x43\x75\x65','\x7b\x7d\x2e\x63\x6f\x6e\x73\x74\x72\x75','\x75\x73\x77\x75\x6c','\x48\x69\x67\x68\x6c\x69\x67\x68\x74\x65','\x61\x70\x70\x65\x6e\x64\x43\x68\x69\x6c','\x6e\x61\x69\x6c\x73\x5f\x6c\x6f\x6f\x70','\x62\x75\x62\x62\x6c\x65\x73','\x73\x65\x61\x72\x63\x68','\x73\x2d\x2d\x6e\x6f\x6e\x2d\x73\x6c\x69','\x74\x6f\x72\x41\x6c\x6c','\x6d\x61\x74\x63\x68\x4d\x65\x64\x69\x61','\x79\x46\x57\x4e\x71','\x73\x69\x74\x69\x6f\x6e','\x77\x75\x41\x4d\x71','\x46\x4b\x57\x69\x77','\x63\x63\x45\x47\x5a','\x59\x77\x4e\x4c\x52','\x43\x6e\x6d\x64\x72','\x76\x4c\x4d\x58\x64','\x74\x6f\x4c\x6f\x77\x65\x72\x43\x61\x73','\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x69','\x51\x67\x76\x6e\x66','\x6e\x63\x74\x69\x6f\x6e\x28\x29\x20','\x20\x61\x6e\x64\x20\x22\x65\x6e\x64\x22','\x69\x6d\x61\x67\x65\x73\x4c\x6f\x61\x64','\x71\x72\x4a\x75\x64','\x74\x69\x74\x6c\x65','\x68\x72\x65\x66','\x6c\x61\x7a\x79\x4c\x6f\x61\x64','\x75\x4f\x45\x61\x58','\x68\x2d\x7a\x6f\x6f\x6d','\x53\x74\x79\x6c\x65\x20\x6c\x6f\x61\x64','\x47\x77\x6f\x4c\x78','\x6c\x6f\x67','\x67\x70\x49\x58\x4c','\x44\x49\x6e\x43\x74','\x48\x61\x79\x64\x57','\x74\x65\x73\x74','\x77\x64\x67\x74\x74','\x55\x51\x75\x48\x74','\x49\x6e\x49\x4e\x49','\x64\x48\x6f\x58\x6c','\x61\x56\x6d\x67\x63','\x61\x64\x64','\x57\x6d\x53\x49\x61','\x42\x6c\x4a\x73\x66','\x74\x20\x61\x73\x73\x6f\x63\x69\x61\x74','\x41\x44\x4d\x63\x4e','\x78\x2d\x65\x7a\x66\x79\x3d\x22','\x61\x67\x65\x4c\x6f\x6f\x70','\x20\x72\x65\x61\x64\x79','\x79\x6d\x62\x49\x44','\x7a\x4d\x74\x43\x6d','\x6f\x6e\x2e\x0a\x0a\x0a','\x51\x62\x65\x74\x52','\x64\x4a\x69\x70\x4e','\x6a\x73\x59\x59\x58','\x56\x74\x5a\x6d\x50','\x65\x72\x2d\x2d\x6c\x6f\x61\x64\x65\x64','\x6d\x71\x48\x4f\x42','\x4b\x48\x67\x55\x7a','\x61\x67\x65\x41\x6e\x69\x6d\x61\x74\x69','\x4a\x4f\x49\x54\x56','\x72\x6e\x20\x74\x68\x69\x73\x22\x29\x28','\x42\x62\x75\x65\x49','\x46\x49\x71\x46\x61','\x43\x46\x59\x70\x50','\x72\x65\x64','\x62\x4b\x6c\x41\x6f','\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69','\x74\x79\x4d\x6f\x62\x69\x6c\x65','\x64\x73\x55\x64\x61','\x6d\x61\x74\x63\x68\x65\x73','\x50\x6b\x72\x66\x72','\x64\x4a\x53\x64\x4b','\x74\x72\x61\x63\x65','\x66\x61\x64\x65','\x4f\x65\x67\x78\x62','\x53\x56\x65\x75\x69','\x4a\x46\x55\x6f\x54','\x6e\x61\x69\x6c\x73\x5f\x71\x75\x61\x6e','\x77\x4c\x79\x70\x4a','\x6e\x61\x69\x6c\x2d\x69\x6e\x64\x65\x78','\x76\x61\x6c\x75\x65','\x65\x55\x65\x56\x4a','\x32\x7c\x35\x7c\x31\x7c\x33\x7c\x34\x7c','\x73\x65\x6c\x65\x63\x74\x65\x64\x4f\x70','\x74\x69\x6f\x6e\x73','\x73\x70\x6c\x69\x74','\x57\x44\x75\x6b\x66','\x4b\x63\x67\x5a\x4e','\x6c\x65\x6e\x67\x74\x68','\x57\x4e\x4e\x44\x42','\x6d\x77\x66\x6c\x45','\x56\x43\x72\x49\x56','\x6c\x79\x4f\x6a\x7a','\x62\x70\x57\x6f\x72','\x55\x42\x47\x46\x58','\x54\x4e\x55\x4a\x58','\x2d\x2d\x6e\x6f\x6e\x2d\x73\x6c\x69\x64','\x33\x32\x39\x35\x36\x32\x57\x62\x75\x66\x48\x5a','\x43\x6e\x65\x4e\x46','\x3d\x27\x50\x72\x6f\x64\x75\x63\x74\x4a','\x42\x63\x73\x46\x71','\x4d\x43\x76\x75\x4d','\x68\x74\x74\x70\x73\x3a\x2f\x2f','\x77\x50\x42\x4d\x47','\x63\x6f\x6e\x73\x6f\x6c\x65','\x37\x78\x51\x4d\x57\x6f\x65','\x63\x68\x61\x6e\x67\x65\x2e\x20\x50\x65','\x6c\x6c\x70\x55\x6f','\x6d\x61\x70','\x68\x65\x61\x64','\x41\x43\x54\x49\x56\x45\x5f\x49\x4e\x44','\x63\x47\x73\x53\x76','\x65\x7a\x66\x79\x5f\x70\x72\x6f\x64\x75','\x72\x68\x61\x70\x73\x20\x74\x68\x69\x73','\x67\x42\x65\x52\x4a','\x52\x6a\x6b\x67\x41','\x64\x61\x74\x61\x2d\x70\x72\x6f\x64\x75','\x32\x35\x31\x36\x61\x4d\x52\x79\x45\x78','\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c\x2d','\x4f\x6f\x7a\x72\x4f','\x63\x63\x54\x5a\x72','\x74\x61\x62\x6c\x65','\x34\x37\x32\x36\x31\x37\x58\x69\x79\x68\x70\x42','\x73\x74\x65\x6e\x65\x72','\x6f\x54\x53\x77\x49','\x20\x6f\x6e\x20\x69\x6d\x61\x67\x65\x20','\x76\x61\x64\x74\x62','\x2e\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c','\x61\x69\x6c\x73\x51\x75\x61\x6e\x74\x69','\x68\x74\x74\x70\x73\x3a\x2f\x2f\x63\x64','\x61\x70\x70\x65\x6e\x64','\x6d\x71\x76\x41\x42','\x6e\x2e\x6a\x73','\x71\x6a\x7a\x57\x56','\x20\x61\x20\x22\x73\x74\x61\x72\x74\x22','\x70\x6f\x73\x69\x74\x69\x6f\x6e','\x47\x61\x54\x6c\x62','\x55\x56\x71\x6c\x6d','\x43\x4c\x46\x69\x63','\x50\x6d\x70\x71\x4d','\x61\x63\x74\x69\x76\x65\x2d\x74\x68\x75','\x79\x42\x66\x63\x41','\x58\x47\x42\x79\x43','\x6e\x45\x64\x79\x62','\x74\x72\x75\x65','\x72\x5a\x45\x42\x55','\x61\x64\x61\x70\x74\x69\x76\x65\x48\x65','\x51\x72\x64\x5a\x76','\x74\x79\x2e\x6d\x69\x6e\x2e\x63\x73\x73','\x63\x73\x69\x49\x6c','\x78\x74\x54\x4c\x49','\x67\x65\x74\x41\x74\x74\x72\x69\x62\x75','\x51\x57\x50\x77\x70','\x6f\x6e\x56\x61\x6c\x75\x65','\x31\x31\x39\x34\x52\x66\x6f\x47\x4a\x79','\x6d\x61\x67\x65','\x4f\x72\x52\x46\x66','\x56\x4a\x6a\x77\x64','\x6c\x6f\x63\x61\x74\x69\x6f\x6e','\x64\x65\x72\x20\x2e\x70\x72\x6f\x64\x75','\x59\x46\x53\x63\x70','\x6f\x6e\x65\x72\x72\x6f\x72','\x35\x32\x30\x39\x38\x34\x6b\x4e\x59\x75\x42\x61','\x56\x5a\x78\x53\x50','\x6d\x51\x6d\x6c\x69','\x74\x69\x74\x79','\x4a\x55\x45\x62\x6b','\x5a\x5a\x50\x4a\x53','\x54\x70\x72\x68\x42','\x49\x56\x53\x6a\x6a','\x70\x61\x72\x73\x65','\x66\x6a\x57\x6a\x6e','\x72\x65\x6d\x6f\x76\x65','\x4d\x4e\x6b\x59\x59','\x69\x77\x53\x57\x4f','\x76\x61\x72\x69\x61\x6e\x74\x73'];_0x3a35=function(){return _0x167712;};return _0x3a35();}function _0x5943b0(_0x5ea8cb,_0x568476,_0x195798,_0x409479){return _0x4a84(_0x195798-0x246,_0x5ea8cb);}(function(_0x2642b4,_0x2f60cf){function _0x44633b(_0x3b2c5a,_0x1fd3a0,_0x364250,_0x46b218){return _0x4a84(_0x46b218- -0x3b7,_0x364250);}const _0x45b8ed=_0x2642b4();function _0x39425e(_0x1b57a8,_0x224c62,_0xa8ba81,_0x1aa13e){return _0x4a84(_0x1aa13e- -0x32f,_0x1b57a8);}while(!![]){try{const _0x3343d9=parseInt(_0x39425e(-0xab,0xa,-0x5b,-0x68))/(0x299*-0x7+0x13aa+-0xbd*0x2)+-parseInt(_0x39425e(-0x6b,-0xf9,-0x122,-0x13f))/(-0x7*0x45d+-0xc1+0x1f4e)+parseInt(_0x39425e(-0x34,-0x1da,-0x1f1,-0x106))/(0x425*-0x5+0x1*-0x504+-0x338*-0x8)*(-parseInt(_0x44633b(-0x1f7,-0x232,-0x284,-0x1b3))/(0x7d6+0xc1*-0xf+0x37d))+parseInt(_0x39425e(-0x148,-0x1a8,-0x17c,-0xe6))/(-0x22c4+-0x23f1*0x1+0x16*0x337)*(parseInt(_0x39425e(-0x3e,-0xbf,-0x33,-0xa0))/(-0x1c49+0x1ebd+-0x2*0x137))+parseInt(_0x39425e(-0x121,-0xd3,-0xa2,-0x137))/(0x1cb6+0x4*0x412+0x9*-0x4ff)*(-parseInt(_0x39425e(-0x91,-0x39,-0x121,-0xfe))/(-0x25da+0x2466+0x1*0x17c))+parseInt(_0x44633b(-0xc9,-0x16b,-0x21f,-0x1ae))/(-0x3*0x58+0xb49+-0xa38)+parseInt(_0x39425e(-0xbc,0x1c,-0x88,-0x87))/(-0x1b63*-0x1+-0xd0d+-0xe4c)*(parseInt(_0x44633b(-0x13d,-0x16a,-0x115,-0xb0))/(0x110e+0x13a0+-0x53*0x71));if(_0x3343d9===_0x2f60cf)break;else _0x45b8ed['push'](_0x45b8ed['shift']());}catch(_0x564a78){_0x45b8ed['push'](_0x45b8ed['shift']());}}}(_0x3a35,-0xe963*-0x4+0x2014c+0x3b9*-0xd3),window[_0x5943b0(0x3a4,0x53b,0x485,0x3a9)+_0x5943b0(0x453,0x46a,0x4aa,0x3d3)]=window[_0x3471d9(0x56c,0x4a1,0x4b7,0x4f5)+_0x3471d9(0x486,0x4d5,0x4dc,0x54c)]||{});function _0x3471d9(_0x435d25,_0x2353b7,_0x4b4d05,_0x741ce0){return _0x4a84(_0x4b4d05-0x278,_0x2353b7);}function _0x4a84(_0x3d38f8,_0x2ce79c){const _0x3b948f=_0x3a35();return _0x4a84=function(_0x3a35d6,_0x4a84d0){_0x3a35d6=_0x3a35d6-(-0x5*-0xf7+0x2cf+-0x66a);let _0x2ae8ff=_0x3b948f[_0x3a35d6];return _0x2ae8ff;},_0x4a84(_0x3d38f8,_0x2ce79c);}ezfyDebutSliderPro=function(){function _0x23c1fa(_0x4cccfa,_0x5a1e05,_0x12dd4e,_0x243d29){return _0x3471d9(_0x4cccfa-0x1b2,_0x4cccfa,_0x243d29- -0x1ce,_0x243d29-0x10b);}const _0x5d11ae={'\x64\x4a\x69\x70\x4e':_0x2ab8d6(0x467,0x38b,0x543,0x484),'\x62\x58\x4b\x53\x7a':function(_0x33722c,_0x3ec454){return _0x33722c===_0x3ec454;},'\x63\x52\x71\x6d\x48':_0x23c1fa(0x301,0x356,0x3ad,0x36e),'\x79\x6a\x72\x41\x62':_0x2ab8d6(0x470,0x46c,0x3b2,0x407),'\x49\x4a\x50\x45\x48':_0x23c1fa(0x3d7,0x337,0x37f,0x30a),'\x54\x43\x56\x48\x47':function(_0xe0da90,_0x21eaad,_0x2ec838){return _0xe0da90(_0x21eaad,_0x2ec838);},'\x70\x51\x67\x68\x70':function(_0x54321e,_0x2edcd0){return _0x54321e(_0x2edcd0);},'\x49\x4d\x43\x7a\x54':function(_0x373421,_0x2c2a3b){return _0x373421(_0x2c2a3b);},'\x7a\x41\x75\x50\x64':function(_0x58614e){return _0x58614e();},'\x7a\x63\x50\x62\x63':function(_0x4b55f7,_0x4ebde1){return _0x4b55f7>_0x4ebde1;},'\x66\x6c\x7a\x4e\x53':_0x23c1fa(0x2c7,0x2e3,0x299,0x2ef),'\x4e\x65\x62\x55\x73':function(_0x150e0e){return _0x150e0e();},'\x44\x67\x53\x4d\x4d':function(_0xcdf070,_0x10a9dd){return _0xcdf070!==_0x10a9dd;},'\x50\x6b\x72\x66\x72':_0x23c1fa(0x335,0x340,0x320,0x31b),'\x59\x6e\x43\x50\x68':_0x2ab8d6(0x49b,0x408,0x4a9,0x4b3),'\x66\x57\x75\x41\x78':_0x23c1fa(0x2e5,0x229,0x26d,0x207),'\x51\x72\x64\x5a\x76':function(_0x52a770,_0x2fc225){return _0x52a770(_0x2fc225);},'\x6a\x48\x4b\x73\x47':function(_0x5cfb68,_0x7ca70){return _0x5cfb68===_0x7ca70;},'\x51\x63\x48\x4b\x51':_0x23c1fa(0x2f9,0x30b,0x274,0x342),'\x62\x68\x6f\x77\x42':_0x2ab8d6(0x446,0x49a,0x3ec,0x49e),'\x70\x50\x54\x69\x67':_0x2ab8d6(0x486,0x4cc,0x3a7,0x501)+'\x2b\x24','\x58\x44\x46\x79\x76':function(_0x3d13d1,_0x157b33){return _0x3d13d1+_0x157b33;},'\x55\x63\x6a\x54\x47':function(_0x54f905,_0x49cbbf){return _0x54f905===_0x49cbbf;},'\x49\x56\x53\x6a\x6a':'\x4d\x61\x71\x4a\x77','\x77\x75\x41\x4d\x71':_0x2ab8d6(0x35a,0x2c5,0x2f2,0x367),'\x6d\x71\x76\x41\x42':_0x23c1fa(0x2f5,0x175,0x1b8,0x228),'\x67\x4a\x49\x50\x65':'\x65\x72\x72\x6f\x72','\x56\x5a\x78\x53\x50':_0x2ab8d6(0x452,0x3e4,0x434,0x4f4),'\x42\x6c\x4a\x73\x66':_0x2ab8d6(0x3b5,0x2fa,0x2fa,0x301),'\x58\x63\x4f\x45\x4b':_0x2ab8d6(0x384,0x2ab,0x3ef,0x365),'\x42\x63\x73\x46\x71':function(_0x4f6edb,_0x3aa1b2,_0x3098e9){return _0x4f6edb(_0x3aa1b2,_0x3098e9);},'\x45\x67\x59\x4f\x62':_0x2ab8d6(0x392,0x3e7,0x38d,0x438),'\x64\x77\x79\x4a\x4e':_0x2ab8d6(0x43d,0x519,0x4ca,0x50c),'\x52\x62\x73\x70\x4b':_0x2ab8d6(0x3cc,0x3dc,0x3d4,0x368),'\x42\x62\x75\x65\x49':function(_0x5b3ff0,_0x4eefaa){return _0x5b3ff0===_0x4eefaa;},'\x61\x56\x6d\x67\x63':_0x2ab8d6(0x457,0x400,0x383,0x3e2),'\x51\x57\x50\x77\x70':'\x73\x74\x79\x6c\x65\x73\x68\x65\x65\x74','\x79\x6d\x62\x49\x44':_0x23c1fa(0x361,0x20a,0x2f6,0x27a),'\x79\x74\x5a\x42\x48':_0x2ab8d6(0x4ac,0x43c,0x4cb,0x431)+'\x65\x69\x6e\x67\x20\x63\x68\x61\x6e\x67'+_0x2ab8d6(0x49f,0x57c,0x47e,0x49c)+_0x23c1fa(0x3f3,0x3f9,0x2f5,0x3b8),'\x76\x42\x77\x7a\x48':function(_0x327cb7,_0x2c46a2){return _0x327cb7===_0x2c46a2;},'\x53\x5a\x79\x4c\x7a':_0x2ab8d6(0x3c6,0x376,0x2f9,0x3ac),'\x55\x4d\x58\x7a\x49':function(_0x214b7f,_0x34f5c5){return _0x214b7f===_0x34f5c5;},'\x47\x7a\x77\x47\x6f':_0x2ab8d6(0x430,0x3ab,0x42a,0x4d0),'\x73\x71\x61\x50\x43':function(_0x26fbfd,_0x564324){return _0x26fbfd(_0x564324);},'\x58\x53\x6d\x54\x43':_0x23c1fa(0x1b1,0x2f9,0x321,0x27d),'\x7a\x62\x61\x66\x53':_0x2ab8d6(0x3e9,0x4aa,0x37a,0x4c2),'\x55\x56\x71\x6c\x6d':_0x2ab8d6(0x3f8,0x3dc,0x40c,0x3ac),'\x4a\x41\x72\x7a\x62':function(_0x103037,_0x28be0f){return _0x103037>=_0x28be0f;},'\x59\x77\x4e\x4c\x52':function(_0x5557c4){return _0x5557c4();},'\x52\x6a\x6b\x67\x41':function(_0x31429e,_0x1f8c1a){return _0x31429e!==_0x1f8c1a;},'\x64\x4a\x53\x64\x4b':'\x78\x48\x61\x78\x56','\x51\x6f\x50\x42\x79':'\x68\x67\x78\x76\x76','\x71\x6a\x7a\x57\x56':_0x23c1fa(0x360,0x3e1,0x262,0x307),'\x4d\x41\x6e\x52\x4f':function(_0x195974,_0x141b72){return _0x195974===_0x141b72;},'\x57\x6d\x53\x49\x61':_0x23c1fa(0x288,0x179,0x167,0x1ed),'\x64\x6e\x77\x68\x45':'\x43\x6e\x65\x4e\x46','\x69\x7a\x58\x45\x73':function(_0x20101a,_0x1ae96d){return _0x20101a(_0x1ae96d);},'\x7a\x68\x5a\x52\x48':'\x67\x76\x69\x50\x4a','\x41\x79\x45\x78\x46':function(_0x4bf0a0,_0x3d1912){return _0x4bf0a0(_0x3d1912);},'\x6d\x77\x66\x6c\x45':function(_0x263aef,_0x2b94ab){return _0x263aef(_0x2b94ab);},'\x42\x78\x55\x7a\x7a':function(_0x311221,_0x22e08a){return _0x311221(_0x22e08a);},'\x47\x61\x54\x6c\x62':'\x7b\x7d\x2e\x63\x6f\x6e\x73\x74\x72\x75'+_0x23c1fa(0x34f,0x2f6,0x2d7,0x33e)+_0x23c1fa(0x1fe,0x2cf,0x2ce,0x275)+'\x20\x29','\x6d\x69\x4c\x4f\x77':'\x4c\x4e\x59\x66\x4c','\x7a\x56\x41\x67\x72':_0x23c1fa(0x270,0x1f2,0x2d4,0x298),'\x47\x47\x52\x6e\x48':_0x23c1fa(0x422,0x3ee,0x3eb,0x390)+_0x2ab8d6(0x48c,0x3ed,0x431,0x414)+_0x23c1fa(0x1b1,0x2d7,0x24b,0x20c)+_0x23c1fa(0x3a0,0x26d,0x381,0x2b6)+_0x23c1fa(0x2fd,0x295,0x2d8,0x2a3)+_0x2ab8d6(0x3ad,0x3be,0x3d0,0x412)+_0x23c1fa(0x3a3,0x34f,0x211,0x2f9)+'\x20\x6e\x6f\x20\x76\x61\x72\x69\x61\x6e'+_0x23c1fa(0x307,0x269,0x1f5,0x264)+'\x65\x64\x20\x74\x6f\x20\x69\x74\x2e\x0a'+'\x0a\x0a','\x63\x73\x69\x49\x6c':function(_0x522e5b,_0x457a30){return _0x522e5b!==_0x457a30;},'\x67\x67\x75\x55\x48':function(_0x36db6e,_0xc5a324){return _0x36db6e in _0xc5a324;},'\x45\x49\x70\x69\x65':_0x2ab8d6(0x34d,0x289,0x29f,0x2e2)+_0x2ab8d6(0x3d7,0x3bd,0x4ab,0x32c),'\x56\x71\x56\x6d\x4d':function(_0x3019b9,_0x508016){return _0x3019b9 in _0x508016;},'\x78\x77\x63\x73\x68':function(_0x36d41a,_0xa9755e){return _0x36d41a===_0xa9755e;},'\x71\x70\x47\x71\x6e':function(_0x1aa832,_0x41e0a5){return _0x1aa832(_0x41e0a5);},'\x44\x61\x52\x48\x51':'\x73\x6a\x47\x4e\x46','\x65\x57\x72\x63\x7a':function(_0x25d12b,_0x1217f0){return _0x25d12b===_0x1217f0;},'\x4f\x6d\x53\x6d\x79':_0x23c1fa(0x38a,0x2ef,0x38a,0x3ac),'\x44\x4d\x6f\x54\x57':function(_0x433794,_0x4f8b97){return _0x433794+_0x4f8b97;},'\x48\x52\x54\x47\x5a':function(_0x38bac0,_0x26be09){return _0x38bac0(_0x26be09);},'\x68\x68\x43\x75\x65':'\x48\x69\x49\x63\x73','\x65\x73\x6b\x46\x57':'\x63\x68\x61\x6e\x67\x65','\x47\x47\x71\x44\x44':_0x23c1fa(0x370,0x315,0x2b7,0x2ff),'\x6f\x54\x53\x77\x49':function(_0x276d47,_0x136d89){return _0x276d47(_0x136d89);},'\x47\x71\x4b\x79\x44':function(_0x3abcb4,_0x1065f7){return _0x3abcb4===_0x1065f7;},'\x46\x49\x71\x46\x61':_0x2ab8d6(0x3f9,0x4dc,0x316,0x3d8),'\x6d\x71\x48\x4f\x42':function(_0x10da31,_0x3c489f){return _0x10da31(_0x3c489f);},'\x50\x58\x6d\x6c\x58':_0x2ab8d6(0x44e,0x411,0x4e5,0x50e)+_0x23c1fa(0x315,0x2db,0x337,0x288)+_0x23c1fa(0x375,0x33c,0x383,0x368),'\x74\x50\x6d\x79\x6a':_0x23c1fa(0x24d,0x17d,0x2a1,0x226),'\x61\x62\x7a\x51\x71':_0x2ab8d6(0x334,0x2cb,0x402,0x407)+_0x2ab8d6(0x324,0x3f3,0x2fc,0x314)+_0x2ab8d6(0x36e,0x446,0x3a5,0x3d4),'\x54\x77\x72\x54\x51':'\x64\x61\x74\x61\x2d\x70\x72\x6f\x64\x75'+_0x2ab8d6(0x30d,0x38e,0x312,0x3a3),'\x47\x4b\x78\x75\x65':function(_0x4cacda,_0x3c0cb6){return _0x4cacda+_0x3c0cb6;},'\x79\x44\x7a\x5a\x65':function(_0x4a92ab,_0x5d2387){return _0x4a92ab===_0x5d2387;},'\x75\x4f\x45\x61\x58':'\x52\x42\x41\x44\x76','\x79\x48\x56\x46\x53':_0x23c1fa(0x21f,0x307,0x297,0x233),'\x62\x59\x48\x6f\x50':_0x2ab8d6(0x4ae,0x4d9,0x43b,0x4c1),'\x56\x4a\x6a\x77\x64':function(_0x1c006a,_0x17cc22){return _0x1c006a(_0x17cc22);},'\x76\x61\x64\x74\x62':function(_0x284411,_0x377ab2){return _0x284411(_0x377ab2);},'\x4b\x48\x67\x55\x7a':_0x23c1fa(0x386,0x26a,0x3df,0x347),'\x49\x46\x61\x4e\x4e':function(_0x50e6e4,_0x332ac7){return _0x50e6e4(_0x332ac7);},'\x55\x51\x75\x48\x74':function(_0xab39b,_0x2bc9e9){return _0xab39b===_0x2bc9e9;},'\x54\x67\x52\x4c\x4a':_0x2ab8d6(0x473,0x3c5,0x540,0x52d),'\x47\x50\x68\x55\x71':function(_0x32a0ce,_0x72d0b){return _0x32a0ce===_0x72d0b;},'\x51\x48\x66\x4c\x69':_0x2ab8d6(0x3cd,0x353,0x401,0x49a),'\x4f\x72\x52\x46\x66':'\x68\x43\x71\x50\x7a','\x58\x7a\x47\x51\x4e':_0x23c1fa(0x16c,0x2f9,0x153,0x22d),'\x78\x74\x54\x4c\x49':function(_0x3dac54,_0xe5eb19){return _0x3dac54!==_0xe5eb19;},'\x57\x59\x53\x79\x78':'\x73\x6a\x6b\x45\x71','\x4b\x4b\x46\x4e\x51':'\x51\x63\x64\x54\x4a','\x42\x52\x4a\x70\x67':_0x2ab8d6(0x2f2,0x28b,0x374,0x2d5),'\x71\x72\x4a\x75\x64':'\x6e\x58\x47\x51\x69','\x49\x4c\x50\x45\x4c':function(_0x1ee5d0,_0x1ae545){return _0x1ee5d0<=_0x1ae545;},'\x55\x43\x75\x43\x69':'\x64\x61\x74\x61\x2d\x73\x6c\x69\x64\x65'+_0x2ab8d6(0x466,0x4f1,0x3ff,0x411),'\x45\x5a\x4e\x68\x54':function(_0x78a1f5,_0x2760e9){return _0x78a1f5(_0x2760e9);},'\x55\x42\x47\x46\x58':_0x23c1fa(0x2a4,0x202,0x163,0x208),'\x61\x59\x45\x75\x49':function(_0x33ec28,_0x4f5ef8){return _0x33ec28(_0x4f5ef8);},'\x44\x48\x70\x54\x6d':_0x23c1fa(0x2a8,0x33c,0x212,0x28a),'\x4b\x51\x76\x55\x4b':function(_0x572e04,_0x3735a3){return _0x572e04===_0x3735a3;},'\x5a\x76\x64\x6c\x42':'\x42\x48\x4f\x42\x51','\x75\x73\x77\x75\x6c':_0x2ab8d6(0x3b2,0x46a,0x486,0x343)+'\x2d\x73\x65\x6c\x65\x63\x74\x65\x64','\x77\x52\x79\x66\x46':function(_0x557452,_0x37acae){return _0x557452===_0x37acae;},'\x6c\x6c\x70\x55\x6f':_0x2ab8d6(0x45e,0x4cb,0x422,0x4d8),'\x6e\x70\x76\x51\x6b':_0x23c1fa(0x23b,0x1c5,0x16d,0x256),'\x57\x4e\x4e\x44\x42':_0x23c1fa(0x3ec,0x3c5,0x34a,0x376),'\x4c\x69\x66\x68\x51':_0x2ab8d6(0x399,0x371,0x380,0x33d),'\x73\x6d\x62\x6d\x51':'\x72\x64\x42\x76\x4b','\x58\x47\x42\x79\x43':function(_0x576645){return _0x576645();},'\x4a\x68\x64\x51\x41':function(_0x159643,_0x38bded){return _0x159643(_0x38bded);},'\x77\x5a\x70\x6a\x6f':function(_0x451f92,_0x5a63cd){return _0x451f92(_0x5a63cd);},'\x7a\x56\x41\x62\x65':function(_0x55fbcd,_0x4a1042){return _0x55fbcd===_0x4a1042;},'\x52\x45\x72\x62\x59':function(_0x354fbb){return _0x354fbb();},'\x49\x6e\x49\x4e\x49':_0x2ab8d6(0x48e,0x50c,0x3f7,0x50e),'\x65\x74\x7a\x4a\x6c':'\x70\x61\x6e\x2d\x79\x20\x70\x69\x6e\x63'+_0x2ab8d6(0x357,0x294,0x304,0x438),'\x55\x6f\x43\x6f\x59':_0x23c1fa(0x43a,0x423,0x2b6,0x387)+_0x23c1fa(0x292,0x2d2,0x1ea,0x268),'\x4a\x46\x55\x6f\x54':_0x2ab8d6(0x4b1,0x3c5,0x3f0,0x456),'\x63\x63\x4e\x70\x71':_0x23c1fa(0x356,0x359,0x2db,0x37f),'\x5a\x54\x56\x75\x68':'\x42\x6e\x66\x4d\x73','\x4f\x65\x67\x78\x62':function(_0x4b5c23,_0x1e477b){return _0x4b5c23!==_0x1e477b;},'\x64\x48\x6f\x58\x6c':_0x2ab8d6(0x3a1,0x2e5,0x327,0x2b8),'\x51\x62\x65\x74\x52':'\x70\x77\x57\x42\x73','\x44\x47\x4d\x42\x59':'\x41\x64\x56\x5a\x49','\x53\x56\x65\x75\x69':_0x2ab8d6(0x409,0x43a,0x4c0,0x35e)+_0x2ab8d6(0x4a1,0x3ff,0x4e9,0x578),'\x46\x4b\x57\x69\x77':_0x23c1fa(0x42c,0x304,0x3e9,0x348),'\x65\x46\x44\x52\x6e':'\x73\x63\x72\x6f\x6c\x6c','\x77\x4c\x79\x70\x4a':_0x2ab8d6(0x401,0x3c6,0x48b,0x3a0),'\x50\x6d\x70\x71\x4d':function(_0x5f28b7){return _0x5f28b7();},'\x44\x49\x6e\x43\x74':function(_0x269a06,_0x3bb110){return _0x269a06(_0x3bb110);},'\x41\x44\x4d\x63\x4e':function(_0x5eb30b,_0x539ca7){return _0x5eb30b(_0x539ca7);},'\x44\x79\x45\x44\x75':function(_0x470341,_0x21bfb9){return _0x470341(_0x21bfb9);},'\x57\x75\x59\x55\x58':function(_0x193f96,_0x237314){return _0x193f96(_0x237314);},'\x79\x4f\x74\x57\x50':function(_0x5c1952,_0x5104cd){return _0x5c1952(_0x5104cd);},'\x6e\x78\x48\x53\x61':function(_0x10e851){return _0x10e851();},'\x72\x61\x46\x65\x65':_0x2ab8d6(0x2e6,0x305,0x26c,0x3be)},_0x286cdf=function(){const _0x4de142={'\x43\x6e\x6d\x64\x72':'\x6d\x56\x50\x4c\x5a','\x4a\x55\x45\x62\x6b':_0x5d11ae[_0x2cff90(0x10b,0x10c,0x190,0x1ae)],'\x51\x4d\x76\x41\x4c':function(_0xe192e0,_0x587316){return _0x5d11ae['\x62\x58\x4b\x53\x7a'](_0xe192e0,_0x587316);},'\x4d\x53\x41\x77\x59':_0x5d11ae[_0x2cff90(0x2be,0x233,0x1eb,0x201)]};function _0x1b4648(_0x184d50,_0x1c81e2,_0x475a09,_0x47c3d0){return _0x23c1fa(_0x184d50,_0x1c81e2-0x10,_0x475a09-0x169,_0x1c81e2- -0x388);}function _0x2cff90(_0x5cff3f,_0x15bc22,_0x1543c8,_0x1b297d){return _0x2ab8d6(_0x15bc22- -0x264,_0x15bc22-0x128,_0x1543c8,_0x1b297d-0x76);}if(_0x5d11ae['\x62\x58\x4b\x53\x7a'](_0x5d11ae[_0x2cff90(0x9f,0xa2,0xf1,-0x18)],_0x5d11ae['\x79\x6a\x72\x41\x62'])){let _0x1d0497=!![];return function(_0x37da2a,_0xab2935){const _0x50340d=_0x1d0497?function(){function _0x5152e2(_0xde63b2,_0x10cf24,_0x9754e7,_0xcc2cd7){return _0x4a84(_0xde63b2-0x1ec,_0x9754e7);}function _0xc200fe(_0x5c53ca,_0x4aad6f,_0x261b98,_0x248e41){return _0x4a84(_0x261b98- -0x3b1,_0x5c53ca);}if(_0x4de142[_0x5152e2(0x389,0x335,0x2e3,0x2ac)]===_0x4de142[_0xc200fe(-0x9b,-0x1f6,-0x17c,-0x9b)])return _0x5c2f85['\x5f\x5f'+_0x34ecb9]=-0x1*-0xf49+-0x14fc+-0x5b3*-0x1,_0x5c9faa[_0xc200fe(-0x11c,-0x108,-0x129,-0x44)](null);else{if(_0xab2935){if(_0x4de142[_0x5152e2(0x33c,0x3dd,0x2cd,0x3a3)](_0x4de142[_0x5152e2(0x350,0x355,0x3ee,0x35e)],_0xc200fe(-0x186,-0x202,-0x1c6,-0x283)))_0x488953[_0xc200fe(-0x8e,-0x112,-0x14b,-0x193)][_0x5152e2(0x427,0x422,0x4eb,0x414)](_0x590d42),_0x20afe8['\x63\x6c\x61\x73\x73\x4c\x69\x73\x74'][_0x5152e2(0x427,0x34d,0x3e4,0x485)](_0x210fe8);else{const _0x23162c=_0xab2935[_0xc200fe(-0xf5,-0xab,-0x150,-0xa3)](_0x37da2a,arguments);return _0xab2935=null,_0x23162c;}}}}:function(){};return _0x1d0497=![],_0x50340d;};}else return _0x375245[_0x1b4648(-0xcc,0x1b,0xef,0x43)]()[_0x2cff90(0x26,0xdc,0x4a,0x6d)](_0x2cff90(0x275,0x222,0x165,0x1ae)+'\x2b\x24')[_0x2cff90(0x23d,0x242,0x26b,0x193)]()[_0x1b4648(-0x36,-0x44,0x85,-0x14)+'\x72'](_0x3cefc5)[_0x2cff90(0x130,0xdc,0x164,0x15d)](_0x1b4648(0x8a,-0x5,0xbf,-0x8a)+'\x2b\x24');}(),_0xc624c=function(){const _0x16d989={'\x4d\x6a\x79\x47\x6f':_0x5d11ae['\x49\x4a\x50\x45\x48'],'\x79\x42\x66\x63\x41':function(_0x5e7ad7,_0x24b5b9){return _0x5e7ad7(_0x24b5b9);}};let _0x4b4979=!![];return function(_0x3e1a4f,_0xf80237){const _0x5e8b9b={'\x4f\x67\x4e\x6b\x75':function(_0x329c18,_0x2532ae){function _0x259ccd(_0xe0382,_0x1e9ccf,_0xce4636,_0x45504b){return _0x4a84(_0xe0382- -0x69,_0x45504b);}return _0x16d989[_0x259ccd(0x1b3,0x107,0x150,0x111)](_0x329c18,_0x2532ae);}},_0x291f62=_0x4b4979?function(){function _0x772eff(_0x147dfb,_0x40225b,_0x535b88,_0x2123ed){return _0x4a84(_0x147dfb-0x3e5,_0x40225b);}function _0x1e1b01(_0x588547,_0x1ccd85,_0x416979,_0x5c9834){return _0x4a84(_0x1ccd85- -0xcc,_0x416979);}if(_0xf80237){if(_0x16d989['\x4d\x6a\x79\x47\x6f']===_0x16d989[_0x1e1b01(0x14b,0x1b5,0x24e,0xd9)]){const _0x5a2884=_0xf80237[_0x1e1b01(0x274,0x195,0x225,0x15d)](_0x3e1a4f,arguments);return _0xf80237=null,_0x5a2884;}else{const _0x170dce={'\x71\x46\x6d\x68\x71':function(_0x28ac1d,_0x3a5878){function _0x47b612(_0x1ca406,_0x1c71b6,_0x2f4dc0,_0x59094b){return _0x1e1b01(_0x1ca406-0x7,_0x2f4dc0-0x2b,_0x1ca406,_0x59094b-0xe7);}return _0x5e8b9b[_0x47b612(0xb2,0x66,0xb3,0x89)](_0x28ac1d,_0x3a5878);},'\x67\x42\x65\x52\x4a':function(_0x504f0a,_0x35259f){return _0x504f0a(_0x35259f);}};return new _0x2e8de8(async(_0x25a44d,_0x27ce4e)=>{function _0x2fb72f(_0x49d7b4,_0xd23bdd,_0x4d4cc5,_0x431453){return _0x772eff(_0x431453- -0x277,_0xd23bdd,_0x4d4cc5-0x1d,_0x431453-0x1df);}function _0x3fb39b(_0x5daaaf,_0x1ad25,_0xd9ce82,_0x494c2f){return _0x1e1b01(_0x5daaaf-0x17,_0x5daaaf-0x316,_0x1ad25,_0x494c2f-0x1a4);}try{const _0x7e70f1=_0x1dc2cd['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+_0x2fb72f(0x436,0x451,0x3d5,0x40d)](_0x2fb72f(0x42e,0x426,0x3ce,0x45b)+_0x3fb39b(0x526,0x516,0x5aa,0x5e7)+'\x5f\x76\x61\x72\x69\x61\x6e\x74\x73'),_0x129b9e=_0x7e70f1[_0x3fb39b(0x42c,0x4dd,0x398,0x46e)+_0x3fb39b(0x42d,0x350,0x43b,0x490)][-0xafa+0x1127+-0x5d*0x11],_0x471694=_0x170dce['\x71\x46\x6d\x68\x71'](_0x37520c,_0x129b9e[_0x3fb39b(0x429,0x352,0x47e,0x3b4)][_0x2fb72f(0x346,0x38d,0x26b,0x2c8)]()[_0x3fb39b(0x3e9,0x475,0x42c,0x3dc)+'\x65']());_0x3b401c=_0xbd7f96[_0x3fb39b(0x488,0x476,0x4e3,0x54f)][_0x2fb72f(0x242,0x274,0x20d,0x2c9)](_0x4317e3=>_0x4317e3['\x69\x64']===_0x471694)[-0x1fb*0x13+0x25a9+0x8*-0x1],_0x25a44d(_0xdbfb78);}catch(_0x28e676){_0x170dce[_0x3fb39b(0x44b,0x41e,0x383,0x3dc)](_0x25a44d,null);}});}}}:function(){};return _0x4b4979=![],_0x291f62;};}(),_0x55dfc7='\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d'+_0x2ab8d6(0x46e,0x488,0x4b8,0x52c);window[_0x23c1fa(0x1e9,0x29a,0x1c1,0x1f7)+_0x23c1fa(0x29d,0x24b,0x1bf,0x2a7)+'\x45\x58']=0x2408+-0x18f5+-0x23*0x51;const _0x5e609f=0xb*0x4e+-0xa2e+0x706,_0x11683b=-0x5f7+-0x239+-0x862*-0x1,_0x1a42e3=_0x11683b*(-0x5*0xb7+0x3*0xbb1+-0x1f7d),_0x44046c=_0x5e609f-(-0x196b+-0x7*0x4f3+0x3c24);let _0x2da8db=![],_0x57ad19=![],_0x339c24=![];const _0x2b6d72={'\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d\x61\x67\x65\x41\x6e\x69\x6d\x61\x74\x69\x6f\x6e':_0x5d11ae[_0x2ab8d6(0x35c,0x409,0x342,0x30a)](_0xed6b5d,_0x2ab8d6(0x4ad,0x584,0x3f3,0x515)+_0x23c1fa(0x457,0x2b7,0x2ff,0x374)+_0x23c1fa(0x29f,0x2b9,0x2c7,0x329)),'\x64\x61\x74\x61\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73\x51\x75\x61\x6e\x74\x69\x74\x79\x4d\x6f\x62\x69\x6c\x65':_0x5d11ae[_0x2ab8d6(0x35c,0x35a,0x29a,0x329)](_0xed6b5d,'\x64\x61\x74\x61\x5f\x74\x68\x75\x6d\x62'+_0x23c1fa(0x269,0x278,0x243,0x286)+_0x23c1fa(0x384,0x3b3,0x446,0x3a0)+'\x65'),'\x64\x61\x74\x61\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73\x51\x75\x61\x6e\x74\x69\x74\x79':_0x5d11ae['\x44\x49\x6e\x43\x74'](_0xed6b5d,_0x2ab8d6(0x46a,0x3e7,0x4f3,0x40c)+_0x23c1fa(0x2db,0x364,0x250,0x286)+_0x2ab8d6(0x3e1,0x3f9,0x46e,0x444)),'\x74\x6f\x74\x61\x6c\x49\x6d\x61\x67\x65\x73':_0x5d11ae[_0x23c1fa(0x203,0x1ce,0x1a9,0x265)](_0xed6b5d,_0x2ab8d6(0x47e,0x474,0x3aa,0x490)+_0x2ab8d6(0x4b5,0x476,0x56d,0x427)),'\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d\x61\x67\x65\x4c\x6f\x6f\x70':_0xed6b5d(_0x2ab8d6(0x4ad,0x593,0x4ba,0x4ae)+_0x2ab8d6(0x477,0x421,0x528,0x3a3)+_0x23c1fa(0x29d,0x154,0x17d,0x227)),'\x65\x6e\x61\x62\x6c\x65\x53\x6c\x69\x64\x65\x72\x46\x6f\x72\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73\x44\x65\x73\x6b\x74\x6f\x70':_0xed6b5d(_0x23c1fa(0x2bd,0x3e3,0x2e1,0x340)+_0x23c1fa(0x2c1,0x259,0x34f,0x315)+_0x23c1fa(0x34c,0x408,0x2fc,0x388)+'\x69\x6c\x73\x5f\x64\x65\x73\x6b\x74\x6f'+'\x70'),'\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73\x48\x69\x67\x68\x6c\x69\x67\x68\x74\x65\x64\x50\x6f\x73\x69\x74\x69\x6f\x6e':_0x5d11ae[_0x2ab8d6(0x317,0x2ea,0x3fd,0x3f5)](_0xed6b5d,_0x23c1fa(0x422,0x327,0x35d,0x367)+'\x6e\x61\x69\x6c\x73\x5f\x68\x69\x67\x68'+_0x2ab8d6(0x485,0x45f,0x511,0x42d)+_0x23c1fa(0x2d2,0x23d,0x16a,0x242)),'\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d\x61\x67\x65\x4c\x61\x7a\x79\x6c\x6f\x61\x64':_0x5d11ae[_0x2ab8d6(0x44d,0x474,0x505,0x3cb)](_0xed6b5d,_0x2ab8d6(0x4ad,0x556,0x408,0x442)+_0x23c1fa(0x370,0x296,0x413,0x374)+'\x6c\x61\x7a\x79\x6c\x6f\x61\x64'),'\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73\x4c\x6f\x6f\x70':_0x5d11ae['\x79\x4f\x74\x57\x50'](_0xed6b5d,_0x23c1fa(0x35e,0x2ec,0x3cc,0x367)+_0x23c1fa(0x259,0x29c,0x232,0x23b))};console[_0x23c1fa(0x1b8,0x1d3,0x29f,0x257)](_0x2b6d72);const _0x44820c={};_0x44820c[_0x2ab8d6(0x4a2,0x516,0x48c,0x540)]=![],_0x44820c['\x63\x6f\x6e\x74\x61\x69\x6e']=!![],_0x44820c[_0x2ab8d6(0x351,0x27b,0x2fd,0x38f)+'\x65\x64']=!![],_0x44820c[_0x2ab8d6(0x3ce,0x49c,0x3ba,0x48a)+'\x69\x67\x68\x74']=!![],_0x44820c[_0x2ab8d6(0x426,0x4cd,0x3b2,0x472)]=_0x2b6d72['\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d'+_0x23c1fa(0x24c,0x2e5,0x1c0,0x267)],_0x44820c[_0x2ab8d6(0x385,0x384,0x409,0x44d)]=!![],_0x44820c[_0x2ab8d6(0x355,0x344,0x2eb,0x2c2)]=_0x2b6d72['\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d'+_0x2ab8d6(0x337,0x288,0x3be,0x3c8)+'\x64'],_0x44820c['\x73\x65\x6c\x65\x63\x74\x65\x64\x41\x74'+_0x2ab8d6(0x440,0x483,0x3b3,0x3b5)]=_0x2b6d72[_0x23c1fa(0x30b,0x468,0x331,0x3b3)+_0x2ab8d6(0x376,0x452,0x2f2,0x409)+'\x6f\x6e']?-0x1f9+-0x1e91+0x682*0x5+0.025:-0x21+0x2b*0x7f+-0x3*0x711,_0x44820c[_0x23c1fa(0x2ea,0x401,0x3fd,0x3a4)]=_0x2b6d72[_0x23c1fa(0x427,0x363,0x3cf,0x3b3)+_0x2ab8d6(0x376,0x416,0x42f,0x436)+'\x6f\x6e']?-0x7f*0x47+0xed6+0x1463+0.28:-0x13fb+0x1193+-0x1*-0x269;const _0xfa226b=_0x44820c,_0x483cb1={'\x61\x73\x4e\x61\x76\x46\x6f\x72':'\x23'+_0x55dfc7,'\x77\x72\x61\x70\x41\x72\x6f\x75\x6e\x64':_0x2b6d72[_0x2ab8d6(0x48a,0x4b2,0x45a,0x4db)+_0x23c1fa(0x282,0x2c8,0x1ec,0x1f6)],'\x69\x6d\x61\x67\x65\x73\x4c\x6f\x61\x64\x65\x64':!![],'\x63\x6f\x6e\x74\x61\x69\x6e':![],'\x70\x61\x67\x65\x44\x6f\x74\x73':![],'\x61\x63\x63\x65\x73\x73\x69\x62\x69\x6c\x69\x74\x79':![],'\x70\x72\x65\x76\x4e\x65\x78\x74\x42\x75\x74\x74\x6f\x6e\x73':!![],'\x63\x65\x6c\x6c\x41\x6c\x69\x67\x6e':_0x5d11ae[_0x2ab8d6(0x419,0x4ee,0x3c8,0x3ae)](_0x1823f3)?_0x5d11ae[_0x23c1fa(0x334,0x417,0x2c9,0x391)]:_0x2b6d72['\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73'+_0x23c1fa(0x237,0x1ae,0x29e,0x239)+'\x64\x50\x6f\x73\x69\x74\x69\x6f\x6e'],'\x67\x72\x6f\x75\x70\x43\x65\x6c\x6c\x73':_0x5d11ae[_0x23c1fa(0x3f5,0x2fe,0x303,0x316)](_0x1823f3)};function _0x2ab8d6(_0x4f0766,_0x5d45d2,_0x1fd32a,_0x270f7c){return _0x5943b0(_0x1fd32a,_0x5d45d2-0x64,_0x4f0766- -0x99,_0x270f7c-0x150);}function _0x1823f3(){const _0x293be9={'\x56\x4c\x57\x43\x6a':function(_0x23c063,_0x746ddd,_0x33aa41){return _0x5d11ae['\x54\x43\x56\x48\x47'](_0x23c063,_0x746ddd,_0x33aa41);}},_0x2e9ef7=parseInt(_0x2b6d72[_0x592579(0x271,0x1f7,0x232,0x25e)+'\x73']),_0x40d5f4=_0x5d11ae['\x70\x51\x67\x68\x70'](parseInt,_0x2b6d72[_0x592579(0x110,0xef,0x1f4,0x18b)+_0x5ea6a1(-0x20,-0x18,0xb1,0x31)+_0x592579(0x19a,0xb6,0x146,0x25d)]),_0x390cff=_0x5d11ae['\x49\x4d\x43\x7a\x54'](parseInt,_0x2b6d72['\x64\x61\x74\x61\x54\x68\x75\x6d\x62\x6e'+'\x61\x69\x6c\x73\x51\x75\x61\x6e\x74\x69'+'\x74\x79']);function _0x5ea6a1(_0x7ae328,_0x3b2bde,_0xdcfa5e,_0x5776ea){return _0x23c1fa(_0xdcfa5e,_0x3b2bde-0x1ab,_0xdcfa5e-0x5e,_0x3b2bde- -0x2d1);}function _0x592579(_0x376bf8,_0x2e1f62,_0x3f2ee7,_0xd0956d){return _0x23c1fa(_0x2e1f62,_0x2e1f62-0x1e3,_0x3f2ee7-0xb0,_0x376bf8- -0xe2);}console['\x6c\x6f\x67'](_0x592579(0x131,0xba,0x21b,0x8e),_0x2e9ef7,_0x40d5f4,_0x390cff);if(_0x5d11ae[_0x592579(0x280,0x2b1,0x28a,0x1fe)](_0x517ec0)&&_0x5d11ae[_0x592579(0x2cd,0x369,0x37a,0x336)](_0x2e9ef7,_0x40d5f4)){if(_0x5d11ae[_0x592579(0x25a,0x1cf,0x265,0x343)]===_0x5d11ae[_0x5ea6a1(0xe4,0x6b,0x100,0x144)])return![];else return;}else{if(!_0x5d11ae[_0x5ea6a1(0x64,0x3e,0x52,-0x86)](_0x517ec0)&&_0x5d11ae['\x7a\x63\x50\x62\x63'](_0x2e9ef7,_0x390cff)){if(_0x5d11ae[_0x592579(0x11f,0x1b7,0x14c,0xea)](_0x5d11ae[_0x5ea6a1(-0x6a,-0x52,-0x70,-0x6)],_0x5d11ae[_0x592579(0x23c,0x24c,0x187,0x30a)]))return![];else _0x4d2030['\x5f\x5f'+_0x8cab16]++,_0x293be9[_0x592579(0x2d5,0x284,0x359,0x2af)](_0x10b500,_0x303976,_0x14529d);}}return!![];}function _0x517ec0(){function _0x57f748(_0x604e57,_0x5e92a7,_0x19777f,_0x4fbaaf){return _0x23c1fa(_0x5e92a7,_0x5e92a7-0x13,_0x19777f-0xe4,_0x4fbaaf-0x14f);}function _0x22dc7f(_0x51db93,_0xeb141f,_0x1500ee,_0x228e04){return _0x2ab8d6(_0xeb141f-0x1f2,_0xeb141f-0x10,_0x51db93,_0x228e04-0x20);}return window[_0x22dc7f(0x511,0x535,0x494,0x504)](_0x57f748(0x3d7,0x562,0x4a5,0x49b)+_0x22dc7f(0x695,0x61d,0x5d8,0x608))[_0x57f748(0x2ff,0x33e,0x302,0x3cd)];}function _0x248dd9(_0x1a1d56){function _0x47a22d(_0x6cc9f2,_0x53c230,_0x4b025b,_0x29b1c3){return _0x23c1fa(_0x4b025b,_0x53c230-0xfc,_0x4b025b-0x149,_0x53c230- -0x41c);}const _0x3acbc7={};function _0x236234(_0x5f0f31,_0xe76f8b,_0x3885f4,_0x409c3b){return _0x2ab8d6(_0xe76f8b-0x134,_0xe76f8b-0x85,_0x5f0f31,_0x409c3b-0xf6);}_0x3acbc7[_0x236234(0x5f0,0x5d8,0x59e,0x6b2)]=function(_0x526812,_0x12ce2d){return _0x526812===_0x12ce2d;},_0x3acbc7[_0x236234(0x39d,0x440,0x4cf,0x3e0)]=_0x236234(0x519,0x5ca,0x5f9,0x4e2),_0x3acbc7[_0x47a22d(-0x210,-0x138,-0x18d,-0x1fd)]=_0x5d11ae[_0x47a22d(-0x174,-0xa7,-0x183,-0x10c)];const _0x12b937=_0x3acbc7;return new Promise(function(_0x14363a,_0x10c7e1){function _0x358c09(_0x3a13ab,_0x547835,_0xa07c36,_0x53f8ee){return _0x236234(_0x53f8ee,_0x3a13ab- -0x449,_0xa07c36-0xfd,_0x53f8ee-0x108);}function _0x48488f(_0x30bd75,_0x1d5b8b,_0x305c72,_0x272bd2){return _0x236234(_0x30bd75,_0x1d5b8b- -0x114,_0x305c72-0x20,_0x272bd2-0x83);}if(_0x12b937['\x44\x59\x74\x6d\x74'](_0x12b937[_0x358c09(-0x9,-0x30,0x46,-0x86)],_0x358c09(0x11a,0x1ae,0x64,0x174)))return _0x5ebaa5;else{const _0x4a0b00=(_0x358c09(0x8,-0x98,-0x5f,0xdf)+'\x33')[_0x358c09(0x7c,0x9a,-0x4,0x38)]('\x7c');let _0x2b7001=-0x15f4+-0x472*-0x8+-0x1*0xd9c;while(!![]){switch(_0x4a0b00[_0x2b7001++]){case'\x30':var _0x533f16;continue;case'\x31':_0x533f16[_0x358c09(0xc8,0x1d,0xc8,0xc4)]=_0x10c7e1;continue;case'\x32':_0x533f16['\x6f\x6e\x6c\x6f\x61\x64']=_0x14363a;continue;case'\x33':document[_0x358c09(0x94,0x39,-0x2f,-0x41)][_0x358c09(0x28,0x8a,-0x6d,-0x7)+'\x64'](_0x533f16);continue;case'\x34':_0x533f16=document['\x63\x72\x65\x61\x74\x65\x45\x6c\x65\x6d'+_0x358c09(0x11,-0x62,0x28,-0x35)](_0x12b937[_0x48488f(0x336,0x407,0x3db,0x3c7)]);continue;case'\x35':_0x533f16[_0x358c09(-0x22,-0xb5,-0x30,0x21)]=_0x1a1d56;continue;}break;}}});}function _0xed6b5d(_0x14adee){const _0x356848=_0x5d11ae['\x54\x43\x56\x48\x47'](_0x286cdf,this,function(){function _0x4e2770(_0x3284c0,_0x5156e0,_0x22916f,_0x39ab17){return _0x4a84(_0x22916f- -0x12c,_0x39ab17);}const _0x4e0d2a={'\x67\x53\x67\x76\x43':function(_0x4b4867,_0x2394c7){function _0x1899a2(_0x2f5c66,_0x55a30d,_0x5b7036,_0x28afe8){return _0x4a84(_0x55a30d-0x9c,_0x28afe8);}return _0x5d11ae[_0x1899a2(0x301,0x2be,0x242,0x303)](_0x4b4867,_0x2394c7);}};function _0x5258fc(_0x521a55,_0x47a56e,_0x514ea1,_0x466c05){return _0x4a84(_0x514ea1- -0xfb,_0x466c05);}if(_0x5d11ae['\x6a\x48\x4b\x73\x47'](_0x5d11ae[_0x5258fc(0x14b,0x1a4,0x1f5,0x282)],_0x5d11ae[_0x4e2770(0x112,0x93,0x13c,0x131)]))_0x4e0d2a['\x67\x53\x67\x76\x43'](_0x39ad67,null);else return _0x356848['\x74\x6f\x53\x74\x72\x69\x6e\x67']()[_0x5258fc(-0x2a,0x135,0x98,0xee)](_0x5d11ae[_0x4e2770(-0x34,0xaa,0x41,-0x55)])['\x74\x6f\x53\x74\x72\x69\x6e\x67']()[_0x4e2770(0xd0,0x1bd,0x16e,0x22b)+'\x72'](_0x356848)['\x73\x65\x61\x72\x63\x68'](_0x5d11ae[_0x4e2770(0xc,0xcf,0x41,-0x5e)]);});_0x5d11ae[_0x1aae67(0x1ca,0x92,0x134,0x201)](_0x356848);function _0x4549da(_0x449d36,_0x25c18f,_0x49d1d9,_0x165f5f){return _0x23c1fa(_0x449d36,_0x25c18f-0x1d7,_0x49d1d9-0x122,_0x25c18f- -0x42f);}const _0x29fe6d=_0x5d11ae[_0x4549da(-0x225,-0x192,-0x247,-0x176)](_0xc624c,this,function(){function _0x53f9f1(_0x1d78a4,_0x5724a6,_0x13a916,_0x53252c){return _0x4549da(_0x53252c,_0x13a916-0x9e,_0x13a916-0x130,_0x53252c-0xa0);}let _0xdd3f38;try{const _0x539815=_0x5d11ae[_0x563f0e(0x58c,0x539,0x558,0x5a1)](Function,_0x5d11ae[_0x563f0e(0x546,0x4ea,0x591,0x4bc)](_0x5d11ae[_0x53f9f1(-0x21e,-0x231,-0x1aa,-0x209)](_0x53f9f1(-0x63,-0xb8,-0x2b,0x64)+'\x6e\x63\x74\x69\x6f\x6e\x28\x29\x20',_0x563f0e(0x521,0x5ec,0x5c4,0x50c)+_0x563f0e(0x56c,0x5ec,0x6b0,0x613)+_0x53f9f1(-0x4d,-0x57,-0x11c,-0x77)+'\x20\x29'),'\x29\x3b'));_0xdd3f38=_0x539815();}catch(_0x17037c){if(_0x5d11ae['\x55\x63\x6a\x54\x47'](_0x5d11ae[_0x563f0e(0x601,0x4f8,0x637,0x5b7)],'\x64\x41\x47\x41\x45'))return/product/[_0x53f9f1(-0x217,-0x6b,-0x136,-0x54)](_0x3a4a6e[_0x563f0e(0x687,0x5b5,0x4eb,0x5ac)][_0x53f9f1(-0x17a,-0x1b9,-0x140,-0x1e4)]);else _0xdd3f38=window;}function _0x563f0e(_0x5491ff,_0x1d3af7,_0x29a2bd,_0x1b1e7e){return _0x1aae67(_0x5491ff-0x98,_0x1d3af7-0x13b,_0x1b1e7e-0x4b0,_0x29a2bd);}const _0x583dc1=_0xdd3f38[_0x53f9f1(-0x1a2,-0xaa,-0xf0,-0x114)]=_0xdd3f38['\x63\x6f\x6e\x73\x6f\x6c\x65']||{},_0x5f347f=[_0x5d11ae[_0x53f9f1(-0x1b1,-0xa7,-0x14e,-0x1c5)],_0x5d11ae[_0x563f0e(0x5e7,0x565,0x541,0x591)],'\x69\x6e\x66\x6f',_0x5d11ae['\x67\x4a\x49\x50\x65'],_0x5d11ae['\x56\x5a\x78\x53\x50'],_0x5d11ae[_0x53f9f1(-0x16c,-0x208,-0x12e,-0xd6)],_0x5d11ae['\x58\x63\x4f\x45\x4b']];for(let _0x2bcb69=-0x989*-0x2+-0x1705+-0x1*-0x3f3;_0x2bcb69<_0x5f347f[_0x563f0e(0x4d2,0x60f,0x5a7,0x566)];_0x2bcb69++){const _0x200db8=_0xc624c[_0x53f9f1(0x16,-0x69,-0x4d,-0x138)+'\x72'][_0x53f9f1(-0xa5,-0x10e,-0x84,-0xd4)][_0x53f9f1(-0x78,-0x95,-0x1e,-0x9d)](_0xc624c),_0x365598=_0x5f347f[_0x2bcb69],_0x2dc392=_0x583dc1[_0x365598]||_0x200db8;_0x200db8[_0x53f9f1(-0x1a,-0x65,-0x40,0x83)]=_0xc624c[_0x563f0e(0x560,0x6d7,0x6d8,0x648)](_0xc624c),_0x200db8[_0x53f9f1(0x1,-0xd1,0x12,-0xd4)]=_0x2dc392[_0x563f0e(0x71d,0x65f,0x71b,0x678)][_0x53f9f1(-0xaa,-0x22,-0x1e,0x77)](_0x2dc392),_0x583dc1[_0x365598]=_0x200db8;}});_0x5d11ae['\x4e\x65\x62\x55\x73'](_0x29fe6d);const _0x1c0b7f=document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+_0x1aae67(0x23d,0x1e2,0x16e,0x207)]('\x5b'+_0x14adee+'\x5d');if(!_0x1c0b7f){if(_0x5d11ae[_0x4549da(-0x2f4,-0x22e,-0x318,-0x1dc)](_0x5d11ae[_0x1aae67(0x213,0x168,0x1a2,0x27b)],_0x5d11ae[_0x4549da(-0x29f,-0x20b,-0x189,-0x2db)]))return null;else _0x5d11ae[_0x4549da(-0xc3,-0x163,-0x95,-0x86)](_0x2a2ee3,_0x16d783[_0x4549da(-0xe5,-0x16f,-0x12e,-0x244)]);}function _0x1aae67(_0x3ebd10,_0x4d1c3b,_0x4b09c2,_0x5a07be){return _0x2ab8d6(_0x4b09c2- -0x2de,_0x4d1c3b-0x1db,_0x5a07be,_0x5a07be-0x14e);}const _0x583b5b=_0x1c0b7f[_0x4549da(-0x7f,-0x15f,-0x73,-0x1cb)+'\x74\x65'](_0x14adee);if(_0x583b5b===_0x5d11ae['\x52\x62\x73\x70\x4b'])return!![];else return _0x5d11ae[_0x1aae67(0x13c,-0x33,0x9b,-0x12)](_0x583b5b,_0x4549da(-0x115,-0x1fa,-0x22e,-0x27d))?![]:_0x583b5b;}function _0xca66f8(_0x34f195,_0x1e1b35,_0x75b0f5){if(!_0x1e1b35||!_0x75b0f5)throw new Error(_0x21398d(-0x2d,-0xe0,-0x56,-0xa9)+_0x5b98d2(0x54d,0x496,0x513,0x4ae)+'\x20\x61\x6e\x64\x20\x22\x65\x6e\x64\x22'+_0x21398d(0x28,-0x6e,-0x83,-0x159));function _0x5b98d2(_0x16d8d5,_0x3022f2,_0x1f6247,_0x443625){return _0x2ab8d6(_0x1f6247-0x151,_0x3022f2-0x1bf,_0x443625,_0x443625-0x8e);}function _0x21398d(_0x26ed3d,_0x1090da,_0x42e316,_0x382c66){return _0x2ab8d6(_0x1090da- -0x4e3,_0x1090da-0x18f,_0x26ed3d,_0x382c66-0x176);}return _0x34f195[_0x5b98d2(0x4db,0x427,0x4e2,0x43a)](_0x1e1b35)[0x14f1+-0x1*-0x1278+-0xd*0x308][_0x21398d(-0x184,-0x152,-0x67,-0xb5)](_0x75b0f5)[0x674+-0x13a6+-0xd32*-0x1];}function _0x1587c2(_0x5cc04a){const _0x4ac10d={};_0x4ac10d[_0x2a4c9c(0x2f2,0x2ff,0x28c,0x21b)]=_0x5d11ae[_0x2a4c9c(0x315,0x36a,0x434,0x3e3)],_0x4ac10d[_0x2a4c9c(0x4d9,0x40f,0x393,0x4b0)]=_0x5d11ae[_0x59c8dc(0x5be,0x4d7,0x695,0x665)];const _0x14eeb7=_0x4ac10d;function _0x59c8dc(_0x58e864,_0x272166,_0x144379,_0x3c7df3){return _0x23c1fa(_0x272166,_0x272166-0x99,_0x144379-0xb6,_0x58e864-0x2ed);}function _0x2a4c9c(_0x302058,_0x12e594,_0x5d2ec8,_0x4de6d3){return _0x2ab8d6(_0x12e594-0x7,_0x12e594-0x1e9,_0x302058,_0x4de6d3-0xce);}return new Promise(function(_0x14f9cc,_0x23cedf){let _0x443c7f=document['\x63\x72\x65\x61\x74\x65\x45\x6c\x65\x6d'+_0x20994b(0x468,0x4b5,0x513,0x50a)](_0x14eeb7[_0x20994b(0x43a,0x3a9,0x470,0x427)]);_0x443c7f[_0x46731a(-0x25,-0x137,-0x5c,-0x11)]=_0x5cc04a,_0x443c7f[_0x46731a(0x1d,0xbe,0xfa,0xd0)]=_0x14eeb7['\x78\x6b\x6c\x6e\x4d'];function _0x46731a(_0x23ba09,_0x1eccb0,_0x4f0ed7,_0xd73a0c){return _0x59c8dc(_0x4f0ed7- -0x59a,_0x23ba09,_0x4f0ed7-0x1dd,_0xd73a0c-0x146);}function _0x20994b(_0x538978,_0x2e2e09,_0x4e886d,_0x5d3671){return _0x2a4c9c(_0x2e2e09,_0x538978-0x13b,_0x4e886d-0x17d,_0x5d3671-0x18);}_0x443c7f[_0x20994b(0x438,0x48f,0x3a1,0x3d8)]=()=>_0x14f9cc(_0x443c7f),_0x443c7f[_0x20994b(0x51f,0x5e7,0x5f5,0x56f)]=()=>_0x23cedf(new Error(_0x20994b(0x49a,0x4a1,0x3f2,0x526)+_0x20994b(0x54d,0x5c1,0x484,0x599)+'\x20'+_0x5cc04a)),document[_0x20994b(0x4eb,0x4ea,0x41d,0x5cd)]['\x61\x70\x70\x65\x6e\x64'](_0x443c7f);});}function _0x1e588d(_0x2cdc2e,_0x1867f6){function _0x380dbf(_0x378839,_0x135fe8,_0x29404e,_0x82856b){return _0x23c1fa(_0x378839,_0x135fe8-0xe7,_0x29404e-0x1ec,_0x135fe8- -0x260);}function _0x1117b6(_0x44ad68,_0x6f8c14,_0x1383e5,_0x3c52f2){return _0x2ab8d6(_0x1383e5-0x204,_0x6f8c14-0x69,_0x44ad68,_0x3c52f2-0x50);}if(_0x5d11ae[_0x380dbf(-0x66,0x9,-0x11,0x8d)]!==_0x380dbf(0xe3,0x50,0x42,-0x5d))document[_0x380dbf(-0x14c,-0x60,0x7a,0x53)+'\x74\x6f\x72'](_0x2cdc2e)['\x61\x70\x70\x65\x6e\x64\x43\x68\x69\x6c'+'\x64'](document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+'\x74\x6f\x72'](_0x1867f6));else{const _0x137a6c=_0xfd6d26?function(){function _0x3dbd77(_0xc65fd6,_0x5a02e9,_0x51a049,_0x4ac9b5){return _0x380dbf(_0x51a049,_0x5a02e9-0x19e,_0x51a049-0x101,_0x4ac9b5-0x163);}if(_0x450187){const _0x22a4ad=_0x5d60be[_0x3dbd77(0x318,0x249,0x2dc,0x223)](_0x36ced8,arguments);return _0x177b3d=null,_0x22a4ad;}}:function(){};return _0x5940f7=![],_0x137a6c;}}function _0x405830(){function _0x313318(_0x2f9780,_0x44f31e,_0x16f571,_0x5d2cdd){return _0x23c1fa(_0x5d2cdd,_0x44f31e-0x1da,_0x16f571-0x1d1,_0x2f9780-0x2c8);}function _0x22221e(_0x41ae61,_0x38dcfd,_0x1e57df,_0x1a6ffb){return _0x23c1fa(_0x1e57df,_0x38dcfd-0x157,_0x1e57df-0x7d,_0x38dcfd- -0xeb);}return _0x5d11ae[_0x22221e(0x326,0x26d,0x20a,0x299)](_0x5d11ae[_0x313318(0x5b8,0x52d,0x4df,0x4dc)],'\x44\x68\x57\x56\x57')?_0x22febf[_0x313318(0x51f,0x609,0x4d1,0x5de)](_0x5d11ae[_0x313318(0x4e0,0x58c,0x45c,0x45f)]):/product/[_0x22221e(0x199,0x170,0xd0,0x255)](window[_0x22221e(0x137,0x1ec,0x151,0x158)]['\x68\x72\x65\x66']);}function _0xff24c(_0x4b838b){const _0x2c0bb5={'\x6d\x42\x4f\x71\x47':function(_0x341dc3){function _0x3358d6(_0x5789b8,_0x46db09,_0x36b63c,_0x410c57){return _0x4a84(_0x5789b8-0x3a5,_0x46db09);}return _0x5d11ae[_0x3358d6(0x60a,0x5b4,0x5a5,0x6a5)](_0x341dc3);}};function _0x308f5a(_0x2dc778,_0x172fa8,_0x1dbd28,_0x485914){return _0x23c1fa(_0x2dc778,_0x172fa8-0x3c,_0x1dbd28-0x161,_0x485914- -0xa9);}function _0x21b646(_0x45138f,_0x55469f,_0x3f6a69,_0xbd866f){return _0x23c1fa(_0xbd866f,_0x55469f-0x14a,_0x3f6a69-0x1e,_0x45138f-0xb);}if(_0x5d11ae[_0x21b646(0x31e,0x403,0x28b,0x31f)](_0x5d11ae[_0x308f5a(0x394,0x39a,0x2c1,0x304)],_0x5d11ae['\x47\x7a\x77\x47\x6f']))return new Promise(_0x258c2d=>setTimeout(_0x258c2d,_0x4b838b));else _0x332470(),_0x2c0bb5[_0x21b646(0x32d,0x345,0x3c9,0x3bb)](_0x240155);}function _0x475897(){function _0x31ff8d(_0x46957a,_0xd98a3c,_0x2e685a,_0x377c8a){return _0x23c1fa(_0x2e685a,_0xd98a3c-0x17e,_0x2e685a-0x16e,_0x46957a-0x2ce);}function _0x5824ef(_0x372125,_0x67c6cb,_0x3fa366,_0x35ec32){return _0x2ab8d6(_0x3fa366-0x13f,_0x67c6cb-0x182,_0x67c6cb,_0x35ec32-0x1a9);}return/cart/[_0x5824ef(0x4e7,0x423,0x49d,0x468)](window[_0x5824ef(0x51c,0x45f,0x519,0x5da)][_0x5824ef(0x459,0x563,0x493,0x47a)]);}function _0x25eab1(_0xd99cad,_0x4215de=-0x2b*0x5b+-0xef8+0x1*0x1e73,_0x39fb54=0x2121+0x40f*0x5+-0x3472){function _0x594406(_0x28b6ac,_0x4d592e,_0x587d13,_0x46140f){return _0x2ab8d6(_0x46140f- -0x4cd,_0x4d592e-0x178,_0x28b6ac,_0x46140f-0x15a);}const _0x3ee83a={'\x52\x64\x48\x50\x71':function(_0x416b68,_0x4be31e){return _0x416b68===_0x4be31e;},'\x4a\x4f\x49\x54\x56':function(_0x1617eb,_0x2d2ecd){return _0x5d11ae['\x73\x71\x61\x50\x43'](_0x1617eb,_0x2d2ecd);},'\x63\x74\x69\x6c\x67':_0x5905a9(0x5b8,0x57f,0x613,0x5e8)+_0x594406(-0x225,-0x1ae,-0x76,-0x162)};function _0x5905a9(_0x8f58c0,_0x366219,_0x2d6ea8,_0x47d4c4){return _0x2ab8d6(_0x366219-0xf5,_0x366219-0xdb,_0x2d6ea8,_0x47d4c4-0x19d);}if(_0x594406(-0x1c3,-0x170,-0xc0,-0x14d)!==_0x5d11ae[_0x594406(-0xac,-0x71,0x9c,-0x2d)])_0x3ee83a['\x52\x64\x48\x50\x71'](_0x2ff255['\x69\x64'],_0x5a2de9(_0x1bb0f0))&&_0x3ee83a[_0x594406(-0x216,-0x119,-0x1af,-0x156)](_0xcefb3c,_0xbdec21['\x70\x6f\x73\x69\x74\x69\x6f\x6e']);else{const _0x5b6ff1=document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+'\x74\x6f\x72'](_0xd99cad);!window['\x5f\x5f'+_0xd99cad]&&(window['\x5f\x5f'+_0xd99cad]=0x1da0+-0x1*-0x2564+0x10c1*-0x4);function _0x3812bf(){return new Promise(_0x5b1d0c=>{window['\x5f\x5f'+_0xd99cad]++,setTimeout(_0x5b1d0c,_0x4215de);});}if(_0x5d11ae[_0x594406(-0x126,-0x43,-0x178,-0xb7)](_0x5b6ff1,null)){if(_0x5d11ae[_0x5905a9(0x5e7,0x50b,0x432,0x4ea)](_0x5d11ae[_0x5905a9(0x5ab,0x51e,0x53b,0x43b)],_0x5d11ae[_0x594406(-0x8e,-0x182,-0x63,-0x108)])){const _0x554acc=_0x1d4acf['\x63\x6f\x6e\x73\x74\x72\x75\x63\x74\x6f'+'\x72'][_0x5905a9(0x4ca,0x505,0x559,0x5b3)]['\x62\x69\x6e\x64'](_0x1c06ad),_0x4fdb5a=_0x67221a[_0x5c03ab],_0x574c44=_0x4b4edd[_0x4fdb5a]||_0x554acc;_0x554acc[_0x5905a9(0x56e,0x549,0x60a,0x5e5)]=_0x4e9403[_0x5905a9(0x509,0x56b,0x5fa,0x4b5)](_0x19de47),_0x554acc[_0x594406(0x67,0x87,0xc0,-0x27)]=_0x574c44[_0x594406(-0x1d,0x24,-0x83,-0x27)][_0x5905a9(0x4d9,0x56b,0x649,0x5f5)](_0x574c44),_0x5a0375[_0x4fdb5a]=_0x554acc;}else{if(_0x5d11ae[_0x5905a9(0x342,0x3e0,0x451,0x3d6)](window['\x5f\x5f'+_0xd99cad],_0x39fb54))return window['\x5f\x5f'+_0xd99cad]=0xf10+0x1b22+-0x2a32,Promise[_0x5905a9(0x5aa,0x52a,0x4fe,0x54a)](null);return _0x5d11ae[_0x5905a9(0x437,0x43e,0x4a9,0x45e)](_0x3812bf)[_0x5905a9(0x5a7,0x548,0x4fa,0x4b6)](()=>_0x25eab1(_0xd99cad));}}else{if(_0x5d11ae[_0x5905a9(0x3b8,0x4a4,0x559,0x430)](_0x5d11ae[_0x5905a9(0x3bd,0x478,0x425,0x43b)],_0x5d11ae[_0x594406(-0xb9,-0xdd,-0x10d,-0x92)]))return Promise['\x72\x65\x73\x6f\x6c\x76\x65'](_0x5b6ff1);else{const _0x3c9dd1={};_0x3c9dd1[_0x594406(-0x289,-0x103,-0x1f8,-0x1cf)]=_0x3ee83a['\x63\x74\x69\x6c\x67'];const _0x8faa51=_0x3c9dd1,_0x558c5c=_0x5905a9(0x619,0x570,0x50c,0x641)+_0x5905a9(0x3d5,0x41d,0x455,0x48a);if(!_0x169a81['\x65\x6e\x61\x62\x6c\x65\x53\x6c\x69\x64'+'\x65\x72\x46\x6f\x72\x54\x68\x75\x6d\x62'+_0x5905a9(0x62e,0x54d,0x5a0,0x593)+'\x6f\x70'])return;if(!_0x3fe135[_0x5905a9(0x373,0x3f8,0x447,0x43d)+'\x74\x6f\x72'](_0x558c5c))return;const _0xe4b84f=new _0x12cb0b(_0x558c5c,_0x522fdf,{'\x6f\x6e':{'\x72\x65\x61\x64\x79':function(){function _0x257e48(_0x29eaf0,_0x4389aa,_0x4ce61e,_0x1892e){return _0x594406(_0x29eaf0,_0x4389aa-0x1d6,_0x4ce61e-0x1cc,_0x4389aa-0x4c0);}function _0x5018c0(_0x1912c6,_0x17a6d6,_0x85eee1,_0x584de5){return _0x5905a9(_0x1912c6-0xab,_0x85eee1- -0xe2,_0x1912c6,_0x584de5-0x3f);}_0x50faee[_0x5018c0(0x2be,0x293,0x36d,0x2a6)](_0x8faa51[_0x5018c0(0x2a6,0x3f9,0x311,0x2ac)]);}}});}}}}function _0x4c0998(_0x4e575a){function _0x55d8ad(_0x4ce915,_0x331412,_0x4a1afc,_0x58000d){return _0x2ab8d6(_0x58000d- -0x14a,_0x331412-0xd5,_0x4a1afc,_0x58000d-0x129);}const _0x3822a6=document[_0x4ddc31(0x491,0x47b,0x4fd,0x455)+'\x65\x6e\x74'](_0x5d11ae[_0x4ddc31(0x40e,0x37e,0x3aa,0x378)]);_0x3822a6[_0x55d8ad(0x1ec,0x152,0xd3,0x1b5)+'\x74']=_0x4e575a;function _0x4ddc31(_0x26fc60,_0x3efdff,_0x6cdd09,_0x3a4812){return _0x2ab8d6(_0x3a4812- -0x49,_0x3efdff-0x19e,_0x26fc60,_0x3a4812-0x4);}document[_0x55d8ad(0x314,0x28e,0x190,0x25f)]['\x61\x70\x70\x65\x6e\x64'](_0x3822a6);}async function _0x52e790(_0xd08ca7){return new Promise(async(_0x526ae7,_0xa06d01)=>{const _0x15e68c={};_0x15e68c['\x57\x6c\x49\x68\x6e']=_0x5d11ae[_0x41e076(-0xff,-0x53,-0x3b,-0x36)];const _0x21bd85=_0x15e68c;function _0x57b33c(_0x46ceec,_0xbe686b,_0x1b8afe,_0x3df1ab){return _0x4a84(_0xbe686b-0x200,_0x46ceec);}function _0x41e076(_0x21359c,_0x125b39,_0x40fd15,_0x21bdb7){return _0x4a84(_0x21bdb7- -0x24a,_0x21359c);}if(_0x5d11ae[_0x57b33c(0x3b1,0x347,0x3df,0x413)](_0x5d11ae[_0x41e076(-0x56,-0x133,-0x37,-0x92)],_0x5d11ae['\x57\x6d\x53\x49\x61']))try{if(_0x5d11ae[_0x41e076(-0xa,-0xb1,-0x104,-0x48)](_0x41e076(-0x66,-0x1e,0x93,-0x59),_0x5d11ae[_0x41e076(0x48,-0x7d,0xec,0x25)]))return _0x5adfe4;else{const _0x422acf=document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+_0x57b33c(0x4d4,0x49f,0x3fb,0x3be)](_0x57b33c(0x5ac,0x4ed,0x5a4,0x511)+_0x41e076(0xf,0xbf,0x5e,0x92)+'\x5f\x76\x61\x72\x69\x61\x6e\x74\x73'),_0x3dafe5=_0x422acf[_0x57b33c(0x340,0x3e2,0x3f0,0x3e6)+_0x41e076(0x57,-0x32,-0x124,-0x67)][-0x17fd+0x1*0x1aa1+-0x2*0x152],_0x10ab5c=parseInt(_0x3dafe5[_0x41e076(0x3d,-0x30,-0x8f,-0x6b)]['\x74\x72\x69\x6d']()['\x74\x6f\x4c\x6f\x77\x65\x72\x43\x61\x73'+'\x65']());variant=_0xd08ca7[_0x57b33c(0x355,0x43e,0x402,0x37e)][_0x41e076(-0x153,-0x7d,-0x6f,-0xef)](_0x9476df=>_0x9476df['\x69\x64']===_0x10ab5c)[0x1938+0x1*0xe15+-0x274d*0x1],_0x5d11ae['\x69\x7a\x58\x45\x73'](_0x526ae7,variant);}}catch(_0x546e95){if(_0x5d11ae[_0x41e076(-0xb4,-0x88,-0x102,-0x103)](_0x57b33c(0x3cd,0x433,0x45d,0x444),_0x5d11ae['\x7a\x68\x5a\x52\x48'])){const _0x5ad4cd=_0x393ff6[_0x57b33c(0x444,0x4f1,0x568,0x5c2)+_0x41e076(0x4,-0x198,-0x195,-0xd1)](_0x21bd85[_0x57b33c(0x4d4,0x4ad,0x58a,0x43c)]);_0x5ad4cd[_0x57b33c(0x2c1,0x352,0x32a,0x2bc)+'\x74']=_0x2a5a06,_0x487c7c[_0x41e076(-0x74,-0x45,-0xd9,-0x4e)][_0x41e076(0x96,0x9c,-0x1a,-0x39)](_0x5ad4cd);}else _0x5d11ae['\x41\x79\x45\x78\x46'](_0x526ae7,null);}else return _0x51d337['\x6c\x6f\x67']('\x4e\x6f\x20\x69\x6d\x61\x67\x65\x20\x61'+_0x57b33c(0x3b1,0x37f,0x2a1,0x2fb));});}async function _0x5bef32(_0x4aa69f){const _0x1c3e99={'\x63\x6a\x43\x4d\x43':function(_0x53d5f3,_0x4fbb79){function _0x54f8f2(_0x20bd83,_0x5e5c05,_0x1b08c9,_0x26c7a5){return _0x4a84(_0x20bd83-0x76,_0x26c7a5);}return _0x5d11ae[_0x54f8f2(0x25f,0x213,0x22b,0x29b)](_0x53d5f3,_0x4fbb79);}};return new Promise(async(_0x36bf04,_0x11ef82)=>{const _0x280980=await _0x5f26bb();function _0x181b03(_0xd1ed8d,_0x4a6506,_0x36f88d,_0x46cad6){return _0x4a84(_0x36f88d- -0x379,_0xd1ed8d);}function _0x56d3c(_0x2ad316,_0x28e086,_0xdd86f5,_0x36c0c3){return _0x4a84(_0x28e086-0x281,_0x36c0c3);}var _0x177ed3=_0x280980[_0x181b03(-0x1b1,-0x105,-0x1f1,-0x282)][_0x56d3c(0x3e6,0x3dc,0x3b9,0x4ba)](_0x14f952=>_0x14f952['\x69\x64']===parseInt(_0x4aa69f))[0xa91*-0x3+0xb24+0x148f*0x1]['\x76\x61\x72\x69\x61\x6e\x74\x5f\x69\x64'+'\x73'][-0x1371*0x1+-0x58*0x56+0x3c5*0xd],_0x2da146=_0x280980[_0x181b03(-0x17a,-0x76,-0x13b,-0x58)]['\x66\x69\x6c\x74\x65\x72'](_0x49d730=>_0x49d730['\x69\x64']===parseInt(_0x177ed3))[0x4*0x856+0x2c+-0x2184*0x1][_0x181b03(-0x258,-0x2b8,-0x1d3,-0x20a)][_0x56d3c(0x3c1,0x465,0x543,0x4cf)]('\x2f')[_0x56d3c(0x4d5,0x47c,0x546,0x53f)](_0x27f282=>_0x27f282[_0x181b03(-0x143,-0x1ff,-0x21f,-0x1fe)]());_0x1c3e99[_0x181b03(-0x20e,-0x1e3,-0x241,-0x2a0)](_0x36bf04,_0x2da146);});}async function _0x2d7bed(_0x3d85ba){function _0x3798be(_0x9e79db,_0x1240f7,_0x55090b,_0x33ae2b){return _0x23c1fa(_0x9e79db,_0x1240f7-0xfb,_0x55090b-0x174,_0x1240f7-0x164);}function _0x2933d2(_0x437dcb,_0x2e5a00,_0xb0bbf3,_0x36dae6){return _0x23c1fa(_0x437dcb,_0x2e5a00-0x75,_0xb0bbf3-0x1ba,_0xb0bbf3- -0x160);}const _0x1a7be8={'\x67\x70\x49\x58\x4c':function(_0x5d5167,_0x407116){function _0x1441bc(_0x62e5ed,_0x2c67ab,_0x3aaa06,_0x185a99){return _0x4a84(_0x3aaa06- -0x239,_0x62e5ed);}return _0x5d11ae[_0x1441bc(-0x6,0x27,-0x15,-0x30)](_0x5d5167,_0x407116);},'\x4b\x66\x45\x4f\x79':_0x3798be(0x3aa,0x494,0x447,0x4f4),'\x7a\x4d\x74\x43\x6d':function(_0x418401,_0x46f709){function _0x1141ca(_0x20eb45,_0x521690,_0x50bcb8,_0x23eab1){return _0x3798be(_0x50bcb8,_0x20eb45-0x122,_0x50bcb8-0xab,_0x23eab1-0x71);}return _0x5d11ae[_0x1141ca(0x600,0x58f,0x515,0x6c6)](_0x418401,_0x46f709);},'\x79\x6a\x79\x51\x4c':_0x5d11ae[_0x3798be(0x404,0x382,0x467,0x377)],'\x73\x63\x58\x79\x57':function(_0x12224e,_0x511df9){return _0x12224e!==_0x511df9;},'\x7a\x65\x54\x72\x6c':function(_0x50a6f3,_0x1b7612){function _0x2fc9bf(_0x2e5465,_0x44a95b,_0x77c0fb,_0x12a34a){return _0x2933d2(_0x77c0fb,_0x44a95b-0x14f,_0x44a95b-0x6b,_0x12a34a-0x35);}return _0x5d11ae[_0x2fc9bf(0x65,0x126,0x3a,0x12f)](_0x50a6f3,_0x1b7612);},'\x6e\x54\x68\x7a\x57':function(_0x5f17ee,_0x3deed7){return _0x5d11ae['\x78\x77\x63\x73\x68'](_0x5f17ee,_0x3deed7);},'\x63\x47\x73\x53\x76':function(_0x2e6288,_0x545115){function _0x265eea(_0x46b9ba,_0x3604cb,_0x44e422,_0x2d0758){return _0x3798be(_0x3604cb,_0x46b9ba- -0x4b0,_0x44e422-0x27,_0x2d0758-0x8f);}return _0x5d11ae[_0x265eea(0x6d,-0x65,0x52,0x12a)](_0x2e6288,_0x545115);},'\x72\x4d\x70\x42\x7a':function(_0x3bf6a4,_0x502d78){return _0x3bf6a4!==_0x502d78;},'\x51\x67\x76\x6e\x66':_0x5d11ae['\x44\x61\x52\x48\x51']};return _0x5d11ae[_0x2933d2(0x129,0x101,0x98,0xb4)]('\x74\x62\x62\x74\x4c',_0x5d11ae[_0x2933d2(0x1a2,0x1e4,0x1d6,0x269)])?new Promise(async(_0x19ad9c,_0x53c82c)=>{function _0x3f96b3(_0x271339,_0x26f691,_0x881912,_0x30b8af){return _0x3798be(_0x26f691,_0x881912- -0x15e,_0x881912-0x113,_0x30b8af-0xe9);}const _0x389d51={'\x48\x61\x79\x64\x57':function(_0x1da4b7,_0x462a6b){function _0x3bc0de(_0x15b5d0,_0x4842ea,_0x15bed5,_0x373e12){return _0x4a84(_0x15bed5- -0x346,_0x15b5d0);}return _0x5d11ae[_0x3bc0de(-0x15e,-0x4a,-0x91,-0x44)](_0x1da4b7,_0x462a6b);},'\x66\x6f\x65\x64\x51':function(_0xaf15b1,_0x271aca){return _0x5d11ae['\x58\x44\x46\x79\x76'](_0xaf15b1,_0x271aca);},'\x61\x4d\x5a\x55\x46':function(_0x2ad9cf,_0x29811b){return _0x2ad9cf+_0x29811b;},'\x55\x78\x51\x6f\x70':_0x5d11ae[_0x3f96b3(0x218,0x252,0x2c7,0x250)],'\x59\x46\x53\x63\x70':function(_0x4cdf5d){return _0x5d11ae['\x59\x77\x4e\x4c\x52'](_0x4cdf5d);}};function _0x10507d(_0x2109ef,_0x58efa9,_0xefd465,_0x29f8a1){return _0x3798be(_0xefd465,_0x58efa9-0x7d,_0xefd465-0x130,_0x29f8a1-0x16d);}const _0x3c61b8=await _0x45fc06();try{if(_0x5d11ae[_0x3f96b3(0x2f3,0x3da,0x37f,0x41a)]===_0x5d11ae[_0x10507d(0x4e0,0x55a,0x478,0x5a2)])_0x3c61b8[_0x3f96b3(0x372,0x382,0x2ee,0x272)][_0x10507d(0x436,0x3e6,0x4a0,0x34e)](_0x14b534=>{function _0xbabaeb(_0x27c8a3,_0x54ecb2,_0x19702a,_0xd517fd){return _0x3f96b3(_0x27c8a3-0xfe,_0x27c8a3,_0x19702a- -0x46c,_0xd517fd-0x145);}function _0x2fb8c1(_0x1c1fe6,_0x4e4bef,_0x1782a1,_0x49c2e5){return _0x10507d(_0x1c1fe6-0xd0,_0x1c1fe6- -0x4b,_0x49c2e5,_0x49c2e5-0x2);}if(_0x1a7be8[_0xbabaeb(-0x2bd,-0x24e,-0x20e,-0x2bd)](_0x1a7be8[_0x2fb8c1(0x482,0x3b4,0x511,0x40e)],'\x4d\x74\x58\x42\x56')){const _0x5b2a2a=WTAiLa[_0x2fb8c1(0x3f0,0x3ca,0x43c,0x486)](_0x1d55ca,WTAiLa['\x66\x6f\x65\x64\x51'](WTAiLa['\x61\x4d\x5a\x55\x46'](_0xbabaeb(-0xb7,-0x16f,-0x100,-0x123)+_0x2fb8c1(0x3e2,0x498,0x3e9,0x41b),WTAiLa[_0x2fb8c1(0x4e4,0x485,0x52c,0x485)]),'\x29\x3b'));_0x42870d=WTAiLa[_0x2fb8c1(0x46f,0x4d8,0x501,0x38a)](_0x5b2a2a);}else{if(_0x1a7be8[_0xbabaeb(-0x2ad,-0x15f,-0x1fc,-0x1f4)](_0x1a7be8['\x79\x6a\x79\x51\x4c'],_0x14b534)&&_0x14b534[_0xbabaeb(-0x2b9,-0x173,-0x21c,-0x151)+_0x2fb8c1(0x46a,0x43b,0x459,0x457)])return _0x14b534;}})[_0x3f96b3(0x29d,0x23f,0x2ab,0x319)](_0x3aaf96=>{if(!_0x3aaf96)return;function _0x3dc1cd(_0x2684a6,_0x14c989,_0x1ca7d4,_0x5ba197){return _0x3f96b3(_0x2684a6-0x11d,_0x2684a6,_0x14c989- -0x3f5,_0x5ba197-0x68);}function _0x35c3ed(_0x5b3c78,_0x390a4b,_0x1e5580,_0x172929){return _0x3f96b3(_0x5b3c78-0x9,_0x390a4b,_0x1e5580-0x40,_0x172929-0x1a2);}const _0x210dcf=_0x1a7be8[_0x35c3ed(0x3d7,0x447,0x3ec,0x49f)](_0x3aaf96[_0x35c3ed(0x320,0x2f7,0x290,0x258)+_0x35c3ed(0x34f,0x3b5,0x31a,0x3ec)],undefined)?_0x3aaf96[_0x35c3ed(0x257,0x1aa,0x290,0x32e)+_0x35c3ed(0x2ac,0x392,0x31a,0x2b8)]:null;if(_0x210dcf&&_0x1a7be8[_0x35c3ed(0x276,0x22e,0x22b,0x2c1)]('\x69\x64',_0x210dcf)&&_0x1a7be8['\x6e\x54\x68\x7a\x57'](_0x210dcf['\x69\x64'],_0x1a7be8[_0x35c3ed(0x26a,0x3d8,0x2ee,0x3a7)](parseInt,_0x3d85ba))){if(_0x1a7be8[_0x35c3ed(0x340,0x450,0x3f6,0x406)](_0x1a7be8[_0x3dc1cd(-0x237,-0x1a4,-0x222,-0x1ec)],_0x1a7be8['\x51\x67\x76\x6e\x66']))return;else _0x1a7be8['\x63\x47\x73\x53\x76'](_0x19ad9c,_0x3aaf96);}});else return;}catch(_0x55129f){_0x5d11ae[_0x10507d(0x371,0x3e3,0x3e6,0x304)]===_0x5d11ae[_0x3f96b3(0x233,0x124,0x208,0x194)]?(console[_0x10507d(0x353,0x438,0x390,0x417)](_0x5d11ae[_0x3f96b3(0x453,0x447,0x37d,0x32c)],_0x55129f),_0x5d11ae[_0x10507d(0x5dd,0x540,0x502,0x591)](_0x19ad9c,null)):_0x1169cd=_0x3f96b3(0x28a,0x227,0x2a5,0x1d4)+(_0x273883[_0x10507d(0x58d,0x4b8,0x4cd,0x550)][_0x10507d(0x2f8,0x3de,0x3fb,0x485)]+_0x11cbd6['\x6c\x6f\x63\x61\x74\x69\x6f\x6e'][_0x10507d(0x4ec,0x53e,0x4ac,0x5df)])+_0x10507d(0x570,0x4e2,0x46e,0x5a2);}}):null;}async function _0x5c6177(){function _0x2203cc(_0x48918b,_0x6c35f5,_0x10efc8,_0x1f2307){return _0x23c1fa(_0x10efc8,_0x6c35f5-0x8,_0x10efc8-0x1bf,_0x6c35f5-0xdf);}if(window['\x65\x7a\x66\x79\x5f\x69\x6d\x61\x67\x65'+'\x5f\x70\x72\x6f\x64\x75\x63\x74\x73']){if(_0x5d11ae[_0x520747(0x225,0x2a9,0x2fb,0x258)]===_0x5d11ae[_0x520747(0x225,0x19a,0x2c1,0x1ac)])return window['\x65\x7a\x66\x79\x5f\x69\x6d\x61\x67\x65'+_0x2203cc(0x471,0x416,0x46f,0x33f)];else return;}function _0x520747(_0x99acb8,_0x120f51,_0x371b62,_0x5075c4){return _0x2ab8d6(_0x99acb8- -0x114,_0x120f51-0x74,_0x5075c4,_0x5075c4-0x10f);}return new Promise(async(_0x1a8cda,_0x31a6a2)=>{let _0x11f10e=_0x345f28(0x1ca,0x85,0xc8,0xf6)+_0x5d11ae[_0x345f28(0x14c,0xb4,0x233,0x14e)](window[_0x4fad06(0x285,0x218,0x270,0x2ec)][_0x4fad06(0x1ab,0x1d0,0x1d9,0x157)],window[_0x345f28(0x1b5,0x16f,0x12b,0x12e)][_0x4fad06(0x30b,0x31a,0x3ad,0x3d8)])+'\x2e\x6a\x73\x6f\x6e',_0x462a93=await fetch(_0x11f10e),{product:_0x1bd5dc}=await _0x462a93[_0x4fad06(0x2a9,0x2a3,0x2c8,0x368)]();function _0x345f28(_0x4818b9,_0x2d226b,_0x38f501,_0x2436de){return _0x520747(_0x2436de- -0x198,_0x2d226b-0x3d,_0x38f501-0xb7,_0x38f501);}window['\x65\x7a\x66\x79\x5f\x69\x6d\x61\x67\x65'+_0x4fad06(0x2e5,0x310,0x388,0x1fe)]=_0x1bd5dc['\x69\x6d\x61\x67\x65\x73'];function _0x4fad06(_0x490cc9,_0x2585df,_0x61f3b8,_0x39a8be){return _0x520747(_0x490cc9- -0x41,_0x2585df-0xe4,_0x61f3b8-0x1e7,_0x39a8be);}_0x5d11ae[_0x345f28(0x1b4,0x1b5,0xbe,0x19c)](_0x1a8cda,_0x1bd5dc[_0x4fad06(0x1e0,0x259,0x1be,0x217)]);});}async function _0x5f26bb(){function _0x251f6d(_0x48f1e3,_0x32ed58,_0xb078cf,_0x9b94fe){return _0x2ab8d6(_0x9b94fe- -0xd5,_0x32ed58-0xf5,_0x32ed58,_0x9b94fe-0xf2);}const _0x15f49d={'\x52\x58\x6a\x48\x45':_0x5d11ae[_0x251f6d(0x2f2,0x1c8,0x208,0x24c)],'\x77\x64\x67\x74\x74':_0x5d11ae[_0xdab7d2(-0x55,-0x15f,-0x7a,-0xcb)],'\x68\x7a\x44\x66\x6b':function(_0x315330,_0x2ac292){return _0x315330+_0x2ac292;},'\x74\x58\x44\x62\x6f':function(_0x1c3cb7,_0x3731fb){function _0x1de8ad(_0x36a595,_0x452d8,_0x2f6111,_0x59a5bf){return _0x251f6d(_0x36a595-0xf8,_0x452d8,_0x2f6111-0x54,_0x36a595- -0x14f);}return _0x5d11ae[_0x1de8ad(0x224,0x27f,0x2ae,0x27a)](_0x1c3cb7,_0x3731fb);},'\x4c\x75\x77\x77\x6d':function(_0x573fd5,_0x546e4d){function _0x55a413(_0x28dd18,_0x45b53a,_0x5a2542,_0x39fc7e){return _0x251f6d(_0x28dd18-0x0,_0x28dd18,_0x5a2542-0x28,_0x39fc7e-0x2f4);}return _0x5d11ae[_0x55a413(0x600,0x58b,0x564,0x5d7)](_0x573fd5,_0x546e4d);}};function _0xdab7d2(_0x3e14d8,_0x15ddb9,_0x239b0d,_0x251364){return _0x23c1fa(_0x15ddb9,_0x15ddb9-0x142,_0x239b0d-0x9d,_0x239b0d- -0x3ab);}if(window['\x65\x7a\x66\x79\x5f\x70\x72\x6f\x64\x75'+_0xdab7d2(-0x235,-0x259,-0x199,-0x22b)]){if(_0x5d11ae[_0xdab7d2(-0x76,-0x15e,-0xc1,-0x189)](_0x5d11ae[_0x251f6d(0x2e5,0x25b,0x2bd,0x2a5)],_0x5d11ae[_0x251f6d(0x2d4,0x2ae,0x31b,0x2a5)]))return window[_0x251f6d(0x2d8,0x389,0x215,0x2d7)+_0xdab7d2(-0x1d6,-0x1bf,-0x199,-0x10b)];else{_0x5f6e13[_0x251f6d(0x2be,0x32f,0x352,0x2b7)]=_0x3a35a7;const _0x563d9f={};_0x563d9f[_0xdab7d2(-0x16d,-0x156,-0x16f,-0x17b)]=!![],_0x35e51b['\x64\x69\x73\x70\x61\x74\x63\x68\x45\x76'+'\x65\x6e\x74'](new _0x3d4475(_0x5d11ae[_0x251f6d(0x458,0x349,0x34f,0x3bc)],_0x563d9f));}}return new Promise(async(_0x267792,_0x1a7014)=>{function _0x39788e(_0x51e484,_0x5d77c7,_0x520f0c,_0x27ead3){return _0xdab7d2(_0x51e484-0x72,_0x27ead3,_0x51e484-0x1dc,_0x27ead3-0x113);}function _0x2f97c7(_0xde8130,_0x317be3,_0x2add99,_0x3a420e){return _0x251f6d(_0xde8130-0x15c,_0x317be3,_0x2add99-0xa9,_0x2add99- -0xff);}if(_0x15f49d[_0x39788e(0x8d,-0x45,0x167,0xb5)]===_0x39788e(0xa0,0x76,0x39,0x22)){if(_0x15f49d['\x52\x58\x6a\x48\x45']in _0x41b684&&_0x463966[_0x2f97c7(0x24f,0x9a,0x179,0x226)+'\x6d\x61\x67\x65'])return _0x5369bd;}else{let _0x5cb8c4='\x68\x74\x74\x70\x73\x3a\x2f\x2f'+_0x15f49d['\x68\x7a\x44\x66\x6b'](window[_0x2f97c7(0x28b,0x195,0x206,0x1e1)][_0x2f97c7(0x55,0x1f7,0x12c,0xce)],window[_0x39788e(0x108,0x192,0x104,0x112)][_0x39788e(0x18e,0x213,0xff,0xb6)])+'\x2e\x6a\x73\x6f\x6e',_0x30a5d6=await _0x15f49d['\x74\x58\x44\x62\x6f'](fetch,_0x5cb8c4),{product:_0x2abc96}=await _0x30a5d6[_0x2f97c7(0x164,0x224,0x22a,0x26b)]();window[_0x39788e(0xda,0xfd,0x40,0x12a)+_0x39788e(0x43,0xf3,0x97,0x89)]=_0x2abc96,_0x15f49d[_0x39788e(0x14d,0x75,0x169,0x153)](_0x267792,_0x2abc96);}});}async function _0x5c64b1(_0xc2977a){const _0x91bb0e={'\x4d\x52\x48\x48\x5a':function(_0x2df1d7,_0xdc61cf){function _0x52a98d(_0x801daf,_0x1e4e23,_0x17920d,_0x3eeffb){return _0x4a84(_0x17920d-0x169,_0x801daf);}return _0x5d11ae[_0x52a98d(0x461,0x34b,0x38d,0x3d3)](_0x2df1d7,_0xdc61cf);},'\x55\x6c\x54\x63\x5a':function(_0x53bea5,_0x36c204){return _0x5d11ae['\x6d\x71\x48\x4f\x42'](_0x53bea5,_0x36c204);},'\x49\x57\x6f\x71\x64':'\x4b\x51\x70\x71\x70','\x6c\x46\x71\x4f\x59':_0x5d11ae[_0xd16f83(-0x104,-0x1dc,-0x1be,-0x7a)],'\x52\x64\x62\x6d\x49':function(_0x17b269,_0x22d19b,_0x5b88c1){return _0x17b269(_0x22d19b,_0x5b88c1);},'\x57\x55\x72\x57\x57':_0x5d11ae['\x74\x50\x6d\x79\x6a'],'\x57\x65\x47\x5a\x6d':_0x5f4836(-0x110,-0x69,0x44,-0x24),'\x41\x78\x43\x70\x6b':_0x5d11ae[_0x5f4836(-0x8c,-0xe0,-0xe1,-0x9)]};function _0x5f4836(_0x3e80e4,_0x1873e5,_0x3315b0,_0x3944c3){return _0x23c1fa(_0x3944c3,_0x1873e5-0x18f,_0x3315b0-0x1cc,_0x1873e5- -0x40e);}function _0xd16f83(_0x5a27a6,_0x5960d3,_0x56860b,_0x1df423){return _0x23c1fa(_0x5960d3,_0x5960d3-0xfc,_0x56860b-0x1dc,_0x5a27a6- -0x334);}return _0x5d11ae[_0x5f4836(-0x12f,-0x140,-0x10d,-0x81)]('\x6f\x45\x6a\x6e\x4e','\x6f\x45\x6a\x6e\x4e')?![]:new Promise(async(_0x547fbf,_0x561af1)=>{const _0x4430ab={'\x71\x44\x43\x53\x55':function(_0x7bffd,_0x3037b9){return _0x91bb0e['\x4d\x52\x48\x48\x5a'](_0x7bffd,_0x3037b9);},'\x63\x63\x45\x47\x5a':_0x31ac83(0x92,-0xf,0xce,0x1ab),'\x76\x4c\x4d\x58\x64':function(_0x311b2e,_0x5dfd16){function _0x4e9bd8(_0x5ebd5,_0x5a6e1c,_0x408b6c,_0x322eb4){return _0x31ac83(_0x5ebd5,_0x5a6e1c-0xb,_0x5a6e1c-0x39f,_0x322eb4-0x106);}return _0x91bb0e[_0x4e9bd8(0x645,0x5c3,0x5d5,0x651)](_0x311b2e,_0x5dfd16);},'\x47\x78\x61\x48\x67':_0x91bb0e[_0x16e7e5(0x305,0x364,0x380,0x2f4)],'\x4a\x65\x73\x41\x49':_0x91bb0e[_0x31ac83(0x26b,0x323,0x27d,0x21c)],'\x55\x56\x63\x72\x75':function(_0x4e5006,_0x2cc93f){return _0x91bb0e['\x55\x6c\x54\x63\x5a'](_0x4e5006,_0x2cc93f);},'\x6c\x51\x45\x64\x42':function(_0x59a2c2,_0x2c0552,_0x25db4f){function _0x1ae8da(_0x4fa399,_0x5a250d,_0x37bccd,_0x7d4513){return _0x31ac83(_0x4fa399,_0x5a250d-0x159,_0x7d4513- -0x216,_0x7d4513-0x91);}return _0x91bb0e[_0x1ae8da(-0x9a,-0x129,-0xb8,-0x60)](_0x59a2c2,_0x2c0552,_0x25db4f);}};function _0x16e7e5(_0x48b19a,_0x513126,_0x5740e1,_0x1d949c){return _0x5f4836(_0x48b19a-0x15d,_0x1d949c-0x3c7,_0x5740e1-0x10,_0x513126);}function _0x31ac83(_0x31f660,_0x5b5383,_0x59f67d,_0x2259b2){return _0x5f4836(_0x31f660-0x142,_0x59f67d-0x2d6,_0x59f67d-0xb7,_0x31f660);}const _0x5e914d=await _0x5c6177();try{_0x5e914d[_0x16e7e5(0x189,0x161,0x1a6,0x1be)](_0xd6c12e=>{function _0x94ee7a(_0x23436e,_0x5efbe9,_0x45f10d,_0x257422){return _0x31ac83(_0x257422,_0x5efbe9-0xa8,_0x45f10d-0x208,_0x257422-0x3c);}function _0x3281f2(_0x45af28,_0x12bde3,_0x9b9263,_0x21346f){return _0x16e7e5(_0x45af28-0x186,_0x21346f,_0x9b9263-0x163,_0x12bde3- -0x1dc);}if(_0x4430ab['\x71\x44\x43\x53\x55'](_0x4430ab[_0x3281f2(-0x1b,0x22,0x4e,0x11)],_0x4430ab['\x63\x63\x45\x47\x5a']))return;else _0xd6c12e['\x69\x64']===_0x4430ab[_0x3281f2(-0x94,0x25,-0x45,0x58)](parseInt,_0xc2977a)&&(_0x4430ab[_0x94ee7a(0x3a6,0x492,0x3d2,0x47d)](_0x4430ab[_0x94ee7a(0x373,0x43b,0x3e1,0x4ca)],_0x4430ab[_0x3281f2(0xd4,0xee,0x138,0x1d0)])?_0x452a48['\x5f\x5f'+_0x4cec19]=-0xe27+0x160d+-0x7e6:_0x547fbf(_0xd6c12e['\x70\x6f\x73\x69\x74\x69\x6f\x6e']));});}catch(_0x143ed7){if(_0x91bb0e['\x57\x55\x72\x57\x57']!==_0x91bb0e[_0x16e7e5(0x1b3,0x289,0x239,0x1c9)])console[_0x16e7e5(0x1ad,0x209,0x1fc,0x210)](_0x91bb0e['\x41\x78\x43\x70\x6b'],_0x143ed7),_0x547fbf(null);else{const _0xc47a31=()=>{function _0x3c3e63(_0x2fadbb,_0x15f6f1,_0x5def3b,_0x415fbf){return _0x16e7e5(_0x2fadbb-0xea,_0x415fbf,_0x5def3b-0x8f,_0x15f6f1- -0xde);}const _0x14e963=_0x64c635[_0x2882a6(0x37f,0x344,0x33c,0x377)+'\x74\x65'](_0x4430ab[_0x2882a6(0x43b,0x3db,0x3e8,0x361)]);if(!_0x14e963)return;const _0x315085=_0x4430ab[_0x3c3e63(0x193,0x244,0x204,0x326)](_0x43fb20,_0x14e963);function _0x2882a6(_0x17264f,_0x2a0826,_0x1dac3a,_0x3e24ac){return _0x16e7e5(_0x17264f-0x1f3,_0x17264f,_0x1dac3a-0xfb,_0x1dac3a-0xb3);}_0x1ca1cf['\x73\x65\x6c\x65\x63\x74'](_0x315085,_0x3be9a8[_0x2882a6(0x3ef,0x3ec,0x41f,0x4d7)+'\x61\x67\x65\x4c\x6f\x6f\x70'],!![]);};_0x4430ab['\x6c\x51\x45\x64\x42'](_0x15d3b9,_0xc47a31,_0xea8e4a);}}});}async function _0x45fc06(){const _0x1074bf=document[_0x1b921f(-0x28b,-0x249,-0x24f,-0x25d)+'\x74\x6f\x72'](_0x95db30(0x67f,0x5f4,0x6dd,0x574)+_0x1b921f(-0x1a2,-0x260,-0x1b3,-0x1cc)+_0x1b921f(-0x2fb,-0x19a,-0x221,-0x27d));function _0x1b921f(_0x23fc52,_0x1f864b,_0x22585a,_0x293ebe){return _0x23c1fa(_0x293ebe,_0x1f864b-0x4f,_0x22585a-0xd,_0x22585a- -0x44f);}if(_0x1074bf)return JSON[_0x1b921f(-0x1a8,-0xc1,-0x16c,-0xfe)](_0x1074bf[_0x1b921f(-0x141,-0x17b,-0x11b,-0x62)]);let _0x3d9152;if(_0x5d11ae[_0x95db30(0x5d9,0x515,0x4e6,0x503)](_hasFeaturedProduct)){const _0x4c3ab7=document[_0x1b921f(-0x1b2,-0x17d,-0x24f,-0x2ba)+_0x1b921f(-0xa9,-0x1e7,-0x106,-0xfc)]('\x5b\x64\x61\x74\x61\x2d\x70\x72\x6f\x64'+'\x75\x63\x74\x2d\x68\x61\x6e\x64\x6c\x65'+'\x5d');if(!_0x4c3ab7)return;const _0x48bc29=_0x4c3ab7[_0x95db30(0x5a3,0x59f,0x5af,0x54b)+'\x74\x65'](_0x5d11ae[_0x95db30(0x648,0x5f0,0x50c,0x537)]);_0x3d9152=_0x95db30(0x562,0x56e,0x49c,0x4ac)+window['\x6c\x6f\x63\x61\x74\x69\x6f\x6e']['\x68\x6f\x73\x74']+_0x1b921f(-0x1dd,-0x26a,-0x220,-0x268)+_0x48bc29+'\x2e\x6a\x73\x6f\x6e';}else _0x3d9152=_0x95db30(0x568,0x56e,0x494,0x5be)+_0x5d11ae['\x47\x4b\x78\x75\x65'](window['\x6c\x6f\x63\x61\x74\x69\x6f\x6e'][_0x1b921f(-0x1eb,-0x2bb,-0x252,-0x174)],window[_0x95db30(0x4c5,0x5a6,0x50c,0x5bb)][_0x1b921f(-0x1b6,-0x1a7,-0xf2,-0x44)])+_0x95db30(0x615,0x5d0,0x58e,0x4e5);function _0x95db30(_0x46c509,_0x2f9d1c,_0x4d048d,_0xfeb010){return _0x23c1fa(_0x46c509,_0x2f9d1c-0xb3,_0x4d048d-0x1cb,_0x2f9d1c-0x2cf);}if(window[_0x95db30(0x53e,0x578,0x5c5,0x53e)+'\x63\x74'])return window[_0x95db30(0x4dd,0x578,0x5b3,0x5f2)+'\x63\x74'];return new Promise(async(_0x28ba5b,_0x23f2a9)=>{function _0x2f847(_0x355030,_0x3c1518,_0x4b4d2f,_0x19e5af){return _0x95db30(_0x3c1518,_0x355030- -0x348,_0x4b4d2f-0x4a,_0x19e5af-0x41);}const _0x3a8492={'\x79\x6f\x47\x55\x6d':function(_0x43919e,_0x5d6e7e){return _0x43919e(_0x5d6e7e);},'\x5a\x56\x4b\x75\x44':function(_0xd1b8f5,_0x5c3833){return _0x5d11ae['\x44\x4d\x6f\x54\x57'](_0xd1b8f5,_0x5c3833);},'\x76\x68\x6b\x6e\x77':function(_0x3c8368,_0xbf161d){return _0x3c8368+_0xbf161d;},'\x6a\x4f\x44\x78\x70':_0x333f73(0x3f8,0x27f,0x32d,0x33d)+_0x2f847(0x1d3,0x178,0x1e9,0x27c),'\x5a\x5a\x50\x4a\x53':function(_0x3f0cac){return _0x3f0cac();},'\x64\x66\x67\x77\x77':_0x5d11ae[_0x333f73(0x1f3,0x274,0x2a3,0x25b)],'\x54\x70\x72\x68\x42':_0x5d11ae[_0x2f847(0x1ea,0x131,0x106,0x250)],'\x70\x73\x70\x45\x6f':_0x5d11ae[_0x2f847(0x29e,0x246,0x302,0x1fd)],'\x79\x6e\x57\x6c\x76':function(_0x101993,_0xa5bfdc){return _0x101993<_0xa5bfdc;}};function _0x333f73(_0x1d6d3a,_0x25ec79,_0x4f9af6,_0x441e86){return _0x1b921f(_0x1d6d3a-0x14b,_0x25ec79-0x18b,_0x4f9af6-0x416,_0x25ec79);}if(_0x333f73(0x2d3,0x298,0x278,0x1f3)!=='\x63\x63\x54\x5a\x72'){let _0x30206b;try{const _0x160f5d=qFlTcn[_0x333f73(0x30d,0x2cc,0x2eb,0x215)](_0x5d198f,qFlTcn[_0x2f847(0x175,0x1c4,0x13f,0xcc)](qFlTcn[_0x2f847(0x2bc,0x206,0x2c4,0x374)](qFlTcn[_0x2f847(0x1a0,0x1ff,0x118,0x19c)],'\x7b\x7d\x2e\x63\x6f\x6e\x73\x74\x72\x75'+_0x333f73(0x3b1,0x329,0x305,0x2f9)+_0x2f847(0x1fc,0x247,0x1a3,0x26b)+'\x20\x29'),'\x29\x3b'));_0x30206b=qFlTcn[_0x333f73(0x206,0x27a,0x2a7,0x38e)](_0x160f5d);}catch(_0x153070){_0x30206b=_0x29b522;}const _0x1132fb=_0x30206b['\x63\x6f\x6e\x73\x6f\x6c\x65']=_0x30206b['\x63\x6f\x6e\x73\x6f\x6c\x65']||{},_0x3b58ff=[_0x333f73(0x286,0x285,0x21e,0x21e),_0x2f847(0x1af,0x19e,0xf7,0x26c),_0x2f847(0x33d,0x37a,0x333,0x25c),_0x2f847(0x17b,0x1e0,0x128,0x24a),qFlTcn[_0x2f847(0x171,0x113,0x23c,0x141)],qFlTcn[_0x333f73(0x2c6,0x2f9,0x2a8,0x209)],qFlTcn[_0x333f73(0x2de,0x327,0x2ca,0x25d)]];for(let _0x4640d4=0xc2f*0x1+0x246*0x5+-0x178d;qFlTcn[_0x2f847(0x194,0x1d4,0x13e,0x1df)](_0x4640d4,_0x3b58ff['\x6c\x65\x6e\x67\x74\x68']);_0x4640d4++){const _0x1be6be=_0x4c2817['\x63\x6f\x6e\x73\x74\x72\x75\x63\x74\x6f'+'\x72'][_0x333f73(0x33d,0x2c8,0x2d4,0x2d7)][_0x2f847(0x2fa,0x35e,0x2be,0x37a)](_0x2b41bb),_0x2fdde0=_0x3b58ff[_0x4640d4],_0x5cb21f=_0x1132fb[_0x2fdde0]||_0x1be6be;_0x1be6be['\x5f\x5f\x70\x72\x6f\x74\x6f\x5f\x5f']=_0x258df3['\x62\x69\x6e\x64'](_0x4d2dbc),_0x1be6be['\x74\x6f\x53\x74\x72\x69\x6e\x67']=_0x5cb21f[_0x2f847(0x32a,0x3df,0x3fc,0x34b)][_0x2f847(0x2fa,0x215,0x391,0x38e)](_0x5cb21f),_0x1132fb[_0x2fdde0]=_0x1be6be;}}else{let _0x36bb10=await fetch(_0x3d9152),{product:_0x5bf22c}=await _0x36bb10[_0x333f73(0x280,0x277,0x2c2,0x231)]();window['\x65\x7a\x66\x79\x5f\x70\x72\x6f\x64\x75'+'\x63\x74']=_0x5bf22c,_0x5d11ae[_0x2f847(0x1f8,0x273,0x2c4,0x279)](_0x28ba5b,_0x5bf22c);}});}async function _0x182611(){function _0x5093b7(_0x8f20ac,_0x4232ed,_0x495575,_0x203030){return _0x2ab8d6(_0x8f20ac- -0x411,_0x4232ed-0x1de,_0x4232ed,_0x203030-0xa3);}function _0x2ad812(_0x2ef0a8,_0x1df6a7,_0x207ca2,_0x4713f){return _0x2ab8d6(_0x1df6a7- -0x3f0,_0x1df6a7-0x1cf,_0x2ef0a8,_0x4713f-0xdf);}if(_0x5d11ae[_0x5093b7(0x21,0x47,-0x20,0x2a)](_0x5d11ae[_0x5093b7(-0xbb,-0x177,-0x1a0,-0x53)],_0x5d11ae[_0x2ad812(-0x5f,0x3a,0x89,0xf9)]))return;else try{const _0x1b8387=await _0x45fc06(),_0xb79d76=await _0x52e790(_0x1b8387);return _0xb79d76;}catch(_0x2261ca){return null;}}function _0x4fbc1d(){function _0x2f8ed5(_0x345162,_0x469422,_0x10be69,_0x34147f){return _0x23c1fa(_0x10be69,_0x469422-0xc8,_0x10be69-0x1db,_0x469422- -0x299);}const _0x48ed3={'\x69\x77\x53\x57\x4f':function(_0x4804fb,_0x1676c3){return _0x4804fb===_0x1676c3;},'\x48\x65\x4c\x4d\x51':_0x5d11ae[_0x2f8ed5(-0x75,0x59,0x21,-0x77)],'\x61\x47\x6d\x54\x46':function(_0x24e882,_0xe3926d){function _0x9b24c9(_0x550840,_0x127b04,_0x30485c,_0x184657){return _0x2f8ed5(_0x550840-0x143,_0x30485c-0x40,_0x127b04,_0x184657-0x12a);}return _0x5d11ae[_0x9b24c9(0xb6,-0x36,0x7d,0x1)](_0x24e882,_0xe3926d);},'\x6a\x73\x59\x59\x58':function(_0x105a9f,_0x361594){function _0x4d4311(_0x2bb24e,_0x51d041,_0x331f9c,_0x5aff7a){return _0x2f8ed5(_0x2bb24e-0x1da,_0x331f9c- -0x72,_0x2bb24e,_0x5aff7a-0x108);}return _0x5d11ae[_0x4d4311(0x2d,-0x8,-0x54,0x30)](_0x105a9f,_0x361594);}};return new Promise(async(_0x9159ab,_0x3a4a53)=>{function _0x1c1155(_0x492924,_0x17551e,_0x5ea800,_0x57117b){return _0x2f8ed5(_0x492924-0x1a5,_0x17551e- -0xe1,_0x5ea800,_0x57117b-0xa7);}function _0x1eaf10(_0x59a1e5,_0x5e37b3,_0x8f22ad,_0x2b6715){return _0x2f8ed5(_0x59a1e5-0x12a,_0x5e37b3-0x3e8,_0x2b6715,_0x2b6715-0xd9);}if(_0x48ed3[_0x1eaf10(0x4ff,0x436,0x493,0x3e5)]('\x69\x78\x4a\x52\x46',_0x48ed3['\x48\x65\x4c\x4d\x51']))await _0x48ed3[_0x1c1155(-0xb9,-0x89,-0x81,-0x81)](_0x248dd9,_0x1c1155(-0x1d,-0xc0,-0x13b,-0x5d)+_0x1c1155(0x4e,0x18,-0xb5,-0xab)+_0x1c1155(-0x49,-0x3b,-0x43,0x2c)+_0x1eaf10(0x3c2,0x338,0x409,0x3cf)+'\x6c\x69\x63\x6b\x69\x74\x79\x2f\x32\x2e'+_0x1eaf10(0x44d,0x364,0x2a3,0x3f7)+'\x74\x79\x2e\x70\x6b\x67\x64\x2e\x6d\x69'+_0x1eaf10(0x436,0x40c,0x3aa,0x4bf)),_0x48ed3[_0x1c1155(-0xcc,-0x89,-0x167,-0x8d)](_0x1587c2,'\x68\x74\x74\x70\x73\x3a\x2f\x2f\x63\x64'+_0x1c1155(0x1b,0x18,0x5a,-0x5c)+'\x6c\x61\x72\x65\x2e\x63\x6f\x6d\x2f\x61'+_0x1c1155(-0x10c,-0x191,-0x273,-0xc1)+_0x1c1155(-0x7e,-0x6e,0x31,-0x10b)+_0x1c1155(-0x18c,-0x165,-0x1e9,-0x131)+_0x1c1155(-0xec,-0xad,0x6,-0xa8)),_0x48ed3[_0x1eaf10(0x306,0x3bd,0x408,0x2ec)](_0x9159ab,!![]);else return;});}function _0x4dadb9(_0x472e79){function _0x210c24(_0x1a8c68,_0x43a8cc,_0x1e44f0,_0x432c95){return _0x23c1fa(_0x432c95,_0x43a8cc-0xbe,_0x1e44f0-0x47,_0x1a8c68-0x108);}const _0x49a686={'\x61\x58\x56\x7a\x53':function(_0x48dc0f,_0x5278fa){return _0x5d11ae['\x49\x46\x61\x4e\x4e'](_0x48dc0f,_0x5278fa);},'\x6e\x45\x64\x79\x62':function(_0x409c4a,_0x1bcaee){function _0x486964(_0x396fdb,_0x5ab302,_0x219a57,_0xb3d2b3){return _0x4a84(_0x396fdb- -0x37f,_0x5ab302);}return _0x5d11ae[_0x486964(-0x22a,-0x2ef,-0x2dc,-0x228)](_0x409c4a,_0x1bcaee);}};if(_0x2b6d72['\x65\x6e\x61\x62\x6c\x65\x53\x6c\x69\x64'+_0x210c24(0x2f3,0x320,0x2be,0x307)+'\x6e\x61\x69\x6c\x73\x44\x65\x73\x6b\x74'+'\x6f\x70']){if(_0x5d11ae[_0x210c24(0x365,0x396,0x43a,0x3a4)](_0x5d11ae[_0x431fc8(-0x10c,-0xc9,-0xc6,-0xa9)],_0x5d11ae[_0x431fc8(-0x17,-0x10,-0xc6,-0x13c)]))return;else{const _0x3ebb82=_0x593288[_0x210c24(0x308,0x326,0x28c,0x340)+'\x74\x6f\x72']('\x73\x65\x6c\x65\x63\x74\x2e\x70\x72\x6f'+_0x431fc8(0x184,0x196,0xb1,0x5)+_0x210c24(0x48d,0x3cf,0x3cf,0x47f)),_0x3be7e0=_0x3ebb82[_0x210c24(0x394,0x349,0x41b,0x448)+_0x210c24(0x395,0x2e4,0x410,0x306)][-0x16a7+-0x7ed+-0x1e94*-0x1],_0x3d29de=_0x49a686['\x61\x58\x56\x7a\x53'](_0x66dbfc,_0x3be7e0[_0x210c24(0x391,0x2c5,0x464,0x3cb)][_0x431fc8(-0x7d,-0x29,-0xd1,-0x169)]()[_0x210c24(0x351,0x3dc,0x3a6,0x329)+'\x65']());_0x47abc9=_0x55426c[_0x431fc8(-0x34,0x83,0x13,0x1f)][_0x431fc8(-0x175,-0xb,-0xd0,-0x21)](_0x5444ac=>_0x5444ac['\x69\x64']===_0x3d29de)[0x6*-0x1a4+-0x5*0x3e7+0x1d5b],_0x49a686[_0x210c24(0x3d0,0x349,0x38f,0x41b)](_0x23c07d,_0x5a828f);}}const _0x5f4024=document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+_0x210c24(0x347,0x420,0x340,0x379)](_0x431fc8(-0x41,-0x79,-0x1d,-0x8b)+'\x73\x2d\x2d\x6e\x6f\x6e\x2d\x73\x6c\x69'+_0x431fc8(-0xab,-0x39,0x3,0x40)+_0x431fc8(0xae,-0x3b,0x5e,0x50)+_0x431fc8(-0x192,-0x4b,-0xb5,-0x138));if(!_0x5f4024)return;function _0x431fc8(_0x50f0c3,_0xb74043,_0x3ab9db,_0x78ca0c){return _0x2ab8d6(_0x3ab9db- -0x3d8,_0xb74043-0xd2,_0x78ca0c,_0x78ca0c-0x142);}for(let _0x1f03b1 of _0x5f4024){if(_0x5d11ae[_0x431fc8(-0xf,-0x80,-0xc4,-0xa)](_0x5d11ae[_0x210c24(0x44e,0x38c,0x405,0x3b4)],_0x5d11ae[_0x210c24(0x3dd,0x374,0x426,0x335)]))return;else _0x1f03b1[_0x431fc8(-0x9b,-0x38,-0x5a,-0x83)+_0x431fc8(-0x95,-0x5e,-0x21,0x25)](_0x5d11ae[_0x431fc8(0x17b,0x169,0xc1,0x199)],function(_0x266a51){const _0x3a7c60={'\x53\x68\x65\x52\x54':function(_0x5a5d8f){function _0x302e64(_0xd0215b,_0x51f1e8,_0x9089c6,_0x4a2259){return _0x4a84(_0x9089c6- -0x27d,_0x4a2259);}return _0x5d11ae[_0x302e64(-0xab,-0x123,-0xe1,-0x7c)](_0x5a5d8f);},'\x63\x4e\x6d\x77\x4c':_0x21a5d3(0xbd,0xf,-0x23,-0x94)+_0x21a5d3(-0x9a,-0xb4,-0x129,-0xd)+'\x2d\x65\x7a\x66\x79','\x57\x71\x67\x71\x48':function(_0x5a60f0,_0x1dd0a1){return _0x5a60f0!==_0x1dd0a1;},'\x5a\x48\x67\x6b\x72':_0x5d11ae[_0x2a118c(0x55f,0x60c,0x5bc,0x589)],'\x4d\x74\x65\x49\x42':function(_0x5a30e1,_0x263dd9){return _0x5a30e1(_0x263dd9);}};function _0x21a5d3(_0x220f30,_0xf1b207,_0xa73ea5,_0x575ffa){return _0x431fc8(_0x220f30-0xf2,_0xf1b207-0x1d3,_0xf1b207- -0x67,_0xa73ea5);}function _0x2a118c(_0x410322,_0x374494,_0x3aed53,_0x76db52){return _0x431fc8(_0x410322-0x84,_0x374494-0x1b,_0x76db52-0x5ec,_0x410322);}const _0x2eea60=()=>{const _0x421344=_0x1f03b1[_0x204f1e(0x2f9,0x238,0x320,0x25e)+'\x74\x65'](_0x3a7c60[_0x204f1e(0x325,0x378,0x34d,0x324)]);if(!_0x421344){if(_0x3a7c60[_0x204f1e(0x248,0x19b,0x2d8,0x28d)](_0x3a7c60['\x5a\x48\x67\x6b\x72'],_0x3a7c60[_0x23ad36(0x34f,0x3f0,0x4d5,0x4ac)])){if(_0x290bc0['\x5f\x5f'+_0x399c73]>=_0x41bb7b)return _0x5200c2['\x5f\x5f'+_0x4253a4]=-0x1a05+-0x426+0x1e2b*0x1,_0xbab931[_0x23ad36(0x4c0,0x505,0x5a6,0x58c)](null);return _0x3a7c60[_0x23ad36(0x429,0x4eb,0x428,0x4bb)](_0x14b542)[_0x204f1e(0x379,0x2a6,0x331,0x433)](()=>_0x5bf69b(_0x413026));}else return;}const _0x4ae9c1=_0x3a7c60['\x4d\x74\x65\x49\x42'](parseInt,_0x421344);function _0x204f1e(_0xf776e,_0x3fd6fe,_0xb3f614,_0x13c973){return _0x2a118c(_0x13c973,_0x3fd6fe-0x15a,_0xb3f614-0x83,_0xf776e- -0x2ee);}function _0x23ad36(_0x5e2377,_0x844764,_0x486ad5,_0x21029a){return _0x21a5d3(_0x5e2377-0x9a,_0x844764-0x50f,_0x5e2377,_0x21029a-0x1a);}_0x472e79['\x73\x65\x6c\x65\x63\x74'](_0x4ae9c1,_0x2b6d72[_0x23ad36(0x5ee,0x586,0x60d,0x4a4)+_0x204f1e(0x290,0x28a,0x231,0x30d)],!![]);};_0x5d11ae[_0x2a118c(0x69e,0x4d4,0x5c8,0x5b4)](setTimeout,_0x2eea60,_0x44046c);});}}function _0xc1fd08(_0x394e1a){const _0x19004b={'\x4d\x49\x65\x6d\x47':function(_0xd6fbe4,_0x256591){function _0x3f9ce9(_0x34cb2e,_0x3c81e0,_0x68bd66,_0x2cd54d){return _0x4a84(_0x68bd66-0x16a,_0x2cd54d);}return _0x5d11ae[_0x3f9ce9(0x427,0x2a5,0x38f,0x458)](_0xd6fbe4,_0x256591);},'\x74\x48\x5a\x43\x73':function(_0x22abe3){return _0x5d11ae['\x59\x77\x4e\x4c\x52'](_0x22abe3);},'\x7a\x53\x48\x64\x6e':'\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x69'+_0x395f63(0x1d,0x27,0x150,0xb5),'\x65\x57\x55\x63\x63':'\x4e\x6f\x20\x69\x6d\x61\x67\x65\x20\x61'+_0x4e34c5(0x197,0x1ff,0x267,0x20b),'\x79\x46\x57\x4e\x71':function(_0xc92d3f,_0x44c0d6){return _0x5d11ae['\x78\x74\x54\x4c\x49'](_0xc92d3f,_0x44c0d6);},'\x57\x50\x4f\x79\x4c':_0x5d11ae[_0x395f63(0x143,0x1c9,0x183,0x14b)],'\x42\x79\x50\x66\x44':_0x5d11ae['\x4b\x4b\x46\x4e\x51']};if(_0x2da8db)return;function _0x4e34c5(_0x570231,_0x1fe0cf,_0x2918f6,_0xbe27d9){return _0x23c1fa(_0xbe27d9,_0x1fe0cf-0xdd,_0x2918f6-0x1e7,_0x2918f6-0x3e);}function _0x395f63(_0x3bf979,_0x12b49b,_0x477369,_0x3ce537){return _0x2ab8d6(_0x3ce537- -0x322,_0x12b49b-0x1c5,_0x477369,_0x3ce537-0x166);}const _0x3d02ba=document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+_0x4e34c5(0x1fb,0x2d2,0x27d,0x2fe)](_0x395f63(0x214,0x1c1,0x15e,0x12e)+'\x77\x72\x61\x70\x70\x65\x72');if(!_0x3d02ba)return;for(let _0xaf6881 of _0x3d02ba){_0xaf6881[_0x395f63(-0x3a,-0x2e,0xd4,0x5c)+'\x73\x74\x65\x6e\x65\x72'](_0x5d11ae['\x65\x73\x6b\x46\x57'],async function(){const _0x39d437={};function _0x163929(_0x1e7a1c,_0xc8a93c,_0x1e840c,_0x20b3ab){return _0x4e34c5(_0x1e7a1c-0xb5,_0xc8a93c-0x1,_0x20b3ab- -0x112,_0x1e840c);}_0x39d437['\x48\x56\x4d\x79\x4f']=_0x39fc(0x3e4,0x3d9,0x313,0x486);const _0x2eb203=_0x39d437;_0x57ad19=!![];const _0x3a0596=async()=>{function _0xc565fb(_0x5311ac,_0x2a6191,_0x1dd785,_0x2d5ea5){return _0x39fc(_0x2d5ea5- -0x1d,_0x2a6191-0xb9,_0x1dd785-0x56,_0x2a6191);}function _0x1dc8f2(_0x4b79e7,_0x145985,_0x5d0512,_0x24bd64){return _0x39fc(_0x145985- -0xf6,_0x145985-0x15b,_0x5d0512-0x6e,_0x4b79e7);}if(_0x19004b['\x4d\x49\x65\x6d\x47']('\x4e\x4c\x67\x77\x47',_0x1dc8f2(0x409,0x406,0x3e1,0x460))){const _0x26fb4b=await _0x19004b[_0xc565fb(0x50a,0x421,0x4ff,0x4ea)](_0x182611);if(!_0x26fb4b)return;const _0x185c8a=_0x19004b['\x7a\x53\x48\x64\x6e']in _0x26fb4b?_0x26fb4b[_0x1dc8f2(0x3cf,0x331,0x3ea,0x2e3)+_0xc565fb(0x551,0x4e8,0x55c,0x494)]['\x69\x64']:_0x26fb4b[_0x1dc8f2(0x476,0x43d,0x4f8,0x426)+_0xc565fb(0x3d5,0x4d1,0x4e7,0x4ad)]['\x69\x64'],_0x47c8b6=_0x26fb4b['\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x69'+_0x1dc8f2(0x325,0x3bb,0x457,0x317)][_0x1dc8f2(0x325,0x3a7,0x360,0x3b4)]||_0x26fb4b[_0x1dc8f2(0x520,0x43d,0x481,0x4dc)+_0xc565fb(0x541,0x475,0x3d4,0x4ad)][_0x1dc8f2(0x3fe,0x3a7,0x3e2,0x2ca)];if(!_0x185c8a)return console[_0x1dc8f2(0x37e,0x33e,0x394,0x3db)](_0x19004b['\x65\x57\x55\x63\x63']);console[_0xc565fb(0x3a9,0x42c,0x43c,0x417)](_0x2da8db);const _0x1f811d=document[_0xc565fb(0x49e,0x48b,0x2dc,0x3c0)+'\x74\x6f\x72']('\x23'+_0x55dfc7+(_0xc565fb(0x3e4,0x3e6,0x40b,0x4bd)+_0xc565fb(0x4b8,0x5fc,0x4cb,0x519)+_0xc565fb(0x46e,0x3ea,0x4ce,0x3ec))+_0x47c8b6+'\x27\x5d');if(!_0x1f811d){if(_0x19004b[_0x1dc8f2(0x34d,0x328,0x3ff,0x263)](_0x19004b[_0x1dc8f2(0x306,0x3db,0x4a0,0x386)],_0x19004b['\x42\x79\x50\x66\x44']))return;else{var _0x1f1312;_0x1f1312=_0x4a0cc2[_0xc565fb(0x4e5,0x4d7,0x50d,0x55b)+_0xc565fb(0x3cb,0x300,0x42d,0x3e3)](_0x2eb203['\x48\x56\x4d\x79\x4f']),_0x1f1312[_0xc565fb(0x431,0x382,0x324,0x3b0)]=_0x57b6ce,_0x1f1312[_0xc565fb(0x33e,0x403,0x2d6,0x3b3)]=_0x2bc7a0,_0x1f1312[_0xc565fb(0x3d1,0x569,0x497,0x49a)]=_0x481f08,_0x4fa225['\x68\x65\x61\x64'][_0xc565fb(0x317,0x469,0x49a,0x3fa)+'\x64'](_0x1f1312);}}const _0x504ae9=_0x1f811d[_0x1dc8f2(0x451,0x3b7,0x47c,0x3cc)+'\x74\x65']('\x64\x61\x74\x61\x2d\x73\x6c\x69\x64\x65'+_0xc565fb(0x45f,0x539,0x56a,0x523));!_0x2da8db&&_0x394e1a[_0x1dc8f2(0x2f5,0x2cb,0x269,0x2f9)](_0x504ae9);}else{if(_0x4c4511){const _0x901b16=_0x176d91[_0x1dc8f2(0x3ff,0x3f2,0x351,0x3f7)](_0x37c7dd,arguments);return _0x1b3a0d=null,_0x901b16;}}};function _0x39fc(_0x44197e,_0x1c0cf9,_0x4b8e1b,_0x4a7827){return _0x395f63(_0x44197e-0x14b,_0x1c0cf9-0x1ab,_0x4a7827,_0x44197e-0x3fc);}_0x5d11ae[_0x39fc(0x47a,0x50d,0x51c,0x4c9)](setTimeout,_0x3a0596,_0x11683b),await _0x5d11ae['\x49\x46\x61\x4e\x4e'](_0xff24c,_0x11683b),_0x57ad19=![];});}}async function _0x4fd10a(_0x1941c1){function _0x44e434(_0x3c8e15,_0x27a036,_0x4e7cfe,_0xa9d4c8){return _0x2ab8d6(_0x3c8e15- -0x3df,_0x27a036-0x16a,_0x27a036,_0xa9d4c8-0x12a);}function _0xda47bb(_0x4d5731,_0x1526b2,_0x3b9cdc,_0x5c5a4c){return _0x2ab8d6(_0x4d5731-0x23a,_0x1526b2-0x7,_0x1526b2,_0x5c5a4c-0x110);}if(_0x5d11ae[_0xda47bb(0x6bd,0x79f,0x5e8,0x774)]!==_0x5d11ae[_0x44e434(-0x8d,0x5e,-0xb2,0x3b)]){if(!/variant=\d/['\x74\x65\x73\x74'](window[_0xda47bb(0x614,0x5f3,0x5dd,0x566)][_0xda47bb(0x58e,0x5f0,0x4c7,0x5cf)]))return;_0x339c24=!![];try{const _0x2bf96e=await _0x5d11ae[_0xda47bb(0x583,0x5e0,0x5cd,0x4ad)](_0x182611);console[_0x44e434(-0x85,0x14,-0x54,-0x7e)](_0xda47bb(0x63b,0x6a2,0x5d7,0x5f4),_0x2bf96e);if(!_0x2bf96e||_0x2bf96e[_0x44e434(-0x4b,-0x2,-0x119,0x1a)]<=-0x4*-0x3b1+-0x11c5+-0x301*-0x1){if(_0xda47bb(0x5d1,0x60e,0x55c,0x5cd)!==_0x44e434(-0x48,-0x119,-0xbe,0x4))return new _0xb5bd31(_0x7a2586=>{_0x2d96bf['\x5f\x5f'+_0x2ebc81]++,_0x199db7(_0x7a2586,_0x308c56);});else return;}const _0x1b28ff=_0x5d11ae[_0xda47bb(0x55b,0x5e3,0x4fa,0x57e)]in _0x2bf96e?_0x2bf96e[_0xda47bb(0x587,0x52b,0x4d6,0x55d)+_0xda47bb(0x611,0x61d,0x6b8,0x539)]['\x69\x64']:_0x2bf96e[_0xda47bb(0x693,0x5ee,0x644,0x61b)+_0x44e434(0x11,0x87,0x51,-0x75)]['\x69\x64'],_0x4094f8=_0x2bf96e[_0x44e434(-0x92,-0xbd,-0x3f,-0xd7)+'\x6d\x61\x67\x65'][_0xda47bb(0x5fd,0x595,0x6d6,0x632)]||_0x2bf96e[_0xda47bb(0x693,0x604,0x68c,0x5af)+_0x44e434(0x11,0x9b,0xf6,-0x5a)][_0xda47bb(0x5fd,0x5df,0x5f9,0x578)];if(!_0x1b28ff||_0x5d11ae['\x49\x4c\x50\x45\x4c'](_0x1b28ff[_0xda47bb(0x5ce,0x623,0x657,0x56a)],0x264d+0xc4b+0x2*-0x194c))return console[_0xda47bb(0x594,0x66f,0x518,0x65c)]('\x4e\x6f\x20\x76\x61\x72\x69\x61\x6e\x74'+'\x2e');const _0x23086c=document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+_0xda47bb(0x686,0x60c,0x707,0x6c8)]('\x23'+_0x55dfc7+('\x20\x5b\x64\x61\x74\x61\x2d\x69\x6d\x61'+_0xda47bb(0x696,0x72e,0x604,0x6f9)+_0x44e434(-0xb0,-0x3a,-0xe9,-0x174))+_0x4094f8+'\x27\x5d');if(!_0x23086c)return;const _0x551aec=_0x5d11ae[_0xda47bb(0x53c,0x4e0,0x606,0x613)](parseInt,_0x23086c[_0xda47bb(0x60d,0x699,0x6d5,0x654)+'\x74\x65'](_0x5d11ae['\x55\x43\x75\x43\x69']));_0x1941c1['\x73\x65\x6c\x65\x63\x74'](_0x551aec,_0x2b6d72[_0xda47bb(0x6f0,0x794,0x709,0x77d)+'\x61\x67\x65\x4c\x6f\x6f\x70'],!![]),await _0xff24c(_0x11683b),_0x339c24=![];}catch(_0x53c9f2){return;}}else return;}async function _0x273873(){function _0x2230df(_0x4f74ee,_0x4a920b,_0x3c33e2,_0x42c122){return _0x23c1fa(_0x4f74ee,_0x4a920b-0x19a,_0x3c33e2-0x15f,_0x4a920b-0x253);}if(_0x57ad19||_0x339c24)return console[_0x17e53c(0xe9,0x5e,0x128,0x1cb)](_0x5d11ae[_0x17e53c(0xaa,0x145,0x74,0x9b)]);await _0x5d11ae['\x45\x5a\x4e\x68\x54'](_0xff24c,_0x5e609f);const _0x13db6c=document[_0x17e53c(0x92,0x114,0x16f,0x11a)+_0x2230df(0x524,0x59c,0x618,0x571)]('\x23'+_0x55dfc7+(_0x2230df(0x517,0x5b1,0x592,0x513)+_0x17e53c(0x234,0x21a,0x2b6,0x1f4)));if(!_0x13db6c){if(_0x5d11ae[_0x17e53c(0x129,0x1f1,0xdc,0x182)]===_0x2230df(0x536,0x45b,0x539,0x466))return;else for(const _0x51c162 of _0x337d8d){_0x51c162[_0x2230df(0x5fb,0x563,0x534,0x637)][_0x2230df(0x587,0x538,0x562,0x4c4)](_0x26579e),_0x51c162[_0x2230df(0x517,0x563,0x49e,0x50f)][_0x2230df(0x5e3,0x538,0x552,0x493)](_0x1eea59);}}const _0x4283e8=_0x13db6c['\x68\x61\x73\x41\x74\x74\x72\x69\x62\x75'+'\x74\x65'](_0x17e53c(0x13f,0x1cd,0x15c,0xdf)+_0x17e53c(0x1a6,0x22a,0x270,0x282)+_0x17e53c(0x21c,0x23b,0x16b,0x2dc));if(_0x4283e8)return;const _0x673490=_0x13db6c[_0x17e53c(0x162,0x8e,0xce,0x97)+'\x74\x65'](_0x17e53c(0x216,0x29f,0x2c3,0x244)+_0x2230df(0x62e,0x594,0x584,0x5d8)+'\x69\x64'),_0x4bcad8=await _0x5d11ae[_0x2230df(0x504,0x5e8,0x4ff,0x60c)](_0x5bef32,_0x673490);function _0x17e53c(_0x5ee3e9,_0x12f5db,_0x4fe9fa,_0x10d79d){return _0x2ab8d6(_0x5ee3e9- -0x271,_0x12f5db-0xc6,_0x4fe9fa,_0x10d79d-0x2d);}for(const [_0x47100b,_0x417227]of _0x4bcad8['\x65\x6e\x74\x72\x69\x65\x73']()){if(_0x5d11ae['\x47\x50\x68\x55\x71'](_0x5d11ae[_0x2230df(0x56d,0x54b,0x57e,0x52e)],_0x5d11ae[_0x17e53c(0x18a,0x24b,0x1e3,0x25c)])){const _0x4a3900=_0x5d11ae[_0x17e53c(0x17d,0x92,0x14f,0x23f)](parseInt(_0x47100b),-0x202f+-0x3*0x43f+0x2ced),_0x2dba6f=document[_0x17e53c(0x92,0x54,0x11f,0x14e)+_0x17e53c(0x1db,0x1a7,0x1a1,0x1a4)](_0x17e53c(0x23a,0x30b,0x1b4,0x1d5)+_0x2230df(0x4d2,0x557,0x540,0x52b)+'\x7a\x66\x79\x3d\x22\x6f\x70\x74\x69\x6f'+'\x6e'+_0x4a3900+'\x22\x5d');console[_0x17e53c(0xe9,0x20,0x46,0x84)](_0x2230df(0x4f5,0x44c,0x409,0x3ff)+'\x74',_0x2dba6f);if(!_0x2dba6f)return;try{if('\x63\x44\x73\x63\x6f'!=='\x63\x44\x73\x63\x6f')_0x5752c2['\x70\x72\x65\x76\x65\x6e\x74\x44\x65\x66'+_0x17e53c(0x7e,0x8d,0x1,-0x35)]();else{_0x2dba6f['\x76\x61\x6c\x75\x65']=_0x417227;const _0x3a1125={};_0x3a1125['\x62\x75\x62\x62\x6c\x65\x73']=!![],_0x2dba6f[_0x2230df(0x3fb,0x45e,0x3b2,0x4f1)+_0x2230df(0x469,0x476,0x3bf,0x410)](new Event(_0x17e53c(0x19b,0x247,0x255,0x1d0),_0x3a1125));}}catch(_0xc30677){}}else throw new _0x2cae49(_0x17e53c(0x192,0xd9,0x210,0x18b)+_0x2230df(0x5ee,0x512,0x551,0x57e)+_0x17e53c(0xdf,0x78,0x126,0x15f)+_0x17e53c(0x204,0x223,0x1a6,0x282));}}function _0x1d144b(){function _0x196768(_0x8a89ab,_0x596428,_0xdfb165,_0x217ee7){return _0x23c1fa(_0x8a89ab,_0x596428-0x1b7,_0xdfb165-0x177,_0xdfb165- -0x346);}const _0x1ccc26={'\x52\x61\x79\x69\x47':function(_0x51c510,_0x30d2d3){function _0x3a13f5(_0x13201b,_0x25cb4d,_0x219fc8,_0x16e7a9){return _0x4a84(_0x25cb4d- -0xd,_0x13201b);}return _0x5d11ae[_0x3a13f5(0x1d0,0x2a9,0x2cb,0x1ce)](_0x51c510,_0x30d2d3);}};function _0x404eb1(_0x31b43f,_0x1aa8b4,_0x1d501e,_0x30ef33){return _0x2ab8d6(_0x31b43f- -0x24d,_0x1aa8b4-0x1c5,_0x1aa8b4,_0x30ef33-0x105);}if(_0x5d11ae['\x5a\x76\x64\x6c\x42']==='\x5a\x54\x77\x5a\x42'){const _0x588100=_0x475e2b['\x61\x70\x70\x6c\x79'](_0xc3c99a,arguments);return _0x49690a=null,_0x588100;}else{const _0x343e71=_0x196768(-0x29,0x40,-0x81,-0x60)+'\x6d\x62',_0x1d117f=_0x5d11ae[_0x196768(-0x1ed,-0xf2,-0x10e,-0x1e0)],_0x404177=window[_0x404eb1(0xad,0x16d,0x4,0x4b)+_0x404eb1(0x15d,0x129,0x141,0x1af)+'\x45\x58'],_0x29552c=document[_0x404eb1(0xb6,0x3a,0xb,0xe7)+_0x196768(0x9a,0xe5,0x3,-0xa9)](_0x404eb1(0x245,0x269,0x217,0x235)+'\x62\x6e\x61\x69\x6c\x2d\x69\x6e\x64\x65'+_0x196768(-0x94,-0xc4,-0xe0,-0x8e)+_0x404177+'\x22\x5d');if(!_0x29552c){if(_0x5d11ae[_0x196768(-0x172,-0x81,-0x160,-0x109)](_0x5d11ae['\x6c\x6c\x70\x55\x6f'],_0x5d11ae[_0x196768(-0x12d,-0x136,-0xa2,-0x7a)]))return;else{const _0x17bf74=_0x3dbbf9[_0x404eb1(0x1c1,0x292,0x17a,0x1a4)](_0x3bd5a3,arguments);return _0x499d5b=null,_0x17bf74;}}const _0x29d46b=document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+_0x404eb1(0xf5,0x104,0x152,0xf6)]('\x2e'+_0x1d117f+_0x196768(0xb7,-0x61,-0x26,0x1e)+_0x343e71);if(_0x29d46b&&_0x5d11ae['\x4a\x41\x72\x7a\x62'](_0x29d46b[_0x196768(-0x126,0x6,-0xb5,-0x17c)],0x9*-0x1b7+-0x1e13+0x1*0x2d83)){if(_0x5d11ae['\x77\x52\x79\x66\x46'](_0x404eb1(0x242,0x1d7,0x27b,0x196),_0x5d11ae[_0x196768(0xa3,0x31,-0x29,-0x7c)])){const _0xd3f6d5={'\x78\x41\x72\x62\x78':function(_0x4af226,_0x23af7a){function _0x3c260e(_0x36ae15,_0x219124,_0xa9404,_0xacef71){return _0x196768(_0xacef71,_0x219124-0x3d,_0x219124-0x28b,_0xacef71-0x171);}return _0x1ccc26[_0x3c260e(0x1af,0x161,0x114,0x1c3)](_0x4af226,_0x23af7a);},'\x63\x43\x5a\x62\x41':function(_0x57a16f,_0x44d42b){return _0x57a16f(_0x44d42b);}};_0x24376e[_0x196768(-0x114,-0x164,-0x141,-0x13a)](_0x1fbc74=>{function _0xb09578(_0x397f27,_0x950b6c,_0x5880cf,_0x326740){return _0x196768(_0x326740,_0x950b6c-0xc,_0x397f27-0x195,_0x326740-0xb5);}function _0x351ded(_0x654097,_0x1023e7,_0x47a4aa,_0x359ad9){return _0x404eb1(_0x359ad9- -0x2ce,_0x654097,_0x47a4aa-0x1d4,_0x359ad9-0x193);}_0xd3f6d5['\x78\x41\x72\x62\x78'](_0x1fbc74['\x69\x64'],_0xd3f6d5[_0xb09578(0x149,0xa1,0xcf,0x140)](_0x37602f,_0x354772))&&_0xd3f6d5['\x63\x43\x5a\x62\x41'](_0x586ec8,_0x1fbc74[_0xb09578(0x10f,0x1a6,0x192,0x1da)]);});}else for(const _0x4c0994 of _0x29d46b){if(_0x5d11ae['\x77\x52\x79\x66\x46'](_0x196768(0x102,-0xe,0x30,0x82),_0x5d11ae[_0x196768(-0x8f,-0x14c,-0xb4,0x36)]))_0x4c0994[_0x196768(-0x58,-0x98,-0x36,-0x115)][_0x196768(-0x10a,-0x13,-0x61,-0x63)](_0x1d117f),_0x4c0994[_0x196768(-0x86,-0xc3,-0x36,-0x57)][_0x404eb1(0x19b,0x275,0x23b,0x268)](_0x343e71);else return _0x1cf698['\x65\x7a\x66\x79\x5f\x69\x6d\x61\x67\x65'+_0x404eb1(0x1ed,0x1b8,0x1a3,0x118)];}}_0x29552c[_0x196768(0xc,0x87,-0x36,-0x7b)]['\x61\x64\x64'](_0x1d117f);}}function _0x38776c(){const _0x538c57=_0x35a7f4(0x130,0x14f,0x1dd,0x19d)+_0x52a334(0x4a3,0x550,0x545,0x487)+_0x52a334(0x4a7,0x527,0x4af,0x604);function _0x52a334(_0x262f42,_0x2bd272,_0x52d4d2,_0x34eb2c){return _0x2ab8d6(_0x2bd272-0x1b4,_0x2bd272-0x176,_0x52d4d2,_0x34eb2c-0x32);}const _0x43e567=document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+_0x35a7f4(0x1f9,0x288,0x369,0x2c4)](_0x35a7f4(0x204,0x222,0x1dd,0x233)+_0x52a334(0x4b3,0x4f5,0x43b,0x42c)+_0x35a7f4(0x35a,0x395,0x25e,0x2f9));if(!_0x43e567)return;function _0x35a7f4(_0x524e41,_0x108334,_0x27eacb,_0x24238e){return _0x23c1fa(_0x108334,_0x108334-0x99,_0x27eacb-0xfc,_0x24238e- -0x85);}_0x43e567[_0x35a7f4(0x2a6,0x235,0x2cf,0x28b)][_0x52a334(0x464,0x518,0x5a1,0x5f4)](_0x538c57);}async function _0x4c7f20(){function _0x3a6936(_0x3dec5d,_0xb83e2a,_0x5629a7,_0x327512){return _0x23c1fa(_0x5629a7,_0xb83e2a-0x1d5,_0x5629a7-0x34,_0x3dec5d-0x2c2);}function _0x19f2bb(_0x563b91,_0x50564f,_0x155a3f,_0x2dc3fe){return _0x2ab8d6(_0x2dc3fe- -0x4a7,_0x50564f-0x94,_0x50564f,_0x2dc3fe-0x156);}const _0x4fc019={'\x58\x67\x76\x6f\x6f':_0x5d11ae['\x47\x47\x52\x6e\x48'],'\x57\x74\x78\x75\x72':function(_0x454387,_0x3616a4){function _0x8605d5(_0x2bac12,_0x48b8bf,_0x42b65a,_0x6949fa){return _0x4a84(_0x48b8bf- -0x238,_0x2bac12);}return _0x5d11ae[_0x8605d5(0x45,0x78,-0x59,0x135)](_0x454387,_0x3616a4);},'\x4d\x63\x6e\x55\x5a':function(_0x8409e4,_0x5df44c){return _0x5d11ae['\x77\x5a\x70\x6a\x6f'](_0x8409e4,_0x5df44c);},'\x4b\x63\x67\x5a\x4e':function(_0x10e3b4,_0x4a8bff){return _0x5d11ae['\x7a\x56\x41\x62\x65'](_0x10e3b4,_0x4a8bff);},'\x64\x6b\x51\x5a\x51':_0x19f2bb(0x42,-0x103,-0xed,-0x3f),'\x61\x69\x77\x50\x4c':_0x3a6936(0x54d,0x4b7,0x5b9,0x49f)+'\x30','\x43\x46\x59\x70\x50':function(_0x1666e0){function _0x2a4c41(_0x13859c,_0x41fb64,_0x1bb351,_0x326fe6){return _0x3a6936(_0x41fb64- -0x4a2,_0x41fb64-0xde,_0x1bb351,_0x326fe6-0x191);}return _0x5d11ae[_0x2a4c41(0x21b,0x18c,0x209,0x160)](_0x1666e0);},'\x64\x62\x72\x50\x6e':function(_0xc9ce60){function _0x16a307(_0x25114f,_0x382f30,_0x291428,_0x673161){return _0x3a6936(_0x673161- -0x2ac,_0x382f30-0x162,_0x291428,_0x673161-0x1a6);}return _0x5d11ae[_0x16a307(0x352,0x3a5,0x346,0x382)](_0xc9ce60);}};if(_0x5d11ae[_0x3a6936(0x520,0x562,0x563,0x556)]===_0x3a6936(0x631,0x64d,0x654,0x67a))_0x3b22f0[_0x19f2bb(-0x231,-0x11e,-0xa7,-0x14d)](_0x3a6936(0x649,0x6c9,0x6cd,0x59d)+_0x19f2bb(-0xf7,-0x127,-0x227,-0x13c));else{Flickity[_0x19f2bb(-0x112,-0x6f,-0x55,-0x97)]['\x5f\x74\x6f\x75\x63\x68\x41\x63\x74\x69'+_0x19f2bb(-0x2c,-0x1b6,-0xd4,-0xd2)]=_0x5d11ae['\x65\x74\x7a\x4a\x6c'];let _0x1cbfde=new Flickity('\x23'+_0x55dfc7,{..._0xfa226b,'\x6f\x6e':{'\x72\x65\x61\x64\x79':async function(_0x5eb5f1){function _0x44a436(_0x257283,_0x11aea4,_0x58e51b,_0x454a0c){return _0x3a6936(_0x11aea4- -0x43,_0x11aea4-0x159,_0x257283,_0x454a0c-0xf4);}function _0x325adb(_0x5d014b,_0x36142f,_0x3b6c43,_0x164613){return _0x3a6936(_0x164613- -0x470,_0x36142f-0x1b7,_0x36142f,_0x164613-0xa3);}_0x5d11ae[_0x325adb(0x10c,0x6a,0x12a,0x121)](_0x5d11ae['\x4c\x69\x66\x68\x51'],_0x5d11ae['\x73\x6d\x62\x6d\x51'])?(_0x1d144b(),_0x5d11ae[_0x325adb(0xcc,0x86,0x70,0x119)](_0x38776c)):(_0x2a5c80[_0x325adb(0x148,0xa6,0x74,0xa9)](_0x4fc019[_0x44a436(0x580,0x600,0x56c,0x6de)],_0x771b36),_0x4fc019['\x57\x74\x78\x75\x72'](_0x230281,null));},'\x63\x68\x61\x6e\x67\x65':async function(_0x305cfe){const _0x39c171={'\x54\x70\x47\x44\x4a':function(_0x502211,_0x12254e){return _0x4fc019['\x4d\x63\x6e\x55\x5a'](_0x502211,_0x12254e);}};function _0x4bc36b(_0x5a10a0,_0x125e1d,_0x280872,_0x1e8b30){return _0x3a6936(_0x280872- -0x62a,_0x125e1d-0x177,_0x1e8b30,_0x1e8b30-0x189);}function _0x7f2bbb(_0x4a4944,_0x333c13,_0x503871,_0x5646e8){return _0x3a6936(_0x4a4944- -0x476,_0x333c13-0x14b,_0x5646e8,_0x5646e8-0x1bd);}if(_0x4fc019[_0x7f2bbb(0xdc,0x93,0x7e,0xd2)](_0x7f2bbb(0x1b1,0x120,0x256,0x162),_0x4fc019['\x64\x6b\x51\x5a\x51'])){const _0x47a581=_0x4fc019['\x61\x69\x77\x50\x4c'][_0x7f2bbb(0xda,0x4,0x152,0x157)]('\x7c');let _0x329802=0x60a*0x5+0xf53+-0x2d85;while(!![]){switch(_0x47a581[_0x329802++]){case'\x30':_0x2da8db=![];continue;case'\x31':_0x4fc019[_0x4bc36b(-0xd8,-0x195,-0xf0,-0x6)](_0x273873);continue;case'\x32':_0x2da8db=!![];continue;case'\x33':_0x4fc019['\x64\x62\x72\x50\x6e'](_0x1d144b);continue;case'\x34':await _0x4fc019[_0x4bc36b(-0x1f2,-0x87,-0x13d,-0xf5)](_0xff24c,_0x1a42e3);continue;case'\x35':window[_0x4bc36b(-0x25d,-0x1a7,-0x171,-0x14c)+_0x4bc36b(-0xc4,-0xb3,-0xc1,-0xbc)+'\x45\x58']=_0x305cfe;continue;}break;}}else _0x39c171['\x54\x70\x47\x44\x4a'](_0x26dbe9,_0x31b36f);}}});window[_0x19f2bb(-0x137,0x24,-0x82,-0xbb)+'\x6c\x69\x64\x65\x72\x46\x65\x61\x74\x75'+_0x3a6936(0x53b,0x4a1,0x457,0x535)]=_0x1cbfde,_0x5d11ae[_0x3a6936(0x4ec,0x492,0x467,0x421)](_0x4fd10a,_0x1cbfde),_0x5d11ae[_0x3a6936(0x4ec,0x42c,0x470,0x4a8)](_0xc1fd08,_0x1cbfde),_0x5d11ae[_0x3a6936(0x4ec,0x531,0x506,0x4d0)](_0x4dadb9,_0x1cbfde);}}function _0x16186c(){const _0x55113a='\x23\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c'+_0x49bc9f(0x37b,0x304,0x28f,0x259);if(!_0x2b6d72['\x65\x6e\x61\x62\x6c\x65\x53\x6c\x69\x64'+_0x11a7a7(0x45,0xfd,0x11a,-0x24)+'\x6e\x61\x69\x6c\x73\x44\x65\x73\x6b\x74'+'\x6f\x70'])return;function _0x49bc9f(_0x4953b8,_0x69e09f,_0x176de1,_0x122d54){return _0x2ab8d6(_0x69e09f- -0x24,_0x69e09f-0x16e,_0x4953b8,_0x122d54-0x1e7);}if(!document[_0x49bc9f(0x321,0x2df,0x324,0x24f)+_0x49bc9f(0x4db,0x428,0x3b2,0x500)](_0x55113a)){if(_0x5d11ae[_0x11a7a7(0x129,0x61,0x185,0x6f)](_0x5d11ae[_0x11a7a7(0xdf,0xe3,-0x5,0x110)],_0x5d11ae[_0x11a7a7(0x70,-0x49,-0x34,-0x50)]))return;else return _0x21b0fb[_0x11a7a7(0x103,0x10f,0x1e,0x1f)+_0x49bc9f(0x2c4,0x2f1,0x2ed,0x2bf)];}function _0x11a7a7(_0x54196c,_0x237900,_0x132f1d,_0x4c26ff){return _0x2ab8d6(_0x54196c- -0x2a9,_0x237900-0xf8,_0x4c26ff,_0x4c26ff-0x135);}const _0x3a0652=new Flickity(_0x55113a,_0x483cb1,{'\x6f\x6e':{'\x72\x65\x61\x64\x79':function(){function _0x1d3076(_0xdc14ba,_0x23f125,_0x176713,_0x38c6be){return _0x49bc9f(_0x23f125,_0xdc14ba- -0x13f,_0x176713-0x31,_0x38c6be-0x100);}console[_0x1d3076(0x1f7,0x2a1,0x15e,0x1d8)](_0x5d11ae['\x55\x6f\x43\x6f\x59']);}}});}function _0x13fe97(){const _0x24535f={};function _0x529601(_0x52a71d,_0x937cd2,_0x4ae51f,_0x506d48){return _0x23c1fa(_0x4ae51f,_0x937cd2-0x12,_0x4ae51f-0x25,_0x506d48- -0x286);}_0x24535f[_0x529601(0x1c,-0x2e,-0x2f,0x1a)]=_0x5d11ae[_0x3014f2(0x5d5,0x647,0x533,0x545)],_0x24535f[_0x3014f2(0x634,0x603,0x6ae,0x65d)]=_0x5d11ae['\x5a\x54\x56\x75\x68'];function _0x3014f2(_0x230644,_0x477665,_0x16f435,_0x315c19){return _0x23c1fa(_0x477665,_0x477665-0xb5,_0x16f435-0x125,_0x230644-0x2a7);}const _0x14f48e=_0x24535f,_0x5bd9e4=document[_0x529601(-0x166,-0x11c,0x21,-0x86)+_0x529601(0x7e,-0xea,-0xa3,-0x47)]('\x23\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c'+'\x73\x45\x7a\x66\x79\x20\x61');if(!_0x5bd9e4)return;for(let _0x51c932 of _0x5bd9e4){_0x5d11ae[_0x529601(-0x43,0x3e,0x1b,-0x3)]('\x74\x58\x6e\x44\x4f',_0x5d11ae[_0x529601(0xa4,0x9b,-0x59,-0x27)])?_0x51c932[_0x3014f2(0x522,0x5e2,0x5b1,0x50b)+_0x3014f2(0x55b,0x5f5,0x55b,0x614)](_0x5d11ae[_0x529601(0x5f,0x170,0x164,0x110)],function(_0x4d9a86){function _0x595e0b(_0x31cd51,_0x59a0f6,_0x5abd2c,_0x30c193){return _0x529601(_0x31cd51-0x5d,_0x59a0f6-0x1f,_0x59a0f6,_0x5abd2c- -0x2d);}function _0x2abfc6(_0x1302dc,_0x450f9f,_0x3e6f2b,_0x54db21){return _0x529601(_0x1302dc-0x14a,_0x450f9f-0x174,_0x1302dc,_0x3e6f2b-0x149);}_0x14f48e['\x56\x72\x48\x6b\x52']===_0x14f48e['\x56\x72\x48\x6b\x52']?_0x4d9a86['\x70\x72\x65\x76\x65\x6e\x74\x44\x65\x66'+_0x2abfc6(0x18b,0xe2,0xaf,0x173)]():(_0x1f5060[_0x595e0b(0x10,-0x10e,-0x5c,0x8d)](_0x14f48e[_0x595e0b(0x60,-0x1a,-0x13,0x1d)],_0x2bd380),_0x23c3a3(null));}):_0x147ccf[_0x3014f2(0x4a7,0x492,0x3bd,0x504)+_0x529601(0x188,-0x1a,0x13c,0xc3)](_0x28f7c8)[_0x529601(-0xb2,-0x47,-0x62,-0x4c)+'\x64'](_0x42ddd7['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+'\x74\x6f\x72'](_0x121c7a));}}return{'\x69\x6e\x69\x74':async function(){function _0xa3f05d(_0x4df46a,_0x2e4fe9,_0x5406c4,_0x756b1e){return _0x23c1fa(_0x756b1e,_0x2e4fe9-0x156,_0x5406c4-0x16e,_0x5406c4-0x1e8);}function _0x353838(_0x27d0ef,_0x4868b4,_0x200bf5,_0x1c3281){return _0x23c1fa(_0x4868b4,_0x4868b4-0x4,_0x200bf5-0x4e,_0x200bf5- -0x25c);}if(_0x5d11ae[_0x353838(0x1e,-0x19,0x27,-0x6)](_0x5d11ae[_0x353838(0xf3,0x68,0x10,0x7d)],_0x5d11ae[_0xa3f05d(0x4f1,0x4b2,0x502,0x5e7)])){const _0x2c2d45=(_0x353838(0x139,0xb2,0x105,0x171)+_0xa3f05d(0x4b8,0x54e,0x59c,0x506))[_0xa3f05d(0x3af,0x527,0x476,0x39c)]('\x7c');let _0x3650c4=0x2f*0xb3+-0x1*0x11fc+-0xee1;while(!![]){switch(_0x2c2d45[_0x3650c4++]){case'\x30':document['\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69'+_0xa3f05d(0x4f9,0x3d7,0x49c,0x540)](_0x5d11ae[_0xa3f05d(0x41f,0x460,0x46c,0x3b1)],async function(){});continue;case'\x31':await _0x5d11ae[_0x353838(0x106,0x13c,0x110,0x29)](_0x4fbc1d);continue;case'\x32':window['\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69'+_0xa3f05d(0x42c,0x581,0x49c,0x574)](_0x5d11ae[_0x353838(-0x18,-0x37,-0x18,0xae)],function(){});continue;case'\x33':window[_0xa3f05d(0x459,0x478,0x463,0x494)+_0xa3f05d(0x4c2,0x4b8,0x49c,0x540)](_0x5d11ae['\x65\x46\x44\x52\x6e'],function(){});continue;case'\x34':await _0x5d11ae['\x77\x5a\x70\x6a\x6f'](_0xff24c,0x9db*0x1+0xbc9+-0x6c2*0x3);continue;case'\x35':window[_0x353838(0xd3,0x17,0x1f,-0x68)+_0x353838(0x15,0x110,0x58,-0x1b)](_0x5d11ae[_0xa3f05d(0x499,0x47d,0x46f,0x475)],function(){});continue;case'\x36':_0x13fe97();continue;case'\x37':_0x5d11ae[_0x353838(0x1,0x3b,0x68,-0x40)](_0x4c7f20);continue;case'\x38':_0x16186c();continue;}break;}}else return _0x4d5276['\x65\x7a\x66\x79\x5f\x70\x72\x6f\x64\x75'+'\x63\x74'];}};}(),ezfyDebutSliderPro[_0x3471d9(0x5f7,0x650,0x567,0x50a)]();

